export const pl = {
    addDatabase: {
        addDatabase: "Dodaj bazÄ danych",
        addFromFile: "Dodaj z pliku",
        analyse: "Analyse",
        analysingYourData: "Analysing your data",
        createFromExcel: "Create from Excel",
        databaseImport: "Database import",
        databaseNotImported: "Import has finished with errors",
        databasePrepared: "Database successfully prepared",
        excelFile: "Excel file",
        fileInformation: "File information",
        fixErrors: "To continue please fix following errors and retry",
        importingYourData: "Importing your data",
        productFilesPath: "Product files path",
        productImagesPath: "Product images path"
    },
    availablePrice: {
        allPackage: "Wszystkie pakiety",
        onePackage: "One package",
        priceType: "Typ ceny",
        setPriceVatVisibility: "Ustaw widocznoÅÄ podatku VAT ",
        setVisibilityAndOrder: "Ustaw widocznoÅÄ i kolejnoÅÄ rodzajÃ³w cen ",
        withAndWithoutVat: "Z podatkiem VAT i bez",
        withVat: "Tylko z podatkiem VAT",
        withoutVat: "Tylko bez podatku VAT"
    },
    barvis: {
        base: "Nazwa bazy",
        bigCanSize: "DuÅ¼a puszka",
        coating: "PowÅoka",
        identifier: "Identyfikator",
        laboratory: "Laboratorium",
        orderOverview: "PodglÄd zamÃ³wienia",
        rank: "Ranga",
        smallCanSize: "MaÅa puszka"
    },
    basicSetup: {
        alreadyLoggedIn: "JesteÅ juÅ¼ zalogowany(a) jako %{login}.",
        askSupplier: "PoproÅ dostawcÄ oprogramowania o przypisanie Ci wiÄkszej liczby licencji.",
        asterisk: "Pozycje oznaczone gwiazdkÄ muszÄ zostaÄ wypeÅnione.",
        identificationKeys: "Identification keys",
        importCustomData:
            "JeÅli to konieczne, zaimportuj dane niestandardowe z poprzedniego oprogramowania dozujÄcego.",
        learnIdentification: "PoproÅ dostawcÄ oprogramowania o klucze identyfikacyjne.",
        login: "PoniÅ¼sze kroki konfiguracji poczÄtkowej wymagajÄ uprawnieÅ administratora.",
        noDatabase: "Å»adna baza danych nie zostaÅa jeszcze dodana, przynajmniej jedna musi zostaÄ wstawiona.",
        offlineLicensing: "Offline licensing",
        productSelection: "Product selection",
        registrationForm: "Registration form",
        seeQuestionMark: "Zobacz maÅe znaki zapytania, aby dowiedzieÄ siÄ wiÄcej o ustawieniu.",
        selectDefaultPrinter: "Wybierz drukarkÄ domyÅlnÄ i ustaw dodatkowÄ konfiguracjÄ.",
        selectDefaultTemplate: "Wybierz domyÅlne szablony z juÅ¼ istniejÄcych, utwÃ³rz nowy szablon lub zaÅaduj wÅasny.",
        selectDispenser: "Wybierz typ dozownika, ktÃ³rego uÅ¼ywasz.",
        selectLanguage: "Wybierz swÃ³j jÄzyk.",
        selectProducts: "Wybierz jeden z dostÄpnych produktÃ³w, ktÃ³ry chcesz aktywowaÄ.",
        selectSpectroType: "Wybierz typ spektrofotometru, ktÃ³rego uÅ¼ywasz.",
        setAdditionalPrinterOptions: "Ustaw dodatkowe opcje drukarki.",
        setAutomaticUpdates: "Ustaw opcje automatycznych aktualizacji.",
        setCustomItems: "Ustaw elementy niestandardowe i widocznoÅÄ danych. PrzewiÅ w dÃ³Å, aby zobaczyÄ wiÄcej opcji.",
        setEnvironment: "Ustaw ogÃ³lne Årodowisko oprogramowania. PrzewiÅ w dÃ³Å, aby zobaczyÄ wiÄcej opcji.",
        setFormulaRepresentation: "Ustaw reprezentacjÄ formuÅy. PrzewiÅ w dÃ³Å, aby zobaczyÄ wiÄcej opcji.",
        summary:
            "MoÅ¼esz zmieniÄ te ustawienia w dowolnym momencie i znaleÅºÄ jeszcze wiÄcej opcji konfiguracyjnych. MiÅego korzystania z %{name}!",
        summarySuccess: "Wszystko gotowe!"
    },
    beforeDispenseColorantBatch: {
        batchNumber: "Batch number: %{batchNumber}",
        colorantIsDefective: "The canister is filled with a defective batch of colorant. Do not use this batch.",
        defectiveInfoLine1: "Please do not use colorant",
        defectiveInfoLine2: "with this batch number.",
        emptyQuickTint: "Empty the canister using Quick tint.",
        warningInfoLine1: "Colorant",
        warningInfoLine2: "with this batch number may be damaged."
    },
    canisterLevel: {
        canisterLevel: "Ustaw poziomy kanistra",
        criticalLevelCanister: "Krytyczny poziom kanistra",
        fillToMax: "WypeÅnij do maksimum",
        maxDispenseLevel: "Dozuj maksimum",
        otherCanisters: "Inne poziomy kanistra",
        warningLevelCanister: "Poziomy ostrzegawcze kanistra"
    },
    canisterRefillHistoryModal: {
        batchNumberOfFilling: "Batch number of filling",
        ufiCodeStatus: "UFI code status"
    },
    canistersTab: {
        availableServiceActions: "DostÄpne akcje serwisowe",
        canisterInformation: "Informacje o kanistrze",
        canisterPreview: "PodglÄd kanistra",
        currentLevel: "Aktualny poziom",
        errors: "BÅÄdy",
        fillState: "Stan napeÅnienia",
        fillToMax: "NapeÅnij do maksimum",
        fillingAmount: "IloÅÄ napeÅniania",
        finalLevel: "Poziom koÅcowy",
        minimumAmount: "Minimalna iloÅÄ",
        minimumLevel: "Minimalny poziom",
        moveTableToRefill: "PrzesuÅ stÃ³Å aby napeÅniÄ",
        refillNoAmount: "Nie wprowadzono iloÅci",
        refillOverLimit: "Wprowadzona iloÅÄ przekracza maksymalnÄ pojemnoÅÄ kanistra",
        refillSummary: "%{amount} %{unit} kolorantu %{colorant} zastanie dodanie do kanistra %{canisterId}.",
        systemWarningAmount: "Systemowa iloÅÄ ostrzegawcza",
        warningAmount: "IloÅÄ ostrzegawcza"
    },
    changeDatabase: {
        changeDatabase: "ZmieÅ bazÄ danych",
        databaseWarning: "Baza danych %{databaseName} nie moÅ¼na uÅ¼yÄ poniewaÅ¼"
    },
    changelog: {
        allVersion: "All versions",
        changelog: "Changelog",
        link: "Link",
        links: "Links",
        version: "Version",
        versionFilter: "Version filter"
    },
    checkBeforeDispensing: {
        checkBeforeDispensingModal: "There is not enough colorant in the canisters for %{numOfPackages} packages.",
        fillAdditionally: "Fill additionally",
        refillToMax: "Refill to max"
    },
    cleanChannels: {
        cleanAllChannels: "WyczyÅÄ wszystkie kanaÅy",
        cleanChannels: "WyczyÅÄ kanaÅy",
        cleaningTime: "Czas czyszczenia",
        selectChannels: "Wybierz kanaÅy",
        startCleaning: "Rozpocznij czyszczenie"
    },
    clientServerSettings: {
        activeServer: "Aktywny serwer",
        addNewServer: "Dodaj nowy serwer",
        availableServers: "Inne dostÄpne serwery",
        clientIdentifier: "Identyfikator klienta",
        clientServerSettings: "Ustawienia klienta/serwera",
        disabledStatus: "wyÅÄczono",
        editServer: "Edytuj serwer",
        fillRequiredFields: "Wymagane pola muszÄ byÄ wypeÅnione",
        noOtherServers: "Nie ma innych dostÄpnych serwerÃ³w",
        offlineStatus: "offline",
        onlineStatus: "online",
        port: "Port",
        serverName: "Nazwa serwera",
        serverNameMissing: "Nazwa serwera musi byÄ wypeÅniona",
        stabileConnection: "Aby zapewniÄ stabilne poÅÄczenie, uÅ¼yj statycznego adresu IP.",
        wrongFormatIp: "NiewÅaÅciwy format adresu IP"
    },
    colorSearchTab: {
        notEveryItemSelected: "One or more items are not selected"
    },
    colorTab: {
        colorTone: "OdcieÅ koloru",
        fandeckPosition: "Pozycja wzornika",
        moreInfoIcons: "More info icons",
        notExistingFormula: "NieistniejÄca formuÅa",
        orderBy: "ZamÃ³w przez",
        selectYourGrid: "Wybierz swojÄ siatkÄ",
        showInPanel: "Show in panel",
        warningIcon: "PokaÅ¼ w panelu"
    },
    colorantBatchNumberSettings: {
        batchNumberByPercentage: "Use Batch numbers by percentage",
        batchNumberFromLastFilling: "Use Batch numbers from the last filling",
        defectiveBatchOfColorant: "Defective Batch of colorant",
        enableBatchNumber: "Enable colorant Batch numbers",
        possibleDamagedBatchOfColorant: "Possibly damaged Batch of colorant",
        scanOrTypeBatchNumber: "Scan or type Batch number"
    },
    colorantPanel: {
        manualMachine: "machine"
    },
    colorantsTable: {
        numberOfColorants: "Liczba kolorantÃ³w:",
        preview: "PodglÄd",
        prices: "Cena"
    },
    currencySettings: {
        addNewCurrency: "Dodaj nowÄ walutÄ",
        codePlaceholder: "Kod",
        currencySettings: "Ustawienia waluty",
        namePlaceholder: "Nazwa",
        ratePlaceholder: "Kurs",
        setDecimalPlaces: "Ustaw liczbÄ miejsc po przecinku ",
        setMainCurrency: "Ustaw gÅÃ³wnÄ walutÄ ",
        setRounding: "ZaokrÄglanie ",
        symbolPlaceholder: "Symbol"
    },
    customFandecks: {
        customFandecks: "WÅasne wzorniki",
        deleteButtonWarning: "Wszystkie formuÅy z wzornika rÃ³wnieÅ¼ zostanÄ usuniÄte.",
        deleteCustomFandeck:
            "Czy na pewno chcesz usunÄÄ tÄ niestandardowy wzornik? Wszystkie formuÅy z tego wzornika rÃ³wnieÅ¼ zostanÄ usuniÄte.",
        disableStandardFandecks: "Ukryj podpowiadane i pokaÅ¼ niestandardowe wzorniki kolorÃ³w",
        enableStandardFandecks: "Podpowiedz standardowe wzorniki kolorÃ³w",
        fandeckName: "Nazwa wzornika"
    },
    customRedlike: {
        addColorantFromBrand: "Add colorant from %{brandName} brand",
        addNewCustomer: "Dodaj nowego klienta",
        addNewNote: "Dodaj nowÄ notatkÄ",
        addedDate: "Data dodania",
        addedQuantity: "Dodana iloÅÄ",
        availableMachine: "Maszyna dostÄpna",
        brand: "Marka",
        brandPlease: "ProszÄ wybraÄ markÄ",
        cancelCustomer: "Anuluj klienta",
        colorPlease: "ProszÄ wybraÄ kolor",
        confirmCustomerData: "PotwierdÅº dane klienta",
        confirmNoteData: "PotwierdÅº dane notatki",
        confirmSelectedUser: "Czy chcesz uÅ¼yÄ klienta %{customerName} do tego zamÃ³wienia.",
        confirmed: "Potwierdzony",
        controlData: "KoÅcowa kontrola danych",
        customerCellNumber: "Numer komÃ³rki klienta",
        customerFilter: "Filtr klienta",
        customerName: "Nazwa klienta",
        customerPhone: "Telefon klienta",
        customerPlease: "ProszÄ wybraÄ klienta",
        dateFilter: "Filtr daty",
        enterPin: "Wpisz swÃ³j kod PIN",
        enterTheNumberOfPackages: "WprowadÅº liczbÄ opakowaÅ",
        existingCustomer: "UÅ¼ytkownik juÅ¼ istnieje",
        fandeckPlease: "Wybierz wzornik",
        fillCanisterHistory: "Historia napeÅniania kanistra",
        findCustomer:
            "Aby przypisaÄ kartÄ lojalnoÅciowÄ do tego zamÃ³wienia, zeskanuj kod kreskowy lub wyszukaj adres e-mail",
        findCustomerByEmail: "Filtruj klienta wedÅug adresu e-mail lub kodu kreskowego",
        finishPreviousStep: "(ProszÄ zakoÅczyÄ poprzedni krok)",
        formulaUnit: "Jednostka formuÅy",
        getBackToList: "WrÃ³Ä do listy klientÃ³w",
        historyOfOrders: "Historia zamÃ³wieÅ",
        insertNote: "IdÅº, aby wstawiÄ notatkÄ",
        loadHistoryOrder: "Czy chcesz zaÅadowaÄ wybrane zamÃ³wienie?",
        loyaltyCards: "Karty lojalnoÅciowe",
        machineIsAvailable: "MASZYNA JEST DOSTÄPNA",
        machineIsUnavailable: "MASZYNA JEST NIEDOSTÄPNA",
        newLoyaltyCard: "Nowa karta lojalnoÅciowa",
        noAvailableMachine: "Maszyna jest niedostÄpna",
        noCustomerSelected: "Å»aden klient nie zostaÅ wybrany. Czy chcesz kontynuowaÄ?",
        notePlease: "ProszÄ wstawiÄ notatkÄ",
        openHistory: "OtwÃ³rz historiÄ",
        orAdd: "Lub dodaj klienta",
        orSelect: "Lub wybierz klienta",
        orderModification: "The original order will be modified. Do you want to continue?",
        orderOverview: "PrzeglÄd zamÃ³wieÅ",
        orderToMachine: "WYÅLIJ MOJE ZAMÃWIENIE DO MASZYNY",
        ordersHistory: "Historia zamÃ³wieÅ",
        packagePlease: "ProszÄ wybraÄ opakowanie",
        pleaseSelectBrand: "Wybierz markÄ",
        previewImage: "PodglÄd obrazu",
        previewPackage: "PodglÄd opakowania",
        productPlease: "ProszÄ wybraÄ produkt",
        resetFilters: "Zresetuj wszystkie filtry",
        searchForHistoricalOrders: "Lub szukaj zamÃ³wieÅ historycznych",
        selectBrand: "Wybierz markÄ",
        selectColor: "IdÅº, aby wybraÄ kolor",
        selectCustomer: "IdÅº, aby wybraÄ klienta",
        selectExistingCustomer: "Wybierz istniejÄcego klienta",
        selectFandeck: "IdÅº, aby wybraÄ wzornik",
        selectManually: "If you want to use this color in %{brandNames} brand, please select it manually.",
        selectPackage: "IdÅº, aby wybraÄ opakowanie",
        selectProduct: "IdÅº, aby wybraÄ produkt",
        shotsCoefficient: "WspÃ³Åczynnik strzaÅÃ³w",
        showDetail: "PokaÅ¼ szczegÃ³Å",
        showHideEshopName: "PokaÅ¼ / Ukryj nazwÄ esklepu koloru w oddzielnej kolumnie",
        showKeyboard: "PokaÅ¼ klawiaturÄ",
        skipCustomerButton: "PomiÅ wybranego klienta",
        skipCustomerText: "PomiÅ, jeÅli nie chcesz wprowadziÄ klienta",
        skipNote: "PomiÅ notatkÄ i wyÅwietl podsumowanie",
        spectroBrand: "Searching in brand %{brandName}",
        statusAccepted: "Zaakceptowany",
        statusCanceled: "Anulowany",
        statusCreated: "Utworzony",
        statusDone: "Zrobione",
        statusPartlyDone: "CzÄÅciowo zrobione",
        statusPreparing: "Przygotowanie",
        summaryChosenBase: "Baza",
        summaryChosenBrand: "Marka",
        summaryChosenCanSize: "Rozmiar puszki",
        summaryChosenColor: "Kolor",
        summaryChosenColorCard: "karta kolorÃ³w",
        summaryChosenProduct: "Produkt",
        summaryChosenQuantity: "IloÅÄ",
        summaryColorPreview: "PodglÄd koloru",
        summaryCustomNote: "Notatka niestandardowa",
        summaryCustomerNumber: "Numer klienta",
        summaryFormula: "FormuÅa",
        summaryFormulaNote: "Notatka formuÅy",
        summaryNote: "Notatka",
        sureAboutSend: "Czy na pewno chcesz wysÅaÄ zamÃ³wienie?",
        useCustomerInOrder: "Czy chcesz uÅ¼ywaÄ %{customerName} w nastÄpujÄcej kolejnoÅci?",
        uuid: "UUID",
        viewSummary: "Zobacz podsumowanie",
        volume: "ObjÄtoÅÄ"
    },
    customRedlikeAnother: {
        pinOrderConfirmation: "Przypnij potwierdzenie zamÃ³wienia",
        pinScreenSaverConfirmation: "Przypnij potwierdzenie wygaszacza ekranu",
        pinSettingsConfirmation: "Przypnij potwierdzenie ustawieÅ",
        printAuto: "Zezwalaj na drukowanie automatycznie",
        printerSettings: "Ustawienia drukarki",
        selectColorWithFandeck: "WspÃ³lny wybÃ³r koloru i wzornika",
        setKeyboard: "Ustaw klawiaturÄ",
        setKioskMode: "Ustaw tryb samoobsÅugowy",
        setLanguage: "Ustaw jÄzyk",
        setModule: "Ustaw moduÅ",
        setQuickSelect: "Ustaw szybki wybÃ³r",
        setScreensaverTimeout: "Ustaw limit czasu wygaszacza ekranu",
        setUnit: "Ustaw jednostkÄ"
    },
    customRedlikeMachine: {
        action: "Akcja",
        additionalPrint: "Dodatkowe wydruku",
        brand: "Marka",
        brandAccess: "UÅ¼ytkownik '%{userName}' nie moÅ¼e uzyskaÄ dostÄpu do danych marki '%{brandName}'",
        can: "Puszka podstawiona",
        canistersLevel: "PodglÄd poziomu kanistrÃ³w",
        closeDetailInformation: "Zamknij szczegÃ³Åy",
        colorantsAmount: "IloÅÄ pigmentÃ³w",
        confirmRefill: "ZatwierdÅº uzupeÅnienie pigmentu",
        deleteOrder: "UsuÅ zamÃ³wienie",
        dialogNoMachine: "Maszyna nie podÅÄczona",
        dialogNoRcc: "Å»adne RCC nie jest podÅÄczone",
        dispense: "Dozowanie",
        dispenserInErrorState: "W dozownik wystÄpiÅ bÅÄd",
        dispensingIsOk: "Dozownik dziaÅa poprawnie",
        emergencyButtonPressed: "WciÅniÄty wyÅÄcznik awaryjny",
        errorCode: "Kod bÅÄdu",
        errorEvents: "BÅÄd dozownika",
        errorReset: "Resetuj bÅÄd",
        explanation: "WyjaÅnienie",
        imageNotAvailable: "Obraz jest niedostÄpny",
        incorrectCanister: "Zeskanowano nieprawidÅowy pojemnik!",
        incorrectColorant: "BÅÄD: zeskanowano nieprawidÅowy kolorant. ProszÄ zeskanowaÄ wÅaÅciwy kolorant",
        lastEvents: "Ostatnie zdarzenia",
        machineActions: "Czujniki dozownika",
        machineConfiguration: "Konfiguracja dozownika",
        machineError: "BÅÄd maszyny",
        machineIsBusy: "Maszyna jest zajÄta",
        machineNotAvailable: "Maszyna jest niedostÄpna",
        machineTinting: "ProszÄ czekaÄ, maszyna barwiâ¦",
        manualScan: "Skanowanie rÄczne",
        notEnoughSpace: "BÅÄD: nie ma wystarczajÄcej iloÅci miejsca dla tego opakowania kolorantu",
        numberOfCanistersUnderCriticalLevel: "Liczba kanistrÃ³w poniÅ¼ej poziomu krytycznego wynosi %{0}",
        numberOfCanistersUnderWarningLevel: "Liczba kanistrÃ³w poniÅ¼ej poziomu ostrzegawczego wynosi %{0}",
        offlinePressed: "NaciÅniÄty przycisk offline",
        orderSettings: "Ustawienia ZamÃ³wienia",
        otherOrderInformation: "SzczegÃ³Åy zamÃ³wienia",
        packageCount: "IloÅÄ opakowaÅ",
        packageWithSeparator: "Opakowanie",
        received: "Odebrane",
        receivedOrders: "Otrzymane zamÃ³wienia",
        receivedTime: "Otrzymany czas",
        recirculation: "Recyrkulacja",
        refillInformation: "Barwnik: %{0}, NapeÅnienie: %{1}, Kanister: %{2}",
        resetErrors: "Resetuj bÅÄdy",
        scanCanister: "Zeskanuj ten pojemnik",
        scanColorantPackage: "Zeskanuj wÅaÅciwe opakowanie barwnika",
        selectedOrder: "Wybrane zamÃ³wienie",
        shelfMovingDown: "PÃ³Åka zjeÅ¼dÅ¼a w dÃ³Å",
        shelfMovingUp: "PÃ³Åka jedzie w gÃ³rÄ",
        solution: "RozwiÄzanie",
        startDispensing: "Rozpocznij dozowanie",
        stirring: "Mieszanie",
        touchToStartFilling: "Dotknij, aby rozpoczÄÄ napeÅnianie barwnikiem",
        unknownBrand: "Nieznana marka"
    },
    customRedlikeSettings: {
        addPos: "Informacje o POS",
        addServer: "Dodaj serwer",
        adminOperations: "Operacje administracyjne",
        adminSettings: "Ustawienia administratora",
        another: "Inny",
        aslOrService: "ASL lub usÅuga",
        availableMachines: "DostÄpne maszyny",
        barcode: "Kod kreskowy",
        basicOperations: "Podstawowe operacje",
        canisterBarcodes: "Kody kreskowe kanistra",
        canisterLevels: "Poziomy kanistra",
        closeConnection: "Zamknij polÄczenie",
        closeRedlike: "Zamknij %{name}",
        databaseList: "Baza danych",
        disabledStatus: "wyÅÄczone",
        dispenseLogicType: "Rodzaj logiki dozowania",
        dropServers: "ZrzuÄ serwery",
        editServer: "Edytuj serwer",
        lastEvent: "Ostatnie wydarzenie",
        logOut: "Wyloguj",
        machineConfiguration: "Konfiguracja",
        maxDispenseAmount: "Maksymalna iloÅÄ dozowania",
        offlineStatus: "offline",
        onlineStatus: "online",
        openFrondesk: "OtwÃ³rz wzornik",
        print: "Ustawienia drukowania",
        rebootPC: "Uruchom ponownie komputer",
        restartRedlike: "Uruchom ponownie %{name}",
        restoreConnection: "PrzywrÃ³Ä poÅÄczenie",
        scanCanisterBarcode: "Zeskanuj kod kreskowy kanistra",
        scanOrDeleteCanisterBarcode: "Zeskanuj lub usuÅ kod kreskowy kamistra",
        setCanisterBarcode: "Ustaw kod kreskowy kanistra",
        swVersion: "Wersja oprogramowania",
        systemFunctions: "Funkcje systemu",
        userSettings: "Ustawienia uÅ¼ytkownika"
    },
    customTab: {
        cifCombinationCheck:
            "The color %{colorName} already exists in fandeck %{fandeckName}, but it contains different spectral data. Would you like to overwrite existing data?",
        editColor: "Edytuj kolor",
        editColorant: "Edytuj kolorant",
        emptyColorant: "JakiÅ kolorant ma zerowÄ iloÅÄ",
        formulaCombinationCheck:
            'The formula with the color name "%{colorName}" already exists. Would you like to overwrite existing formula with the new one?',
        formulaForMasterProduct: "Formula for master product",
        formulaForMasterProductWithParam: "Formula for master product %{productName}",
        isNotAvailable: "Jest niedostÄpny",
        noBaseSelected: "Baza jest wymagana",
        noColorantsSelected: "Nie wybrano Å¼adnych kolorantÃ³w",
        noFandeckSelected: "Wzirnik jest wymagany",
        noNameOrCode: "Color name and code are required",
        noProductSelected: "Produkt jest wymagany",
        productPreview: "PodglÄd produktu",
        saveCustomRecipe: "Zapisz wÅasnÄ formuÅÄ",
        saveIsNotAvailable: "Zapis nie jest dostÄpny",
        showSiblingProducts: "Show sibling products",
        siblingProducts: "Sibling products by master product"
    },
    customersTab: {
        addCustomer: "Dodaj klienta",
        additionalSettings: "Dodatkowe ustawienia",
        adress: "Adres",
        createAndSelect: "Dodaj i wybierz",
        createNewCustomer: "UtwÃ³rz nowego klienta",
        editCustomer: "Edytuj klienta",
        expiration: "Customer %{name} will expire in %{dayCount} days",
        identificationNumber: "Numer identyfikacyjny",
        information: "Informacje kontaktowe",
        listOfCustomers: "Lista klientÃ³w",
        rabat: "Upust",
        selectCustomer: "Wybierz klienta",
        spentLastMonth: "Wydano w zeszÅym miesiÄcu",
        spentMoney: "Wydane pieniÄdze",
        typeOfMargin: "Rodzaj marginesu",
        zipCode: "Kod pocztowy"
    },
    dialog: {
        cheaperColorSearch: "Trwa wyszukiwanie taÅszego koloru",
        competitiveColorSearch: "Trwa wyszukiwanie konkurencyjnych kolorÃ³w",
        reallyChangeModule: "Czy naprawdÄ chcesz zmieniÄ moduÅ?",
        reallyCloseRedlike:
            "Czy na pewno chcesz zamknÄÄ %{name}? Wszystkie panele %{name} zostanÄ zamkniÄte, niezapisane zmiany zostanÄ utracone.",
        reallyDeleteOrder:
            "Czy na pewno chcesz usunÄÄ to zamÃ³wienie? Wszystkie dane zwiÄzane z tym zamÃ³wieniem zostanÄ utracone.",
        reallyRebootPC:
            "Czy naprawdÄ chcesz ponownie uruchomiÄ ten komputer? Wszystkie panele zostanÄ zamkniÄte, niezapisane zmiany zostanÄ utracone.",
        reallyRestartRedlike:
            "Czy naprawdÄ chcesz zrestartowaÄ %{name}? Wszystkie panele zostanÄ zamkniÄte, niezapisane zmiany zostanÄ utracone.",
        reallyShutdownPc:
            "Czy na pewno chcesz wyÅÄczyÄ ten komputer? Wszystkie panele %{name} zostanÄ zamkniÄte, niezapisane zmiany zostanÄ utracone.",
        unlockComputer: "Computer will be unlocked."
    },
    dispenseLogicTypes: {
        1: "Dozuj tylko maksymalna iloÅÄ do barwienia",
        2: "ZezwÃ³l na rÄczne dozowanie za pomocÄ skali dla iloÅci przekraczajÄcych maksymalnÄ iloÅÄ do barwienia",
        3: "UzupeÅniaj podczas barwienia (podziel iloÅÄ na mniejsze czÄÅci)",
        4: "Force manual dispensing using scale only in case of custom package"
    },
    editCustomFandeck: {
        fandeckName: "Nazwa wzornika"
    },
    editFormulaRgbModal: {
        apply: "Zastosuj",
        blue: "Niebieski",
        green: "Zielony",
        modalLabel: "Edytuj kolor",
        red: "Czerwony",
        tryGenerateRgb: "Try to generate RGB by colorant amounts"
    },
    environmentsSettings: {
        allowAutoCloseTab: "Zamknij kartÄ formuÅy automatycznie",
        allowBarcodes: "Zezwalaj na kody kreskowe",
        allowBuildingSitePanel: "Allow building site specification",
        allowCustomers: "Zezwalaj na klientÃ³w",
        allowDeleteConfirmation: "Allow delete confirmation",
        allowDiskSpaceNotification: "Zezwalaj na powiadomienie o miejscu na dysku",
        allowDispensing: "PozwÃ³l na dozowanie",
        allowFileTransfer: "Zezwalaj na automatyczny transfer plikÃ³w",
        allowFormulaModificationPanel: "Allow formula modification panel",
        allowFormulaStatusPanel: "Allow formula status panel",
        allowInternalNotes: "Allow internal notes",
        allowLight: "ZezwÃ³l %{name}",
        allowOrderNotificationModal: "PokaÅ¼ powiadomienia o nowym zamÃ³wieniu",
        allowOrdering: "Zezwalaj na zamawianie",
        allowPricing: "Allow pricing",
        allowPrint: "Allow print",
        allowProductPreviewImage: "ZezwÃ³l na podglÄd obrazu produktu podczas dozowania",
        allowQualityControl: "Allow quality control",
        allowSearchCheaperColors: "PozwÃ³l na wyszukiwanie taÅszych kolorÃ³w",
        allowSound: "Zezwalaj na powiadomienie dÅºwiÄkowe",
        allowSpectro: "Zezwalaj spektro",
        allowTabs: "Allow tabs",
        applyZoom: "Zastosuj powiÄkszenie",
        automaticLogout: "Automatic logout",
        barcodeScan: "Barcode Scan",
        canisterBarcode: "Kody kreskowe kanistra",
        canisterLevel: "Poziom kanistra",
        changelog: "Dziennik zmian",
        closeTab: "Zamknij kartÄ",
        colorDifference: "Color difference",
        colorPanelNavItem: "Paleta kolorÃ³w",
        competitiveColorSearch: "Konkurencyjne wyszukiwanie kolorÃ³w",
        customBanner: "Niestandardowy baner",
        customCurrencyFormat: "Currency format",
        customDateFormat: "Date format",
        customNumberFormat: "Number format",
        customTimeFormat: "Time format",
        deltaA: "Delta A",
        deltaB: "Delta B",
        deltaE: "Delta E",
        deltaL: "Delta L",
        deltaMetamerism: "Delta metamerism",
        discount: "Show discount",
        dispensingHistory: "Historia dozowania",
        dispensingNotes: "Allow dispensing notes",
        enableCustomers: "Enable customers",
        enableDeleteConfirmation: "Enable delete confirmation",
        enableDispensing: "WÅÄcz dozowanie",
        enableLight: "WÅÄcz %{name}",
        enableMarginMarkup: "WÅÄcz margines lub znaczniki",
        enableNotes: "WÅÄcz notatki",
        enableOrdering: "WÅÄcz zamawianie",
        enableProductPreviewImage: "WÅÄcz podglÄd obrazu produktu",
        enableSpectro: "WÅÄcz spektro",
        enableVirtualKeyboard: "Zezwalaj na wirtualnÄ klawiaturÄ",
        environmentsSettings: "Ustawienia Årodowiska",
        exportTranslationKeys: "Eksportuj klucze tÅumaczenia",
        formulaNotes: "Zezwalaj na notatki do formuÅ",
        hintTooltips: "Podpowiedzi",
        image: "Obraz",
        keyboardShortcuts: "SkrÃ³ty klawiszowe",
        languageBased: "Language based",
        lockYourComputer: "Zablokuj swÃ³j komputer",
        machineReset: "Reset urzÄdzenia",
        manageTranslations: "ZarzÄdzaj tÅumaczeniami",
        margin: "Tylko margines",
        markup: "Tylko znaczniki",
        matchingRowCount: "Set number of results found",
        maxNumberTabs: "Maksymalna liczba zakÅadek formuÅ",
        memoryTabs: "Przechowuj ostatnio otwarte karty",
        moreInfo: "Kolor + obraz + wiÄcej informacji",
        navigationItems: "Ustawienia elementÃ³w nawigacji",
        newTab: "Nowa karta",
        numberOfPriceGroups: "Liczba grup cenowych",
        order: "ZamÃ³wienie",
        orderId: "ID zamÃ³wienia",
        ordersHistory: "Historia zamÃ³wieÅ",
        overwriteLastTab: "ZastÄp ostatniÄ kartÄ formuÅy",
        priceCalculation: "Kalkulacja ceny",
        priceDefBothPurchasePrimary: "Both, purchase primary",
        priceDefBothSellPrimary: "Both, sell primary",
        priceDefPurchaseOnly: "Tylko cena zakupu",
        priceDefSellOnly: "Tylko cena sprzedaÅ¼y",
        priceDefinition: "Definicja ceny",
        priceGroupsEnabled: "WÅÄcz grupy cenowe",
        runLightAtStartUp: "Uruchom %{light} przy starcie",
        screenSaverTimeout: "Limit czasu wygaszacza ekranu",
        selectedSpectro: "Wybrany %{spectro} widma",
        selectedSpectroNone: "Nie wybrano widma.",
        setAutomaticClientStart: "Uruchom %{name} podczas uruchamiania komputera",
        setCustomHomeButton: "Ustaw akcjÄ przycisku Home",
        setDecimalPlaces: "Ustaw liczbÄ miejsc po przecinku",
        setFormulaPreview: "Ustaw podglÄd formuÅy",
        setFormulaUnit: "Ustaw jednostkÄ formuÅy",
        setFts: "UÅ¼yj wyszukiwania peÅnotekstowego",
        setInfoItemInRgb: "Ustaw informacje widoczne w podglÄdzie kolorÃ³w formuÅy",
        setKeyboardShortcuts: "Ustaw skrÃ³ty klawiaturowe",
        setKioskMode: "Ustaw tryb samoobsÅugowy",
        setKioskModeOff: "WÅÄcz tryb samoobsÅugowy",
        setKioskModeOn: "WyÅÄcz tryb samoobsÅugowy",
        setNavigationItems: "Ustaw elementy nawigacyjne",
        setNavigationItemsList: "Ustaw widocznoÅÄ i kolejnoÅÄ elementÃ³w nawigacyjnych",
        setOrderSearchItems: "Ustaw parametry wyszukiwania zamÃ³wieÅ",
        setRounding: "Ustaw zaokrÄglanie",
        setSearchParameters: "Ustaw parametry wyszukiwania formuÅy",
        setTabLimit: "Ustaw limit zakÅadek",
        setYourLanguage: "Ustaw swÃ³j jÄzyk",
        setZoom: "Ustaw powiÄkszenie",
        showLocalPrices: "PokaÅ¼ ceny lokalne",
        skipPlaceCanDialogEnabled:
            "To ustawienie nie moÅ¼e zostaÄ zmienione, poniewaÅ¼ okno dialogowe zostaÅo dezaktywowane w Ustawieniach maszyny",
        sortItems: "Sortuj elementy nawigacyjne",
        startDispensing: "Rozpocznij dozowanie",
        stir: "WymieszaÄ"
    },
    error: {
        errorDetail: "SzczegÃ³Åy bÅÄdu",
        errorOccurred:
            "WystÄpiÅ nieoczekiwany bÅÄd. Skontaktuj siÄ z naszym wsparciem na %{0}, a my skontaktujemy siÄ z TobÄ jak najszybciej.",
        hideDetail: "Ukryj szczegÃ³Åy"
    },
    favoritesTab: {
        addFolder: "Dodaj folder",
        closeTabToLoadFormula: "Zamknij jednÄ z formuÅ, aby otworzyÄ nowÄ kartÄ. OsiÄgniÄto maksymalnÄ liczbÄ kart.",
        deleteFolder: "UsuÅ folder",
        editFolder: "Edytuj folder",
        favoriteFormulas: "Ulubione formuÅy",
        formulaNotes: "Formula notes",
        message: {
            formulasFromFolder: "FormuÅy z folderu",
            moveAllFormulas: "PrzenieÅ wszystkie formuÅy z tego folderu do folderu gÅÃ³wnego",
            removeAllFormulas: "UsuÅ wszystkie formuÅy z tego folderu",
            wantToDeleteFolder: "Czy na pewno chcesz usunÄÄ ten folder?"
        },
        newFolder: "Nowy folder",
        packages: "Opakowanie",
        pricePerPackage: "Cena za opakowanie",
        regularPrice: "Cena regularna",
        removeFromFavorites: "UsuÅ z ulubionych",
        specialPriceOff: "Specjalna cena %{number}% zniÅ¼ki",
        specialPriceVIP: "Specjalna cena VIP"
    },
    fileTransfer: {
        afterImport: "After import",
        alreadyExists: "Task for given type and format already exists",
        customFormulaSimple: "Prosta formuÅa niestandardowa",
        direction: "Direction",
        exportTask: "Zadanie eksportu pliku",
        fileTransferNotification: "File transfer notification",
        flashMessage: "Flash message",
        importTask: "File import task",
        noInformation: "No information",
        protocol: {
            folder: "Folder",
            ftp: "FTP protocol",
            ftps: "FTPS protocol",
            redlikeStorage: "%{softwareName} FTP storage protocol",
            sftp: "SFTP protocol"
        },
        protocolDescription: {
            folder: "Protocol checking files in defined local folder.",
            ftp: "Protocol checking files in remote FTP folder using standard FTP connection.",
            ftps: "Protocol checking files in remote FTPS (FTP-SSL / FTP Secure) server using standard FTP connection.",
            redlikeStorage: "Protocol checking files in %{softwareName} storage."
        },
        remoteFolder: "Remote folder",
        startType: "Typ startu",
        statusbar: "Statusbar information",
        testConnection: "Test connection",
        xMoreLeft: "(%{amount} more left)",
        xmlImporting: "XML file is being imported"
    },
    filtering: {
        consumptionType: "Rodzaj zuÅ¼ycia",
        filter: "Filtr",
        from: "Od",
        to: "Do"
    },
    findText: {
        findTextTitle: "ZnajdÅº tekst",
        removeMarks: "UsuÅ zaznaczenia",
        search: "Wyszukaj sÅowo"
    },
    flashMessage: {
        VMNotAllowed: "VM nie jest dozwolone",
        addedToStock: "Successfully added items to stock",
        allRecordsDeleted: "All imported records were successfully deleted",
        autologinFailed: "Automatyczne logowanie do bazy danych nie powiodÅo siÄ.",
        autotaskDuplicateName:
            "BÅÄd integralnoÅci bazy danych: element %{0} z %{1} %{2} juÅ¼ istnieje, uÅ¼yj innego %{3}",
        barcodeIsUsed: "Kod kreskowy jest juÅ¼ uÅ¼ywany.",
        barcodeNotFound: "Nie znaleziono kodu kreskowego",
        bugReportSent: "TwÃ³j raport o bÅÄdzie zostaÅ wysÅany.",
        cannoctConnectToServer: "Nie moÅ¼na poÅÄczyÄ siÄ z serwerem",
        cannotWriteLicense: "Nie moÅ¼na napisaÄ licencji",
        clientConnectionRejected: "PoÅÄczenie odrzucone",
        clientNotLoggedIn: "Klient nie jest zalogowany",
        colorFromInactiveDatabase: "Color is from inactive database %{0}.",
        colorantPackageRemovedStock: "Colorant package successfully removed from stock.",
        competitiveSearchEmpty:
            "Nie znaleziono konkurencyjnych kolorÃ³w. ZmieÅ parametry wyszukiwania lub wybierz inny kolor.",
        competitiveSearchSelectProduct: "Please select product to start competitive color search.",
        computerBackdated: "Antydatowanie komputera",
        connectionFailed: "Connection test failed: %{0}",
        connectionSuccess: "Connection test was successful",
        corruptedLicenseFile: "Plik licencji jest uszkodzony",
        customFormulaCreated: "Custom formula successfully created.",
        customFormulaCreationError: "Error while creating custom formula.",
        customFormulaFromXmlCreationError:
            "Error while creating custom formula with colorants '%{colorants}' for combination of product '%{product}', fandeck '%{fandeck}', color '%{color}' and base '%{base}'.",
        customerNotFound: "Klient nie odnaleziony",
        dataNotAvailable: "Serwer nie moÅ¼e poÅÄczyÄ siÄ z bazÄ danych",
        datacolorMatching: {
            couldNotConnect: "Could not connect to Datacolor Matching, either server down or PC is offline.",
            disabled: "Datacolor Matching disabled.",
            internalError: "Datacolor Matching internal error: '%{0}'",
            invalidCredentials: "No or invalid credentials for Datacolor Matching provided, contact database provider.",
            noCansAvailable: "No cans available for selected color file (product line), contact database provider."
        },
        defaultMessage: "WystÄpiÅ nieoczekiwany bÅÄd podczas ostatniej akcji serwera",
        deleteAll: "UsuÅ Wszystko",
        deletingImportedData: "Deleting imported records.",
        disableWinterPlugin:
            "MoÅ¼esz wyÅÄczyÄ wtyczkÄ zimowÄ za pomocÄ menu rozwijanego po prawej stronie nawigacji uruchomionych zakÅadek",
        duplicateBarcode: "Zduplikowany kod kreskowy juÅ¼ istnieje.",
        duplicateName: "Zduplikowana nazwa juÅ¼ istnieje",
        emptyFandeck: "Selected fandeck is empty.",
        emptyStock: "There are no records in stock for the item you have used.",
        expiredLicense: "Licencja wygasÅa",
        exportSuccess: "Dane zostaÅy pomyÅlnie wyeksportowane",
        fandeckExist: "Ta niestandardowa nazwa wzornika juÅ¼ istnieje.",
        featureNotAutorized: "Funkcja nie jest autoryzowana",
        fileExportComplete: "Plik zostaÅ pomyÅlnie wyeksportowany.",
        fileExportError: "An error occurred during file export.",
        fileSaveComplete: "File was successfully saved.",
        fileSaveError: "An error occurred during file saving.",
        fileTransferCustomFormulaRecordsAdded: "New custom formula records were added from the received file.",
        fileTransferCustomFormulaRecordsNotFullyProcessed:
            "Could not fully process custom formula data in file: '%{0}', see error log files for more info.",
        fileTransferCustomFormulaRecordsProcessed:
            "The new custom formula records (%{0} of the %{1}) were succesfully added from the recieved file.",
        fileTransferCustomerRecordsAdded: "New customer records were added from the received file.",
        fileTransferCustomerRecordsNotFullyProcessed:
            "Could not fully process customer data in file: '%{0}', see error log files for more info.",
        fileTransferCustomerRecordsProcessed:
            "The new customer records (%{0} of the %{1}) were succesfully added from the recieved file.",
        fileTransferFileNotProvided: "Plik nie zostaÅ dostarczony lub jest pusty.",
        fileTransferHistoryRecordsAdded: "New dispensing history records were added from the received file.",
        fileTransferHistoryRecordsNotFullyProcessed:
            "Could not fully process dispensing history data in file: '%{0}', see error log files for more info.",
        fileTransferHistoryRecordsProcessed:
            "The new history records (%{0} of the %{1}) were succesfully added from the recieved file.",
        fileTransferInvalidFile: "Nie moÅ¼na przetworzyÄ danych w pliku, plik jest nieprawidÅowy.",
        fileTransferOrderRecordsAdded: "New order records were added from the received file.",
        fileTransferOrderRecordsNotFullyProcessed:
            "Could not fully process order data in file: '%{0}', see error log files for more info.",
        fileTransferOrderRecordsProcessed:
            "The new order records (%{0} of the %{1}) were succesfully added from the recieved file.",
        fileTransferUnknownVersion: "Nie udaÅo siÄ wykryÄ wersji pliku.",
        filetransferNoData: "Brak poÅÄczenia z bazÄ danych, sprawdÅº ustawienia",
        formulaDataUnavailable: "Dane formuÅy nie sÄ dostÄpne",
        helperDefaultMessage: "WystÄpiÅ nieoczekiwany bÅÄd podczas ostatniej akcji serwera pomocniczego",
        helperServerError: "BÅÄd serwera pomocniczego",
        importAborted: "Proces importowania zostaÅ przerwany",
        importSuccess: "Dane zostaÅy zaimportowane pomyÅlnie",
        incompatibleBaseCan: "Baza nie jest kompatybilna z danym produktem, bazÄ i opakowaniem",
        incorrectPassword: "Twoje stare hasÅo jest nieprawidÅowe. ProszÄ podaÄ poprawne",
        invalidCurrency: "Kod waluty jest nieprawidÅowy. Euro jest ustawione jako domyÅlna waluta.",
        invalidDatabaseName: "Nazwa bazy danych jest nieprawidÅowa",
        invalidEmail: "TwÃ³j adres e-mail jest nieprawidÅowy",
        invalidFormulaColorants:
            "There is the software issue in the formula. Formula could be wrong! Contact your support!",
        invalidLicenseCompanyUserKey: "NieprawidÅowy klucz uÅ¼ytkownika firmy",
        invalidLicenseFile: "NieprawidÅowy plik licencji",
        invalidLicenseIdentificationKeys: "Twoje klucze identyfikacyjne licencji sÄ nieprawidÅowe",
        invalidLicenseKey: "Twoja licencja jest niewaÅ¼na",
        invalidLicenseProduct: "Plik licencji nie pasuje do produktu",
        invalidRccResponse: "WystÄpiÅ nieoczekiwany bÅÄd podczas przetwarzania ostatniej odpowiedzi RCC",
        invalidServerResponse: "WystÄpiÅ nieoczekiwany bÅÄd podczas przetwarzania ostatniej odpowiedzi serwera",
        invalidUrl: "URL jest nieprawidÅowy",
        itemNotFound: "Produkt nie zostaÅ znaleziony",
        keyboardShortcutUsedInModal:
            "Tego skrÃ³tu klawiaturowego nie moÅ¼na uÅ¼ywaÄ w oknie modalnym. Zamknij okno modalne.",
        keyboardShortcutValidation: "Nie moÅ¼esz mieÄ tego samego skrÃ³tu klawiaturowego dla dwÃ³ch rÃ³Å¼nych akcji",
        licenseHasBeenRevoked:
            "Twoja licencja zostaÅa cofniÄta. Aby je odnowiÄ, skontaktuj siÄ z dostawcÄ oprogramowania.",
        licenseProlongationNeeded:
            "Wymagane przedÅuÅ¼enie licencji (podÅÄcz komputer do Internetu, aby uzyskaÄ nowÄ licencjÄ)",
        licenseUpToDate: "Your license is up to date. No update necessary.",
        licenseUpdateUnsuccessful: "Could not update license.",
        licenseUpdated: "License has been successfully updated.",
        licensedOnDifferentComputer: "Pierwotnie licencjonowany na innym komputerze",
        logFileArchiveDownloadComplete: "Pobieranie archiwum dziennika zakoÅczone pomyÅlnie",
        loginError: "WystÄpiÅ nieoczekiwany bÅÄd podczas logowania",
        logoutError: "WystÄpiÅ nieoczekiwany bÅÄd podczas wylogowywania",
        machineIsConnecting: "Maszyna siÄ ÅÄczy, proszÄ czekaÄ",
        machineIsNotConnected: "Twoje urzÄdzenie NIE JEST PODÅÄCZONE do RCC. SprawdÅº konfiguracjÄ RCC.",
        malformedFormula: "Formula is malformed.",
        matching: {
            correctionNotPossible: "Correction cannot be done, use reformulation.",
            forbidden: "Request '%{0}' failed: forbidden.",
            internalServerError: "Internal server error.",
            invalidBase: "Invalid base in product.",
            invalidBipp: "Invalid base in product package.",
            invalidColorantId: "Invalid colorant with ID: %{0}.",
            invalidColorantName: "Invalid colorant with name: %{0}.",
            invalidColorfile: "Invalid color file with ID: %{0} for product with ID: %{1}.",
            invalidIlluminant: "Invalid illuminant: %{0}",
            invalidProduct: "Invalid product with ID: %{0}.",
            invalidSpectralCurve: "Invalid spectral curve.",
            noColorfiles: "No color files defined for product with ID: %{0}.",
            notAuthorized: "Request '%{0}' failed: unauthorized.",
            notFound: "Request '%{0}' failed: not found.",
            reformulationNotPossible: "Reformulation cannot be done.",
            unknownError: "Unknown error.",
            validationError: "Request '%{0}' failed due to validation errors: %{0}."
        },
        maxFileSizeExceeded: "Maximum file size of %{0} MB exceeded",
        maxTabs: "Maksymalna liczba kart, zamknij jednÄ.",
        noTemplate: "Nie moÅ¼na wykonaÄ wydruku, poniewaÅ¼ nie ma dostÄpnych szablonÃ³w.",
        openNewTab: "OtwÃ³rz nowÄ kartÄ formuÅy, aby zaÅadowaÄ formuÅÄ za pomocÄ kodu kreskowego",
        orderAlreadyAcquired: "ZamÃ³wienie zostaÅo juÅ¼ nabyte, naleÅ¼y je najpierw zwolniÄ",
        orderCreated: "ZamÃ³wienie zostaÅo wysÅane pomyÅlnie",
        passwordIsNotUnique: "Stare hasÅo musi rÃ³Å¼niÄ siÄ od nowego.",
        printCannotBeCarriedOut: "Nie moÅ¼na wykonaÄ drukowania, poniewaÅ¼ nazwa drukarki jest nieprawidÅowa.",
        problemWithFileExport: "Niestety wystÄpiÅ problem podczas zapisywania archiwum dziennika.",
        productFileWarning: "Plik produktu jest dostÄpny tylko online.",
        productNotLicensed: "Produkt nie jest licencjonowany",
        rccDefaultMessage: "WystÄpiÅ nieoczekiwany bÅÄd podczas ostatniej akcji RCC",
        rccError: "BÅÄd RCC",
        rccNeedRestart: "Uruchom ponownie RCC",
        restoredSettings: "Ustawienia zostaÅy przywrÃ³cone.",
        revokedLicense: "Licencja zostaÅa cofniÄta",
        runningOutOfSpace: "KoÅczy siÄ wolne miejsce na komputerze.",
        savedFormulaToHistory: "Receptura zostaÅa pomyÅlnie zapisana.",
        savedLogArchive: "Archiwum dziennikÃ³w zostaÅo pomyÅlnie zapisane w twoim katalogu.",
        scanning: "Trwa skanowanie",
        serverError: "BÅÄd serwera",
        setClientIdentifier: "ProszÄ ustawiÄ identyfikator klienta",
        showLess: "PokaÅ¼ mniej",
        showMore: "PokaÅ¼ wiÄcej",
        spectroIsDisconnecting: "Spectro siÄ rozÅÄcza, proszÄ czekaÄ",
        spectroIsNotConnected: "W tej chwili Twoje spectro NIE JEST PODÅÄCZONE. SprawdÅº konfiguracjÄ RCC.",
        spectroIsNotSelected: "Twoje spectro NIE jest obecnie wybrane. SprawdÅº konfiguracjÄ RCC.",
        tmcNotAvailable: "%{tmc} is not available. Please check your %{collector}.",
        tmcNotConnected: "%{tmc} is not connected. Please start your %{collector} and restart server.",
        unknownError: "Nieznany bÅÄd: %{0}",
        userAlreadyLoggedIn: "JesteÅ juÅ¼ zalogowany!",
        versionNotAllowedByLicense: "Software version is too new and is not allowed for your license.",
        webApiConnectionError: "Nie moÅ¼na poÅÄczyÄ siÄ z serwerem Web Api",
        webApiInternalError: "BÅÄd wewnÄtrzny serwera Web Api",
        webApiInvalidUser: "Niepoprawny uÅ¼ytkownik serwera Web Api",
        webApiNoLicenseAvailable: "Serwer Web Api nie jest dostÄpna licencja",
        wrongDataSaved: "Wrong data was saved to XML file in the %{0} folder.",
        wrongHelpInput: "ZÅy format wejÅcia %{0}.",
        wrongRccVersion: "SprawdÅº wersjÄ swojego konta RCC. TwÃ³j klient jest zgodny tylko z RCC %{0}."
    },
    footer: {
        aboutApplication: "O aplicacji",
        activeUser: "Aktywny uÅ¼ytkownik",
        logOut: "Wyloguj",
        machineErrors: "BÅÄdy maszyny"
    },
    formulaProperties: {
        exterior: "Exterior",
        interior: "Interior",
        invalid: "Invalid",
        solvent: "Solvent based",
        universal: "Universal",
        water: "Water based"
    },
    formulaSettings: {
        allUnits: "Wszystkie jednostki dostÄpne w bazie danych",
        allowCustomFormulas: "Zezwalaj na formuÅy niestandardowe",
        allowCustomPackageSize: "Zezwalaj na niestandardowy rozmiar opakowaÅ",
        allowFormulaAutomaticNaming: "Zezwalaj na automatyczne nadawanie nazw",
        automaticNaming: "Automatyczne nazewnictwo formuÅ",
        basePanelSize: "Ustaw rozmiar panelu bazy",
        bippPanelSize: "Ustaw rozmiar bazy w panelu opakowania produktu",
        blendColorNameAndCode: "Blend color name and color code",
        buttonBellowMoreInfo: "Show button below formula notes",
        buttonInColorantPanel: "Show button in Colorants panel",
        colorCodePrimary: "Color code as primary",
        colorPanel: "Paleta kolorÃ³w",
        colorPreviewAsImage: "PodglÄd koloru jako obraz",
        colorPreviewResizable: "Resizable color preview",
        competitiveColorSearch: "Konkurencyjne wyszukiwanie kolorÃ³w",
        customFormula: "Custom formula",
        customFormulaForMasterProduct: "Allow create custom formulas for master product",
        customFormulaForMasterProductDefault: "Checked by default",
        customFormulas: "Niestandardowe formuÅy",
        customPackageSettingsUnitGrav: "Custom package settings gravimetric unit",
        customPackageSettingsUnitVol: "Custom package settings volumetric unit",
        customPackageSize: "Niestandardowy rozmiar opakowania",
        customUnits: "Wybierz jednostki niestandardowe",
        dropDownCalculate: "Expand the drop down menu to the height of the window",
        editColorants: "Edytuj koloranty",
        editColorantsAllowed: "Zezwalaj na edycjÄ kolorantÃ³w",
        fandeckPanelSize: "Ustal rozmiar panelu wzornika kolorÃ³w",
        favoriteFormulas: "Ulubione formuÅy",
        formulaColorPreview: "PodglÄd koloru formuÅy",
        formulaDataSettings: "Ustawienia danych formuÅy",
        formulaPanel: "Panel FormuÅy",
        formulaPanelSize: "Ustaw rozmiar panelu formuÅ",
        formulaSettings: "Ustawienia formuÅ",
        generateColorPreview: "Generate color preview",
        gravimetricOnly: "Tylko jednostki grawimetryczne",
        hideAlternativeFormulas: "Hide alternative formulas",
        hideFormulaProperties: "Hide formula properties",
        hideHistoricalFormulas: "Hide historical formulas",
        imagesLocal: "UÅ¼ywaj tylko obrazu z lokalnej bazy danych",
        imagesOnline: "Przede wszystkim sprÃ³buj otworzyÄ obraz online, jeÅli siÄ nie powiedzie, otwÃ³rz obraz lokalny",
        infoPanelResizable: "Resizable more info panel",
        numberOfColorants: "Number of shown colorants",
        orderByDistance: "Order of search results by the distance",
        productDependent: "Jednostka zaleÅ¼y od wybranego produktu",
        productFilesDialog: "PokaÅ¼ okno dialogowe, aby otworzyÄ plik lokalny lub plik online",
        productFilesLocal: "UÅ¼ywaj tylko plikÃ³w produktÃ³w z lokalnej bazy danych",
        productFilesOnline:
            "W pierwszej kolejnoÅci sprÃ³buj otworzyÄ plik produktu online, jeÅli siÄ nie powiedzie, otwÃ³rz plik lokalny",
        productPanelSize: "Ustaw rozmiar panelu produktu",
        searchPanelQuickSelect: "Szybki wybÃ³r",
        setAdditionalFormulaPanel: "Ustaw dodatkowy panel formuÅy",
        setCompetitiveColorSearch: "WÅÄcz konkurencyjne wyszukiwanie w kolorze",
        setInitialFormulaPanel: "Ustaw poczÄtkowy panel formuÅy",
        setMaxToleranceForCompetitiveColors: "Ustaw maksymalnÄ tolerancjÄ dla konkurencyjnego wyszukiwania kolorÃ³w",
        setNumberOfCompetitiveColors:
            "Set numbUstaw dostÄpnoÅÄ tolerancji dla konkurencyjnego wyszukiwania kolorÃ³wer of competitive colors",
        setSearchPanel: "Ustaw panel wyszukiwania",
        setVisibilityAndOrder: "Ustaw widocznoÅÄ i kolejnoÅÄ rÃ³Å¼nych danych formuÅ",
        setVisibleUnit: "Ustaw widoczne jednostki",
        showColorPreview: "PokaÅ¼ podglÄd kolorÃ³w",
        showInFormulaStatusPanel: "Show in formula status panel",
        showInMoreInfoPanel: "Show in formula notes",
        sorting: "Colorant panel sorting",
        useBase: "UÅ¼yj elementu wyboru dla podstawy",
        useBaseInProductPackage: "UÅ¼yj elementu wyboru jako podstawy w pakiecie produktÃ³w",
        useColorCode: "Use color code",
        useColorName: "Use color name",
        useFandeckGroups: "Use fandeck groups",
        useProduct: "UÅ¼yj elementu wyboru dla produktu",
        useProductCode: "UÅ¼yj kodu produktu",
        useProductGroups: "UÅ¼yj grup produktÃ³w",
        volumetricOnly: "Tylko jednostki objÄtoÅciowe"
    },
    general: {
        accepted: "Accepted",
        active: "Ostatnia aktywnoÅÄ",
        actual: "Rzeczywisty",
        actualLevel: "Aktualny poziom",
        add: "Dodaj",
        addColorant: "Dodaj barwnik",
        addColorantForPackage: "Dodaj barwnik do opakowania",
        addFile: "Dodaj plik",
        all: "Wszystko",
        amount: "IloÅÄ",
        applyNow: "Apply now",
        attachments: "ZaÅÄczniki",
        automaticCorrection: "Automatic correction",
        automatically: "Automatycznie",
        available: "Available",
        back: "Wstecz",
        base: "Baza",
        baseInProductPackage: "Baza w produkcie i opakowaniu",
        batchNumber: "Batch number",
        bottom: "Dolny",
        buildingSite: "Building site",
        calculate: "Oblicz",
        can: "Puszka",
        canSize: "Rozmiar pyuszki",
        cancel: "Anuluj",
        canister: "Kanister",
        canisterId: "ID kanistra",
        canisterIndex: "Indeks kanistra",
        canisters: "Kanistry",
        cap: "Czapka",
        capacity: "PojemnoÅÄ",
        channels: "KanaÅy",
        choose: "WybieraÄ",
        city: "Miasto",
        clean: "Czysty",
        clear: "WyczyÅÄ",
        client: "Klient",
        close: "Zamknij",
        closeAll: "Close all",
        collapseAll: "ZwinÄÄ wszystkie",
        color: "Kolor",
        colorCode: "Kod koloru",
        colorFile: "Colorfile",
        colorName: "Nazwa koloru",
        colorPreview: "PodglÄd kolorÃ³w",
        colorant: "Kolorant",
        colorantBatchNumber: "Colorant Batch number",
        colorantPackage: "Opakowanie kolorantu",
        colorants: "Koloranty",
        colors: "Colors",
        company: "Firma",
        competitiveColor: "Competitive color",
        confirm: "PotwierdÅº",
        confirmDeletion: "Czy na pewno chcesz trwale usunÄÄ ten element?",
        confirmHelpSettings: "Czy na pewno chcesz zapisaÄ formularz i pozostawiÄ pola puste?",
        connect: "PoÅÄcz",
        continue: "Kontynuuj",
        correction: "Correction",
        country: "Kraj",
        created: "Utworzony",
        creationDateOf: "Creation date of",
        criticalLevel: "Poziom krytyczny",
        currency: "Waluta",
        currentBatchNumber: "Current batch number",
        currentUfiCode: "Current UFI code",
        custom: "Niestandardowy",
        customData: "Custom data",
        customFandeck: "WÅasny wzornik",
        customFormula: "Custom formula",
        customPackage: "Niestandardowy",
        customPackageSettings: "Custom package settings",
        customer: "Klient",
        customerVersion: "Wersja klienta",
        customers: "Klienci",
        database: "Baza danych",
        date: "Data",
        default: "Default",
        delete: "UsuÅ",
        deleteImportedData: "Delete imported records",
        delta: "Delta",
        description: "Opis",
        disconnect: "RozÅÄczyÄ siÄ",
        discount: "Upust",
        discover: "OdkryÄ",
        dispense: "Dozowanie",
        dispensing: "Dozowanie",
        doNotShowAgain: "Nie pokazuj ponownie tej wiadomoÅci.",
        downloadingFile: "Pobieranie plikÃ³w",
        edit: "Edytuj",
        email: "Email",
        enabled: "WÅÄczone",
        error: "BÅÄd",
        expandAll: "RozwiÅ wszystkie",
        exportData: "Eksportuj dane",
        exportPdf: "Eksportuj PDF",
        fan: "Wentylator",
        fandeck: "Wzornik",
        fandeckCode: "Fandeck code",
        fandeckName: "Nazwa wzornika",
        fandecks: "Wzroniki",
        favorite: "Ulubiony",
        fileTransfer: "File transfer",
        filling: "WypeÅnienie",
        fillingDate: "Data wypeÅnienia",
        find: "ZnajdÅº",
        finish: "Koniec",
        finishedCorrection: "Finished correction",
        formula: "FormuÅa",
        formulas: "Formulas",
        frontdesk: "Panel poczatkowy",
        getQrCode: "Uzyskaj kod QR",
        gravimetric: "Gravimetric",
        historical: "Historical",
        history: "Historia",
        hours: "Hou.",
        id: "ID",
        images: "Obrazy",
        in: "In",
        index: "Indeks",
        insertBarcode: "ProszÄ wstawiÄ kod kreskowy",
        install: "Instaluj",
        installed: "Zainstalowano",
        instructions: "Instrukcje",
        internalNote: "Internal note",
        interval: "Interval",
        ip: "adres IP",
        itemNumber: "Item no.",
        itemXOfY: "Item %{x}/%{y}",
        itemsCount: "Items count",
        later: "Later",
        limit: "Limit",
        load: "ZaÅaduj",
        loadFormula: "Load formula",
        localVersion: "Wersja lokalna",
        machine: "Maszyna",
        manualCorrection: "Manual correction",
        manually: "RÄcznie",
        margin: "Margines",
        markup: "Znacznik",
        matching: "Matching",
        matchingFormula: "Matching formula",
        maxLevel: "najwyÅ¼szy poziom",
        maxValue: "Maksymalna wartoÅÄ",
        maximum: "Maksymalny",
        mayTakeAWhile: "This may take a while",
        measured: "Measured",
        metamarism: "Metameryzm",
        minimum: "Minimum",
        minutes: "Min.",
        missingItem: "BrakujÄcy element",
        missingRequiredItems: "NaleÅ¼y wypeÅniÄ wszystkie wymagane pozycje (oznaczone gwiazdkÄ)",
        modified: "Modified",
        modifiedAutomaticCorrection: "Target color correction",
        modifiedCustomFormula: "Modified custom formula",
        modifiedStandardFormula: "Modified standard formula",
        moduleChange: "Module change",
        more: "WiÄcej",
        moreInfo: "WiÄcej informacji",
        moveDown: "PrzesuÅ w dÃ³Å",
        moveUp: "PrzesuÅ do gÃ³ry",
        myOrders: "Moje zamÃ³wienia",
        name: "Nazwa",
        nameTitle: "Nazwa",
        new: "Nowy",
        next: "Dalej",
        no: "Nie",
        noColorantsAvailable: "Brak dostÄpnych barwnikÃ³w",
        noFormulas: "Nie ma jeszcze formuÅ",
        noPricesAvailable: "Brak dostÄpnych cen",
        nominalAmount: "Kwota nominalna",
        notAvailable: "NiedostÄpne",
        note: "Uwaga",
        numberOfCanisters: "Liczba kanistrÃ³w",
        numberOfItemCount: "Number of '%{item}': %{count}",
        numberOfLabels: "Liczba etykiet",
        numberOfPackages: "IloÅÄ opakowaÅ",
        off: "WyÅÄcz",
        ok: "OK",
        on: "WÅÄcz",
        onFocus: "On focus",
        open: "OtwÃ³rz",
        operator: "Operator",
        options: "Opcje",
        order: "Order",
        other: "Inny",
        otherError: "Inny bÅÄd",
        out: "Out",
        overwrite: "Overwrite",
        package: "Pakiet",
        packagePreview: "PodglÄd pakietu",
        partialUpdates: "Partial updates",
        phone: "Telefon",
        pleaseWait: "ProszÄ czekaÄ",
        previous: "Previous",
        price: "Cena",
        priceGroup: "Gupa cen",
        print: "WydrukowaÄ",
        printTask: "Wydrukuj zadanie",
        processingStep: "Processing %{step}",
        product: "Produkt",
        productCode: "Kod produktu",
        productName: "Nazwa produktu",
        products: "Produkty",
        pump1: "Pompa 1",
        pump2: "Pompa 2",
        purchasePrice: "Cena zakupu",
        purge: "OczyÅciÄ",
        qualityControl: "Quality control",
        quantity: "IloÅÄ",
        quantityQty: "QTY",
        quickTint: "Szybkie dozowanie",
        rccIsNotAvailable: "RCC jest niedostÄpny",
        rccIsNotConnected: "RCC nie jest podÅÄczony",
        rccNotLicensed: "RCC nie jest licencjonowany",
        reconnect: "Na nowo poÅÄczyÄ",
        refill: "UzupeÅnij",
        refillManualLevelCorrection: "Manual correction",
        reformulation: "Reformulation",
        reloadTab: "Reload Tab",
        reset: "Reset",
        restart: "Uruchom ponownie",
        restore: "Restore",
        retint: "Ponowne barwienie",
        revision: "Rewizja",
        safetySheet: "Karta Charakterystyki",
        save: "ZapisaÄ",
        saveAs: "Zapisz jako",
        saveToDispensingHistory: "Zapisz w historii",
        searchResult: "Search result",
        searching: "Searching",
        seconds: "Sec.",
        select: "Select",
        selectAll: "Zaznacz wszystko",
        selectChannels: "Select channels",
        selectColumns: "Select columns to work with",
        selectXFirst: "Select %{item} first",
        sellPrice: "Cena sprzedaÅ¼y",
        settings: "Ustawienia",
        shelf: "PÃ³Åka",
        showItem: "Show %{item}",
        showOptions: "Show another options",
        size: "Rozmiar",
        skip: "PominÄÄ",
        smartPurge: "Inteligentne czyszczenie",
        softwareRestartInSeconds: "%{software} will be automatically restarted in %{seconds} seconds",
        sortResults: "Sort results",
        spectro: "Spectro",
        standardFormula: "Standard formula",
        status: "Status",
        street: "Ulica",
        sum: "Sum",
        summary: "streszczenie",
        sync: "Synchronizuj",
        technicalSheet: "Karta techniczna ",
        templates: "Szablony",
        threshold: "Threshold",
        ticketing: "Ticketing",
        tintometricSystem: "Tintometric system",
        toDispenseOrders: "Aby dozowaÄ",
        top: "GÃ³ra",
        total: "CaÅkowity",
        totalAmount: "Total amount",
        totalBaseAmount: "Total base amount",
        totalColorantAmount: "Total colorants amount",
        type: "Type",
        ufiCode: "Kod UFI",
        ufiThreshold: "PrÃ³g UFI",
        unableToSynchronize: "Unable to synchronize",
        undefined: "Undefined",
        unit: "Jednostka",
        units: "Jednostki",
        unknown: "Unknown",
        update: "Aktualizuj",
        updated: "Zaktualizowano",
        user: "UÅ¼ytkownik",
        value: "WartoÅÄ",
        vat: "VAT",
        verified: "Verified",
        version: "Wersja",
        versionId: "ID wersji",
        versionStructure: "Struktura wersji",
        volumetric: "Volumetric",
        warning: "OstrzeÅ¼enie",
        warningLevel: "Poziom ostrzegawczy",
        withoutName: "(bez nazwy)",
        workingProperly: "Working properly",
        yes: "tak",
        zoom: "Zoom"
    },
    help: {
        autotasks: {
            brushMaintenance:
                "Ustaw to zadanie automatyczne tak, aby %{name} Å¼ÄdaÅ dziaÅania automatycznego czyszczenia pojemnika szczotki w okreÅlonym czasie. Operator dozownika musi rÄcznie wyjÄÄ, wyczyÅciÄ, a nastÄpnie zwrÃ³ciÄ pojemnik ze szczotkami.",
            capMaintenance:
                "Ustaw to zadanie automatyczne tak, aby %{name} Å¼ÄdaÅ akcji czyszczenia nasadki automatycznie w okreÅlonym czasie. Operator dozownika musi wyczyÅciÄ autocap rÄcznie po jego otwarciu.",
            cleanAll:
                "Ustaw to zadanie automatyczne, aby dozownik automatycznie wykonywaÅ czyszczenie wszystkich kanaÅÃ³w w okreÅlonym czasie.",
            cleanChannels:
                "Ustaw to zadanie automatyczne, aby dozownik automatycznie wykonywaÅ czynnoÅÄ czyszczenia okreÅlonych kanaÅÃ³w w okreÅlonym czasie.",
            computerReboot:
                "Ustaw to zadanie automatyczne, aby komputer byÅ ponownie uruchamiany automatycznie w okreÅlonym czasie.",
            computerShutdown:
                "Ustaw to zadanie automatyczne, aby komputer wyÅÄczaÅ siÄ automatycznie o okreÅlonej godzinie.",
            dispenserCleaning:
                "Ustaw to zadanie automatyczne tak, aby %{name} Å¼ÄdaÅ dziaÅania automatycznego czyszczenia dozownika w okreÅlonym czasie. Operator dozownika musi rÄcznie wyczyÅciÄ maszynÄ szmatkÄ.",
            humidifierWaterLevelMaintenance:
                "Ustaw to zadanie automatyczne tak, aby %{name} Å¼ÄdaÅ akcji automatycznego napeÅniania nawilÅ¼acza w okreÅlonym czasie. Operator dozownika musi rÄcznie sprawdziÄ i uzupeÅniÄ wodÄ w nawilÅ¼aczu.",
            purgeAll:
                "Ustaw to zadanie automatyczne, aby dozownik wykonywaÅ czynnoÅÄ polegajÄcÄ na automatycznym oprÃ³Å¼nieniu wszystkich kanaÅÃ³w w okreÅlonym czasie.",
            purgeChannels:
                "Ustaw to zadanie automatyczne, aby dozownik wykonywaÅ czynnoÅÄ polegajÄcÄ na automatycznym oprÃ³Å¼nianiu okreÅlonych kanaÅÃ³w w okreÅlonym czasie.",
            recirculateAll:
                "Ustaw to zadanie automatyczne, aby dozownik automatycznie wykonywaÅ recyrkulacjÄ wszystkich kanaÅÃ³w w okreÅlonym czasie.",
            recirculateChannels:
                "Ustaw to zadanie automatyczne, aby dozownik automatycznie wykonywaÅ recyrkulacjÄ okreÅlonych kanaÅÃ³w w okreÅlonym czasie.",
            refillAll:
                "Ustaw to %{name} zadanie automatyczne, aby dozownik wykonywaÅ czynnoÅÄ polegajÄcÄ na automatycznym napeÅnianiu wszystkich kanaÅÃ³w w okreÅlonym czasie.",
            refillCanisters:
                "Ustaw to %{name} zadanie automatyczne, aby dozownik automatycznie wykonywaÅ czynnoÅÄ uzupeÅniania okreÅlonych kanaÅÃ³w w okreÅlonym czasie.",
            smartPurgeAll:
                "Ustaw to zadanie automatyczne, aby dozownik wykonywaÅ akcjÄ inteligentnego czyszczenia wszystkich kanaÅÃ³w automatycznie w okreÅlonym czasie. Czyszczenie zostanie przeprowadzone, jeÅli nie zostanÄ speÅnione zasady inteligentnego czyszczenia.",
            smartPurgeChannels:
                "Ustaw to zadanie automatyczne, aby dozownik automatycznie wykonywaÅ akcjÄ inteligentnego czyszczenia okreÅlonych kanaÅÃ³w w okreÅlonym czasie. Czyszczenie zostanie przeprowadzone, jeÅli nie zostanÄ speÅnione zasady inteligentnego czyszczenia.",
            stirAll:
                "Ustaw to zadanie automatyczne, aby dozownik wykonywaÅ Å¼Ädanie automatycznego miksowania wszystkich kanaÅÃ³w w okreÅlonym czasie.",
            stirCanisters:
                "Ustaw to zadanie automatyczne, aby dozownik wykonywaÅ Å¼Ädanie dziaÅania polegajÄcego na automatycznym miksowaniu okreÅlonych kanaÅÃ³w w okreÅlonym czasie.",
            switchPlateMaintenance:
                "Ustaw to zadanie automatyczne tak, aby %{name} Å¼ÄdaÅ dziaÅania automatycznego czyszczenia pÅytki przeÅÄcznika w okreÅlonym czasie. Operator dozownika musi rÄcznie zdjÄÄ, wyczyÅciÄ, a nastÄpnie zwrÃ³ciÄ pÅytkÄ przeÅÄcznika."
        },
        colorantBatchNumber: {
            batchNumberByPercentage:
                "The Batch number which prevails is used for printing considering its actual amount in the canister. Navigate to Canister settings to define the threshold for each canister.",
            batchNumberFromLastFilling:
                "The Batch from the last refill given by the operator is used for printing regardless the refilled amount.",
            enableBatchNumber: "With this setting on, refilled colorant batches are tracked."
        },
        connection: {
            add: "UmoÅ¼liwia rÄczne dodanie nowego serwera, jeÅli nie moÅ¼na go wykryÄ za pomocÄ funkcji Discover.",
            clientIdentifier:
                "To ustawienie umoÅ¼liwia identyfikacjÄ tego klienta, jeÅli do jednego serwera jest podÅÄczonych wiÄcej klientÃ³w.",
            disconnect:
                "Informacje o aktualnie uÅ¼ywanym serwerze. Przycisk rozÅÄczenia pozwala opuÅciÄ ten serwer i przeÅÄczyÄ siÄ na inny, jeÅli jest dostÄpny.",
            discover: "Wykrywa, czy w sieci sÄ dostÄpne inne serwery.",
            dropServers: "Usuwa wszystkie wczeÅniej wykryte serwery z listy.",
            dropServersNotAvailable: "Brak dostÄpnego serwera",
            edit: "UmoÅ¼liwia rÄcznÄ edycjÄ juÅ¼ znalezionego serwera.",
            editDisabled: "Nie wybrano serwera."
        },
        continue: "Do you really want to continue?",
        driverSettings: {
            alfaRestApi: {
                host: "Wpisz nazwÄ hosta komputera lub adres IP komputera.",
                machineType: "Dotyczy wszystkich maszyn Alfa. Windows oraz Linux."
            },
            corobDsProxy: {
                machineType:
                    "ObowiÄzuje dla generacji Slave (D200, D600 ..), 4G (First One) i 5G (EvoFlx). Musi byÄ zainstalowany DspProxy. Tylko Windows."
            },
            corobEvoDriver: {
                machineType: "ObowiÄzuje dla generacji 5G (EvoFlx). NaleÅ¼y zainstalowaÄ EVOservice. Windows oraz Linux."
            },
            corobFlex500LLD: {
                dispenserConfigurationFile: "Wybierz plik konfiguracyjny dozownika. DomyÅlne ustawienie wstÄpne.",
                hldRootDir: "Wybierz gÅÃ³wny folder HLD. DomyÅlne ustawienie wstÄpne.",
                machineType:
                    "Valid for Corob Flex (500, 520, 540) = former Lenteq. HLD must be installed. Windows only."
            },
            corobNextDriver: {
                machineType:
                    "Valid for generations Slave (D200, D600..), 4G (First One) and 5G (EvoFlx). NextDriver must be installed. Linux only."
            },
            dromontDDrv: {
                databasePath: "Path to the database file with calibration data. Default pre-set.",
                driverPath: "Path to the driver (D_DRV.exe). Default pre-set.",
                machineType:
                    "Indirect dispenser communication via set paths. Valid for generations V1 and V2. D_SET must be installed. Windows as well as Linux.",
                resultPath: "Path to the result file created after operation is over. Default pre-set.",
                serviceSoftwarePath: "Path to the Dromont service software (D_SET.exe). Defalut pre-set."
            },
            dromontDirect: {
                machineType:
                    "Direct dispenser communication. Valid for generations V1 and V2. D_SET must be installed. Windows as well as Linux.",
                rootDir: "Select the main Dromont folder"
            },
            dromontMisura: {
                driverPath:
                    "Path to the driver (MisuraRetail.exe) might change based on the Misura Retail version. Default pre-set.",
                extensionPath: "Path to communication file for service actions.",
                formulaPath: "Path to communication file for dispensing.",
                machineType: "Valid for generation V3. Dromont Misura must be installed. Windows only."
            },
            fastAndFluidIDD: {
                machineType: "Valid for all F&F machines. Windows only.",
                path: "Supported are IDD2 (HA 450, HA 650, X-smart, etc.) - must be licensed, IDD3 (HP 500, etc.), IDD4 (HA 180, HA 480, HA 680, Xprotint, etc.)"
            },
            fastAndFluidUIDD: {
                host: "Type in the computer host name or computer IP address.",
                machineType: "Valid for all F&F machines. Windows as well as Linux.",
                password: "Type in the user password.",
                port: "Select the port number.",
                user: "Type in the user name."
            },
            heroPCPDriver: {
                machineType: "Valid for all Hero machines. Windows only."
            },
            italtinto: {
                machineType: "Valid for all Italtinto machines. Wcal or ItaltintoCal must be installed. Windows only.",
                path: "Path to the adjusted Italtinto configuration file."
            },
            manualAdvanced: {
                machineType: "Valid for all manual machines, canister support included. Windows as well as Linux.",
                path: "Path to the configuration file with data about the dispenser and canisters."
            },
            manualSimple: {
                machineType: "Valid for all manual machines. Windows as well as Linux.",
                path: "Path to the configuration file with data about the dispenser."
            },
            none: {
                machineType: "No dispenser driver is selected."
            },
            santintColorLink3: {
                machineType: "Valid for all Santint machines. Windows only."
            },
            simulation: {
                machineType: "Valid for simulation dispenser if there is no real dispenser connected to the computer.",
                path: "Path to the simulation configuration file which must be in accord with the inserted database."
            },
            udcp: {
                machineType: "Dozownik UDCP"
            }
        },
        environment: {
            activeServerPlugins: "The overview of additional software plugins.",
            allowAutoCloseTab:
                "With the setting on, each formula tab will be closed automatically after the dispensing process has been finished.",
            allowAutomaticClientStart:
                "With this setting on, %{name} will start automatically after the start of the computer.",
            allowAutomaticPrint:
                "Etykieta zostanie wydrukowana automatycznie. Wymaga dalszych ustawieÅ dotyczÄcych drukowania przed wydaniem, po wydaniu lub w obu przypadkach.",
            allowBuildingSitePanel: "On Formula Panel, building site panel will be available.",
            allowCustomers: "W panelu Formula sekcja klientÃ³w bÄdzie dostÄpna.",
            allowDispensing: "Na panelu FormuÅy przycisk dozowania zostanie aktywowany.",
            allowFileTransfer:
                "Po wÅÄczeniu tego ustawienia dostÄpny jest automatyczny import i eksport danych przez transfer plikÃ³w.",
            allowFormulaModificationPanel: "On Formula Panel, Modification panel will be activated.",
            allowFormulaStatusPanel: "On Formula Panel, Status panel will be activated.",
            allowLight: "%{name} bÄdzie dostÄpny.",
            allowOrdering: "W panelu FormuÅa zostanie aktywowany przycisk ZamÃ³w.",
            allowPricing:
                "On Formula panel, the prices can be used. Visibility of prices is set in Available Prices. The prices are set in Price Settings.",
            allowProductPreviewImage: "ZdjÄcie produktu pojawi siÄ podczas dozowania.",
            allowQualityControl: "Quality control will be activated.",
            allowSearchCheaperColors: "W Panelu FormuÅa bÄdzie dostÄpna funkcja wyszukiwania taÅszych kolorÃ³w.",
            allowSoundNotification:
                "Powiadomienie dÅºwiÄkowe o zamÃ³wieniu odtwarza melodiÄ muzycznÄ po otrzymaniu zamÃ³wienia.",
            allowSpectro: "Sekcja Spectro bÄdzie dostÄpna.",
            allowTabs: "With this setting on, working with multiple tabs simultaneously is available.",
            applyZoom:
                "Zoom powiÄksza lub zmniejsza rozdzielczoÅÄ. SkrÃ³ty klawiaturowe CTRL + i CTRL - majÄ rÃ³wnieÅ¼ zastosowanie.",
            automaticLogout: "Set after how many minutes the automatic logout should be activated.",
            availableDatabases:
                "The settings enables to switch between databases if there are more than one available.",
            backupLocalDB: "Exports the local databse. The exported file can be used as database backup.",
            barcodeTesting:
                "The barcode testing environment serves to check the correctness of the scanned barcode by comparing it with the barcodes inserted in the database.",
            customBanner: "Set your own logo or banner and its position.",
            customCurrencyFormat:
                "Custom currency format can override default currency format based on selected language. ",
            customDateFormat: "Custom date format can override default date format based on selected language.",
            customNumberFormat: "Custom numer format can override default numer format based on selected language.",
            customTimeFormat: "Custom time format can override default time format based on selected language.",
            defaultPrinter:
                "Wybrana drukarka bÄdzie uÅ¼ywana podczas drukowania etykiet, chyba Å¼e zostanie zmieniona w oknie Opcje drukarki.",
            defaultTemplate:
                "Wybrany szablon bÄdzie uÅ¼ywany podczas drukowania etykiet, chyba Å¼e zostanie zmieniony w oknie Opcje drukarki.",
            deleteImportedData:
                "Deletes the previously imported custom data. The data can be imported again after deletion.",
            diskSpaceNotification: "Sprawdza dostÄpne miejsce na dysku i powiadamia w przypadku braku miejsca.",
            dispensingNotes: "Na panelu Formula dostÄpna bÄdzie sekcja notatek dozujÄcych.",
            downloadListEmpty: "No downloads in progress",
            enableVirtualKeyboard: "W %{name} dostÄpna bÄdzie wirtualna klawiatura.",
            exportLocalSettings: "Exports the local settings of this computer.",
            exportStaticSql:
                "Exports the local settings of this computer. The exported file can be used to create a database with this setup.",
            exportTranslationKeys:
                "Export the newest translations and after translating, send them by email to your software supplier to have them imported.",
            favoriteButton: "Click to add the formula as favorite",
            formulaNotes: "W panelu FormuÅa dostÄpna bÄdzie sekcja notatek z formuÅami.",
            helpSettings: "Informacje sÄ widoczne w sekcji Pomoc na panelu szybkiego dostÄpu.",
            importCustomData: "Imports the local custom data based on the selected format.",
            importExcelFile: "Import the excel file with data to be added to database.",
            importsLocalSettings: "Imports the local settings of this computer.",
            internalNote: "On Formula panel, internal note section will be accessible.",
            lockComputer:
                "The settings ensures that the environment of %{name} cannot be left - it enables the ultimate kiosk mode experience. Only applicable for Windows.",
            maxNumberTabs: "Limit kart okreÅla, ile kart formuÅy moÅ¼na otworzyÄ jednoczeÅnie.",
            memoryTabs: "Zezwalaj na ponowne otwieranie ostatnio otwartych kart po uruchomieniu oprogramowania.",
            printAfterDispensing:
                "Ustawienie wymaga informacji o tym, ile kopii etykiet naleÅ¼y wydrukowaÄ po zakoÅczeniu procesu wydawania.",
            printAsImage:
                "TlaÄ ako obrÃ¡zok pomÃ¡ha rieÅ¡iÅ¥ problÃ©my pri beÅ¾nom spÃ´sobe tlaÄe. NepouÅ¾Ã­vajte, ak funguje beÅ¾nÃ¡ tlaÄ sprÃ¡vne. Funguje iba pre Linux.",
            printBeforeDispensing:
                "Ustawienie wymaga informacji o tym, ile kopii etykiet naleÅ¼y wydrukowaÄ przed procesem wydawania.",
            printEnabled:
                "This setting enables using printer with the software. Additional settings are in Print Settings.",
            printOnRequest: "W panelu FormuÅa przycisk Drukuj zostanie aktywowany.",
            printTaskVariable: "The print task is processed only if given print variable is available in print data",
            quickTintTemplate: "ZvolenÃ¡ Å¡ablÃ³na bude pouÅ¾itÃ¡ pri tlaÄenÃ­ Å¡tÃ­tkov z rÃ½chleho tÃ³novania.",
            restoreLocalSettings: "Restores the local settings of this computer.",
            runLightAtStartUp: "%{light} zostanie uruchomione zamiast %{name}.",
            screenSaverTimeout: "Set after how many minutes, the screensaver should be activated.",
            selectCustomDataFormat:
                "Select the format of the original data to be imported. Each format might require different additional files and settings.",
            setCustomHomeButton: "Przycisk Home w %{name} przekieruje do wybranego panelu.",
            setFts: "Fulltext search allows full-text formula searching (also from the middle of the word, etc.).",
            setKeyboardShortcuts: "Nie moÅ¼na ustawiÄ tego samego skrÃ³tu klawiaturowego dla dwÃ³ch rÃ³Å¼nych akcji.",
            setNumberOfDecimalPlaces: "ZaokrÄglenie okreÅla liczbÄ miejsc dziesiÄtnych barwnikÃ³w uÅ¼ytych w formule.",
            setOrderSearchParameters:
                "Wyszukiwanie zamÃ³wieÅ okreÅla, ktÃ³re parametry sÄ uÅ¼ywane podczas wyszukiwania wÅrÃ³d zamÃ³wieÅ. DostÄpne tylko w %{name}.",
            setOverwriteLastTab:
                "When choosing a new formula via global search whereas formula tab limit is reached, the last loaded formula tab will be overwritten by the new formula selection.",
            setSearchPanel: "Set your own visibility and order of items used when searching for a new formula.",
            setVisibilityAndOrder:
                "Wybrane elementy nawigacyjne bÄdÄ widoczne w panelu szybkiego dostÄpu. NajwyÅ¼sza pozycja tutaj okreÅla lewÄ pozycjÄ w panelu. Maksymalna dozwolona liczba elementÃ³w nawigacji wynosi 6.",
            setYourLanguage: "Zmiana jÄzyka wymaga ponownego uruchomienia oprogramowania.",
            settingsSearch: "Look up various settings if you are unsure where to find them.",
            showNewOrderNotifications:
                "Powiadomienie o zamÃ³wieniu to wyskakujÄce okienko informujÄce o otrzymaniu nowego zamÃ³wienia.",
            sorting:
                "W szybkim odcieniu moÅ¼na zamÃ³wiÄ kanistry wedÅug nazw barwnikÃ³w lub wedÅug numerÃ³w identyfikacyjnych kanistrÃ³w.",
            turnOnKioskMode: "Tryb kiosku na ukrytym pasku zadaÅ.",
            windowClosingRules:
                "Ustawienie decyduje, czy okno szybkiego odcienia zostanie zamkniÄte przed czy po rozpoczÄciu procesu dozowania."
        },
        formulaSettings: {
            additionalFormulaTab: "The setting decides which panel will be shown when opening a new formula tab.",
            allowCustomFormulas: "Zostanie aktywowane tworzenie i wyszukiwanie niestandardowych formuÅ.",
            allowCustomPackageSize: "W panelu FormuÅa aktywowana zostanie opcja niestandardowego rozmiaru pakietu.",
            allowEditingColorants:
                "W panelu FormuÅa zostanie aktywowany przycisk Edytuj kolorant (widoczny po wybraniu koloru).",
            alternativeFormulasPosition: "Defines how to access alternative formulas.",
            basePanelSize: "Ustaw rozmiar bazy na panelu FormuÅa",
            bippPanelSize: "Ustaw rozmiar bazy w opakowaniu produktu na panelu FormuÅa",
            blendColorNameAndCode:
                "The setting joins together the search fields for Color name and code to create one search field only.",
            color: "W panelu FormuÅa podglÄd kolorÃ³w bÄdzie jedynÄ widocznÄ informacjÄ.",
            colorCodePrimary: "Color code will be displayed first in the search field.",
            colorPreviewAsImage: "W panelu FormuÅa podglÄd koloru bÄdzie reprezentowany przez obraz.",
            colorPreviewResizable: "Allows to resize color preview panel.",
            colorantPanelLimit:
                "The settings sets the number of colorants that will be always visible before it hides under scroll bar.",
            colorantPanelOrderBy: "Formula panel can have the colorants ordered according to the names or by amounts.",
            customCanOption: "Choose which measurement units can be used for custom package size on Formula panel.",
            customCanSettingsUnit:
                "Choose which measurement unit can be used as default for custom package settings on Formula panel.",
            customFormulaForMasterProduct:
                "Defines whether the option âFormula for master productâ is displayed when saving custom formula",
            customFormulaForMasterProductDefault:
                "Defines whether the option âFormula for master productâ is checked by default",
            deleteConfirmation: "Enabling this setting will result in pop-ups to confirm deletion of an item.",
            dropDownCalculate:
                "The drop-down menu to select the formula you are looking for will extend to the bottom of the window.",
            fandeckGroups: "The setting enables hierarchy with fandeck groups if available in the database.",
            fandeckPanelSize: "Ustaw wzornik w panelu FormuÅy",
            favoriteFormulasInitial: "Po uruchomieniu %{name} pojawi siÄ panel Ulubione.",
            formulaAutomaticNaming:
                "A changed formula will be named automatically based on the performed colorant modifications.",
            formulaPanel: "Po otwarciu nowej karty pojawi siÄ panel FormuÅa.",
            formulaPanelInitial: "Po uruchomieniu %{name} pojawi siÄ panel FormuÅy.",
            formulaPanelSize: "Ustaw rozmiar formuÅy w panelu FormuÅa",
            formulaPropertiesPosition: "Defines how to access formula properties.",
            generateColorPreview:
                "With this setting on, the color preview will be generated automatically. The resulting preview is not accurate.",
            historicalFormulasPosition: "Defines how to access historical formulas.",
            image: "Na panelu Formula obraz produktu bÄdzie widoczny obok podglÄdu kolorÃ³w z moÅ¼liwoÅciÄ otwarcia panelu z dodatkowymi informacjami.",
            images: "Ustawienie definiuje ÅºrÃ³dÅo plikÃ³w graficznych.",
            infoPanelResizable: "Allows to resize more info panel.",
            initialFormulaTab: "The setting decides which panel will be shown after %{0} starts.",
            moreInfo:
                "W panelu FormuÅa panel informacyjny bÄdzie widoczny obok podglÄdu kolorÃ³w i podglÄdu obrazu produktu.",
            orderByDistance: "With this setting on, the result of color search is ordered by special distance metric.",
            productCode:
                "The setting enables to use product codes along with product names if available in the database.",
            productFiles: "Ustawienie okreÅla ÅºrÃ³dÅo plikÃ³w produktowych dostÄpnych w panelu FormuÅa.",
            productGroups: "Ustawienie wÅÄcza hierarchiÄ z grupami produktÃ³w, jeÅli sÄ dostÄpne w bazie danych.",
            productPanelSize: "Ustaw rozmiar produktu w panelu FormuÅa",
            searchNewFormula:
                "Po otwarciu nowej karty pojawi siÄ Wyszukaj nowÄ formuÅÄ (zawiera informacje o ostatnio wydanych formuÅach i ulubionych formuÅach).",
            searchNewFormulaInitial:
                "Po uruchomieniu %{name} pojawi siÄ Wyszukaj nowÄ formuÅÄ (zawiera informacje o ostatnio wydanych formuÅach i ulubionych formuÅach).",
            searchPanelFormulaItems: "At least one of the formula items must be selected.",
            searchPanelProductItems: "Only one of the product items can be selected.",
            searchPanelQuickSelect:
                "No need to press the load formula button. You will be redirected directly to main formula tab just after formula selection.",
            setCompetitiveColorSearch:
                "With this setting on, the feature of competitive color search in Color Palette and Formula panel (only for not available formulas) is available.",
            setFormulaInfoInPreview:
                "On Formula panel, the selected data type will be always visible in the color preview.",
            setFormulaPreview:
                "The setting changes the position and display of color preview, package image and info data about the color.",
            setFormulaRGBPreviewVisibleInformation:
                "W panelu FormuÅa wybrany typ danych bÄdzie zawsze widoczny w podglÄdzie kolorÃ³w.",
            setFormulaUnit:
                "W panelu FormuÅa to ustawienie decyduje, ktÃ³ra jednostka barwnika jest otwierana jako pierwsza po wybraniu koloru. Ma rÃ³wnieÅ¼ zastosowanie w Quick Tint.",
            setFormulaVisibilityAndOrder:
                "W panelu FormuÅa wybrane dane bÄdÄ widoczne w sekcji WiÄcej informacji (dotyczy tylko, jeÅli Ustaw podglÄd podglÄdu formuÅy w ustawieniu FormuÅa to Obraz lub WiÄcej informacji.",
            setMaxToleranceForCompetitiveColors:
                "Set the maximal Delta E (CIA 2000) tolerance for competitive color search.",
            setNumberOfCompetitiveColors:
                "Define how many competitive master colors should be offered after search. The defined number does not correspond to the number of results.",
            setVisibleUnit:
                "W panelu FormuÅa to ustawienie decyduje, ktÃ³re jednostki barwnika bÄdÄ widoczne po wybraniu koloru. Ma rÃ³wnieÅ¼ zastosowanie w Quick Tint.",
            showColorPreview:
                "Na panelu FormuÅa pokazuje maÅy podglÄd koloru obok nazwy koloru podczas wyszukiwania nowej formuÅy.",
            showSiblingProducts:
                "Defines whether the option âShow sibling productsâ is displayed when saving custom formula",
            useColorCode: "On Formula panel, shows the information about color code."
        },
        formulaValidation: {
            batchNumberInvalid: "Canister (%{colorants}) is filled with a defective batch of colorant.",
            batchNumberWarning: "Colorant (%{colorants}) with this batch number may be damaged.",
            bellowBaseLimit: "Sum of colorant amounts is below base limit.",
            checkColorantBaseRules: "The setting checks if used colorants and base can be used in this combination.",
            checkMinDosableAmount:
                "The minimal tintable amount is the smallest colorant amount which can be dispensed as recommended by the laboratory.",
            checkOverfill:
                "The setting checks if there is enough space in the can for the colorants immediately after the amounts are set.",
            checkTotalCntAmounts:
                "The setting checks if the limits for the minimal and maximal colorant amounts in product base package have been exceeted. These limits are defined in the database.",
            colorantBaseRules: "Colorant is not valid for selected base.",
            colorantMinAmount: "Colorant amount is below the minimal tintable amount.",
            dispensingWithErrorsEnabled:
                "If allowed, a warning message will appear in case of validation violations, but it will be possible to proceed to dispensing nonetheless.",
            invalidBatchNumber: "Colorant has invalid or defective batch number",
            overBaseLimit: "Sum of colorant amounts is over maximal tintable amount.",
            overfill: "Overfill has been detected.",
            unifyColorantBatchForMultipleCans:
                "If allowed, an info refill to max modal will appear when amount of colorant is bigger than maximum of canister and canister is not filled on maximum level.",
            warningConfirmBtn: "I know the risks, continue"
        },
        help: "Wsparcie",
        helpLink: "Centrum pomocy",
        helper: {
            automaticallyCheckForUpdates:
                "It will be automatically checked if there is any update available for %{name} or database in the given time interval.",
            automaticallyDownloadUpdates:
                "If an update is available, it will be downloaded automatically without having to confirm.",
            automaticallyInstallNewDatabases:
                "If a hitherto absent DB is sent, it will be installed as a new DB. Afterwards, the DB can be used.",
            automaticallyInstallUpdates:
                "If an update has been downloaded, it will be installed automatically without having to confirm.",
            canBrowseChangeLog: "When updating the software, the official %{name} changelog will be available to see",
            forceInstall: "The update will be installed by force.",
            installDuringNight: "The update will be installed during night if the computer is running."
        },
        licensing: {
            collect:
                "The logfiles will be downloaded to the selected location. The logfiles are required by the software supplied for bug analysis.",
            company: "The company which supplied the license.",
            computerID: "License identification to help the software supplier in case of required assistance.",
            email: "The email address of the license holder.",
            licenseUuid: "License identification to help the software supplier in case of required assistance.",
            name: "The name of the license holder.",
            openBugreport:
                "Please let us know if there is a bug in the software and send us a report with the bug description.",
            posInfoContactperson: "POS information about the owner to be printed on the label.",
            posInfoMachineInformation:
                "POS information about the dispenser to be printed on the label or recognized in the network.",
            posInfoPos: "POS information about the location to be printed on the label.",
            reactivation: "Reactivation or change of the current license.",
            refresh: "Downloads the newest license information.",
            refreshUnavailable: "License refresh unavailable because you are offline.",
            registrationContactperson: "Registration information to identify the owner of the license.",
            registrationMachineInformation: "Registration information to identify the dispenser of the license.",
            registrationPos: "Registration information to identify the location of the license.",
            versionScope: "The software expiration limits.",
            versionType: "The software product type."
        },
        machineIsBusy: "Errors cannot be reset as the machine is busy.",
        machineSettings: {
            allowManualColorantAddition:
                "JeÅli wymagana iloÅÄ barwnika przekracza maksymalnÄ iloÅÄ dozowania, ustawienie pozwala dodaÄ go rÄcznie po dozowaniu.",
            autotasks:
                "Zadania automatyczne to zdarzenia zwiÄzane z automatycznÄ konserwacjÄ maszyn i komputerÃ³w, ktÃ³re moÅ¼na ustawiÄ tak, aby byÅy wykonywane w okreÅlonym czasie lub odstÄpie czasu.",
            barcodeRefillValidation: "The setting turns on barcode validation on refill.",
            barcodeRefillValidationBaseAndColorant:
                "Barcode check is performed on canister and colorant package refilling.",
            barcodeRefillValidationColorant: "Barcode check is performed on colorant package refilling.",
            canisterBarcode:
                "The barcode is assigned to the canister in which the colorant is available. The barcode is necessary to ensure correct colorant refilling.",
            checkCanBeforeDispense: "Ustawienie dotyczy tylko symulacji Fast & Fluid.",
            checkOverfill:
                "Ustawienie sprawdza, czy w puszce jest wystarczajÄca iloÅÄ miejsca na barwniki przed dozowaniem.",
            currentlySelectedMachine: "Provides information about the currently selected machine.",
            dispenseInvalidColorants:
                "The setting allows to dispense colorants which are not defined in the machine configuration by prompting manual colorant addition.",
            dispenserConfigurationBackup: "Download and save the current machine configuration to maintain a backup.",
            dispensingLogic:
                "Dispensing logic types can ensure different behaviour for each canisters when there is more colorant to be dispensed than allowed or desired. Additional behavior is set in Dispensing Settings.",
            enableTmc: "Ustawienie umoÅ¼liwia wysyÅanie danych do TMC.",
            enableUserIdentification: "User has to log in before dispensing is allowed.",
            machineUnit: "Jednostka maszynowa okreÅla jednostkÄ miary barwnikÃ³w w pojemnikach.",
            minDispensedAmount:
                "Min. Dozowana iloÅÄ okreÅla, ile barwnika musi zostaÄ wydane, aby rozwaÅ¼yÄ wykonanie czyszczenia (aby uniknÄÄ dodatkowego czyszczenia).",
            minimalDispenseAmount:
                "Minimalna iloÅÄ dozowania to najmniejsza zalecana iloÅÄ barwnika, ktÃ³rÄ moÅ¼na dozowaÄ. W przypadku naruszenia zostanie wyÅwietlony komunikat (wydawanie jest nadal moÅ¼liwe).",
            missingAutotaskCanisters: "There must be selected at least 1 canister",
            missingAutotaskChannels: "There must be selected at least 1 channel",
            missingAutotaskChannelsValue: "Volume of all selected channels must be filled in",
            missingAutotaskCleanTime: "Time of cleaning must be filled in",
            missingAutotaskName: "Name of the autotask must be filled in",
            missingAutotaskRecirculation: "Time and speed of recirculation must be filled in",
            missingAutotaskStirring: "Time and speed of stirring must be filled in",
            missingAutotaskVolume: "Volume of purge must be filled in",
            placeCanSensor:
                "Ustawienie aktywuje czujnik umieszczania puszek - dozowanie nie rozpocznie siÄ, dopÃ³ki puszka nie zostanie prawidÅowo umieszczona.",
            placeCanSensorDelay:
                "Zalecane ustawienie zwiÄzane z miejscem moÅ¼e czujnik. Zapewnia to, Å¼e dozowanie rozpocznie siÄ dopiero po okreÅlonym czasie, w ktÃ³rym puszka zostaÅa prawidÅowo umieszczona.",
            purgeVolume:
                "ObjÄtoÅÄ oczyszczania okreÅla, ile Årodka barwiÄcego jest usuwane podczas przeprowadzania inteligentnego czyszczenia.",
            rccUrl: "Redlike Control Center (RCC) is responsible for the communication with the dispenser.",
            refillThreshold:
                "If the amount of colorant in the canister with the given UFI or Batch number drops below this limit, such UFI or Batch number will be discarded.",
            refillThresholdBatch:
                "If the amount of colorant in the canister with the given Batch number drops below this limit, such Batch number will be discarded.",
            refillThresholdUfi:
                "If the amount of colorant in the canister with the given UFI drops below this limit, such UFI will be discarded.",
            removeCanSensor:
                "Ustawienie aktywuje czujnik do wyjmowania puszki - wydawanie nie jest uwaÅ¼ane za wykonane, chyba Å¼e puszka zostaÅa wyjÄta.",
            removeCanSensorDelay:
                "Zalecane ustawienie zwiÄzane z usuniÄciem czujnika puszki. Zapewnia to, Å¼e dozowanie zostaÅo zakoÅczone dopiero po okreÅlonym czasie, w ktÃ³rym puszka zostaÅa wyjÄta.",
            skipPlaceCanDialog:
                "Przy wÅÄczonym tym ustawieniu dozownik nie bÄdzie czekaÅ podczas wkÅadania puszki do momentu naciÅniÄcia przycisku OK, ale automatycznie rozpocznie proces wydawania.",
            skipRemoveCanDialog:
                "Przy tym ustawieniu dozownik nie bÄdzie czekaÅ podczas wyjmowania puszki, dopÃ³ki nie zostanie naciÅniÄty przycisk OK, ale uzna, Å¼e ââproces wydawania zakoÅczy siÄ automatycznie.",
            smartPurgeType:
                "Typ oczyszczania moÅ¼e braÄ pod uwagÄ tylko dozowanie lub dozowanie plus inne zdarzenia oczyszczania podczas sprawdzania poprawnoÅci, jeÅli potrzebne jest inteligentne czyszczenie.",
            splitFormula:
                "JeÅli wymagana iloÅÄ barwnika przekracza maksymalnÄ iloÅÄ dozowania, ustawienie pozwala na dozowanie porcji barwnika, napeÅnienie pojemnika, a nastÄpnie kontynuowanie dozowania reszty.",
            tintometricSystem:
                "Tintometric system (set of available colorants) defines what colorants and formulas will be available in the application and application settings.",
            validateBarcodeBaseCan:
                "Baza moÅ¼e wymagaÄ walidacji za pomocÄ kodu kreskowego, zanim dozowanie bÄdzie dozwolone. Ustawienie zapewnia, Å¼e uÅ¼ywana jest wÅaÅciwa baza.",
            validateColorantsDuringInit:
                "The machine configuration will be compared to the database each time when RCC is restarted. In case of mismatches, a notification occurs."
        },
        matchingSettings: {
            matchingInformation: "On matching result panel, %{item} will be available.",
            matchingOptionsColorants: "On matching options panel, colorants panel will be available.",
            matchingOptionsColorfile: "On matching options panel, colorfile selectbox will be available.",
            matchingOptionsSortResults: "On matching options panel, sort results selectbox will be available.",
            matchingRowCount: "Defines how many results should be offered after matching."
        },
        navigation: {
            barcodeScan: "Opens a window with the possibility to enter the barcode manually.",
            canisterBarcodes:
                "Opens a window with canister barcode overview and the possibility to set canister barcode.",
            canisterLevel: "Opens a window with canister levels overview and the possibility to set canister level.",
            canisters: "Opens a panel with canister levels overview and the possibility to set canister level.",
            clean: "Open a window with the possibility to clean machine channels",
            colorPanel: "Opens a panel with the possibility to search for a new formula in an electronic fandeck.",
            colorSearchTab: "Opens a panel with possibility to search all colors in all fandecks.",
            colorantRefillHistory: "Opens a window with the overview of performed canister refills.",
            customFormula: "Opens a panel  with the possibility to create a new custom formula.",
            customers: "Opens a panel  with the overview of customers and the possibility to add/edit/delete them.",
            dispensingHistory: "Opens a panel with the overview of performed dispensings.",
            favorites: "Opens a panel with the possibility to select a favorite formula.",
            help: "Opens a window with customer service information if provided by the supplier.",
            hideItems: "Otwiera okno z moÅ¼liwoÅciÄ oznaczenia produktÃ³w i wzornikÃ³w jako ukryte.",
            historyOfOrders: "Valid for %{name} exclusively, opens a panel with the overview of dispensed orders.",
            machineReset: "Starts dispenser reset.",
            matching: "Opens a panel with the possibility to match new color with a spectro.",
            myOrders: "ZamÃ³wienia wysÅane z tego komputera",
            purge: "Opens a window with the possibility to set canister purge.",
            quickTint: "Opens a window with the possibility to perform manual dispensing.",
            searchFormula: "Opens a panel with the possibility to search for a new formula.",
            spectro: "Opens a panel with the possibility to measure with a spectro.",
            stir: "Opens a window with the possibility to set canister stirring.",
            ticketing: "Opens a ticketing system panel.",
            toDispense: "ZamÃ³wienia otrzymane przez ten komputer"
        },
        noHelpForLicense: "Licencja nie jest dostÄpna, poproÅ dostawcÄ o jej dodanie.",
        posInfo: {
            sync: "Synchronizes data with the section Registration"
        },
        poweredByDeso: "ObsÅugiwane przez %{name}",
        priceSettings: {
            VatPrice: "WartoÅÄ VAT barwnika w %.",
            VatPriceProduct: "The generic product VAT will be the same for every colorant. Set in %.",
            basePurchase: "Cena zakupu podstawy (w tym wyÅÄcznie podstawa).",
            basePurchasePriceProduct: "Purchase price for the package of the given base. Set in selected currency.",
            baseSell: "Cena sprzedaÅ¼y tylko dla podstawy (w tym podstawy i marÅ¼y / znacznikÃ³w).",
            baseSellFull: "Sell full price for base.",
            cntName: "Defines which colorant the price is related to.",
            cntPurchase: "Cena zakupu barwnikÃ³w (w tym wyÅÄcznie barwnikÃ³w).",
            cntPurchaseByName: "Cena zakupu barwnikÃ³w obliczana indywidualnie dla kaÅ¼dego (w tym wyÅÄcznie barwnikÃ³w).",
            cntPurchasePricePerLiter: "Cena kosztowa barwnika za litr (bez marginesÃ³w i znacznikÃ³w).",
            cntSell: "Cena sprzedaÅ¼y tylko dla barwnikÃ³w (w tym barwnikÃ³w i marÅ¼y / znacznikÃ³w).",
            cntSellByName:
                "Cena sprzedaÅ¼y wszystkich barwnikÃ³w uÅ¼ytych w produkcie obliczana indywidualnie dla kaÅ¼dego (w tym barwnikÃ³w i marÅ¼y / znacznikÃ³w).",
            cntSellFull: "Sell full price for colorants.",
            cntSellFullByName: "Sell full price for colorants by name.",
            cntSellPricePerLiter:
                "The sell price of the colorant per liter (incl. colorant exclusively). Set in the selected currency.",
            cntVat: "Colorant VAT value set in %.",
            colorants:
                "OgÃ³lne ceny barwnikÃ³w bÄdÄ takie same dla kaÅ¼dego barwnika. Ta funkcja jest szczegÃ³lnie przydatna do ustawiania podatku VAT.",
            colorantsPosCoeficient: "The generic colorant coeficient for POS.",
            colorantsSellPrice:
                "The generic colorant prices will be the same for every colorant. Sell price is recommended to by modified by discount. Set in selected currency.",
            currencyCodeNew: "Kod waluty musi byÄ w oficjalnej formie litery drzewa, na przykÅad EUR.",
            currencyNameNew: "Nazwa waluty, na przykÅad euro.",
            currencyRateNew:
                "Kurs waluty w stosunku do gÅÃ³wnej waluty, na przykÅad 25,855 CZK za 1 â¬. Stawka musi byÄ stale zmieniana, aby byÄ na bieÅ¼Äco.",
            currencyRoundingNew:
                "ZaokrÄglenie ustawia najmniejszÄ moÅ¼liwÄ do zapÅaty wartoÅÄ waluty, na przykÅad euro ma zaokrÄglenie 0,01, poniewaÅ¼ najmniejsza moÅ¼liwa wartoÅÄ wynosi 1 cent.",
            currencySymbolNew: "Oficjalny symbol waluty, na przykÅad â¬ dla euro.",
            defaultPrice: "Cena barwnika ustalona w wybranej bazie danych (bez VAT).",
            defaultPriceGroup: "Cena barwnika dla grupy cenowej ustawionej w wybranej bazie danych (bez VAT).",
            defaultVatPrice: "Ustawiony podatek VAT od barwnika w wybranej bazie danych.",
            discountHeader: "Discount substracts the the defined value from the purchase colorant price. Set in %.",
            discountHeaderProduct:
                "Discount substracts the the defined value from the product colorant price. Set in %.",
            export: "Export a file with the currently inserted prices. It can be imported again after having modified the prices.",
            import: "Import a correctly formated (exported) file to insert or modify the prices.",
            localPrices:
                "Local prices change suggested prices from the main database and are present solely locally on this particular computer.",
            margin: "Choose which price calculation should be used for the definition of the final available price. Margin and markup add up to whereas discount substracts from the given sell price.",
            marginAll: "Cena marÅ¼y / znacznikÃ³w dla wielu paczek (w tym marÅ¼y / znacznikÃ³w).",
            marginHeader: "Margin adds the defined value up to the purchase colorant price. Set in %.",
            marginHeaderProduct: "Margin adds the defined value up to the purchase product price. Set in %.",
            marginPerPkg: "Cena za marÅ¼Ä / marÅ¼Ä za jednÄ paczkÄ (w tym marÅ¼Ä / marÅ¼Ä).",
            markupHeader: "Markup adds the defined value up to the purchase colorant price. Set in %.",
            markupHeaderProduct: "Markup adds the defined value up to the purchase product price. Set in %.",
            packagePricing: "Dodatkowa dopÅata ustalana indywidualnie dla kaÅ¼dego rozmiaru paczki.",
            packageSurcharge: "OgÃ³lne ceny pakietÃ³w bÄdÄ takie same dla kaÅ¼dej dodatkowej opÅaty za pakiet.",
            priceDefinition: "The setting defines which price types are used when calculating final prices.",
            priceGroupNumber:
                "The setting defines how many price groups will be used. The range for individual price groups can be set in Default Values.",
            priceGroupPricePerLiter: "Cena barwnika stosowana przy obliczaniu ceny grupy cenowej.",
            priceGroups:
                "Grupy cenowe wyÅwietlajÄ numer odpowiedniej grupy cenowej (granice sÄ ustalane w bazie danych lub w cenach ogÃ³lnych).",
            priceGroupsEnabled:
                "The setting allows you to work with price groups. Define the range in Default Values and individual prices in Colorant Pricing.",
            priceGroupsGeneric:
                "Grupy cenowe to przedziaÅy cenowe ostatecznej farby na podstawie cen barwnikÃ³w we wzorze.",
            productBasePackageSellPrice: "Sell price for the package of the given base. Set in selected currency.",
            productBaseSellPrice:
                "Sell price for base calculated per liter (incl. base exclusively). Set in the selected currency.",
            productBaseVat: "Product base VAT value for the given package set in %.",
            productName: "Defines which product base the price is related to.",
            productPosCoeficient: "The generic product coeficient for POS.",
            productPricing: "Przy wydawaniu paczek niestandardowych stosowana jest cena zakupu wszystkich paczek.",
            productSize: "Defines which package of the given product base the price is related to.",
            productVat: "Product base VAT value set in %.",
            products:
                "OgÃ³lne ceny produktÃ³w bÄdÄ takie same dla kaÅ¼dego produktu. Ta funkcja jest szczegÃ³lnie przydatna do ustawiania podatku VAT.",
            productsSellPrice:
                "The generic product prices will be the same for every colorant. Sell price is recommended to by modified by discount. Set in selected currency.",
            sellPriceAll: "Cena sprzedaÅ¼y wielu paczek (w tym baza, barwniki, dopÅata i marÅ¼a / znaczniki).",
            sellPricePerKg: "Cena sprzedaÅ¼y produktu za kilogram (w tym baza, barwniki, dopÅata i marÅ¼a / znaczniki).",
            sellPricePerL: "Cena sprzedaÅ¼y produktu za litr (w tym baza, barwniki, dopÅata i marÅ¼a / znaczniki).",
            sellPricePerPkg: "Cena sprzedaÅ¼y jednego pakietu (zawiera bazÄ, barwniki, dopÅatÄ i marÅ¼Ä / znaczniki).",
            setPriceTypesVisibilityAndOrder:
                "W panelu FormuÅa wybrane ceny bÄdÄ widoczne w sekcji cen. NajwyÅ¼sza pozycja tutaj okreÅla lewÄ pozycjÄ w sekcji.",
            surchargeAll: "Cena dodatkowej opÅaty za wiele paczek (w tym dopÅata).",
            surchargePerPkg: "Cena dodatkowej opÅaty za jeden pakiet (zawiera dopÅatÄ).",
            tintPurchaseAll: "Cena zakupu za caÅy proces barwienia wielu opakowaÅ (w tym colorans i dodatkowa opÅata).",
            tintPurchasePerPkg:
                "Cena zakupu za caÅy proces barwienia jednego opakowania (w tym colorans i dodatkowa opÅata).",
            tintSellFullAll: "Tint sell full price for all packages.",
            tintlSellFullAllPerPackage: "Tint sell full price per package.",
            totalPurchaseAll: "CaÅkowita cena zakupu produktu dla wielu opakowaÅ (w tym baza i barwniki).",
            totalPurchasePerKg: "CaÅkowita cena zakupu produktu za kilogram (w tym baza i barwniki).",
            totalPurchasePerL: "CaÅkowita cena zakupu produktu za litr (w tym baza i barwniki).",
            totalPurchasePerPkg: "CaÅkowita cena zakupu produktu za jedno opakowanie (w tym baza i barwniki).",
            totalSellFullAll: "Total sell full price for all packages.",
            totalSellFullPerKg: "Total sell full price per kilogram.",
            totalSellFullPerLiter: "Total sell full price per liter.",
            totalSellFullPerPackage: "Total sell full price per package.",
            withAndWithoutVat:
                "On Formula panel, the price will be visible in both variations, with and without VAT, simultaneously.",
            withVat: "On Formula panel, all prices will be visible only with VAT included.",
            withoutVat: "On Formula panel, all prices will be visible only with VAT excluded."
        },
        qualityControlSettings: {
            colorDifference: "Color difference model for quality control.",
            deltaA: "Defines tolerance limit for delta A in quality control.",
            deltaB: "Defines tolerance limit for delta B in quality control.",
            deltaE: "Defines tolerance limit for delta E in quality control.",
            deltaL: "Defines tolerance limit for delta L in quality control.",
            deltaMetamerism: "Defines tolerance limit for metamerism delta in quality control."
        },
        registration: {
            sync: "Synchronizes data with the section POS Info"
        },
        searchingPleaseWait: "Please wait, the best match is being searched for",
        setupSteps: {
            customData: "Custom Data",
            machineType: "Machine Type",
            userPreferences: "User Preferences"
        },
        spectroSettings: {
            ColorixNanoUseProfiledValues:
                "When using profiled values, the measured results are recalculated to remove the filter effect. Allow this option for universal spectro measuring.",
            XRiteModelRM400: "No drivers required.",
            datacolorDiagnosticTile: "Datacolor use diagnostic tile",
            datacolorSilent: "Datacolor silent",
            measureModes: "Select supported gloss levels.",
            model: "Model",
            simulationPath: "Path to the simulation file. Default preset.",
            spectroType: "Official spectro driver has to be installed. Windows only.",
            spectroTypeCom:
                "Official spectro driver has to be installed. Beware of the used COM Port. Windows as well as Linux.",
            spectroTypeDataColorReader:
                "The computer has to have Bluetooth connection. The spectro has to be paired with the computer. Windows 10 with 2018 automn update required.",
            spectroTypeMinolta2XXXd:
                "Official spectro driver has to be installed. Beware of the used COM Port. Windows as well as Linux.",
            spectroTypeNotSelected: "Select your spectro model.",
            spectroTypeRM400: "No drivers required.",
            spectroTypeSimulation: "Lab values required to obtain simulation results. Windows as well as Linux.",
            spectroTypeXRite: "Windows only."
        },
        ufiCode: {
            baseUfiCodeValidation: "Base can UFI code has to be validated via barcode before dispensing is allowed.",
            enableUfiCodes:
                "UFI codes are used in EU and provide information about how hazardous a product is to environment.",
            invalidUfi: "Invalid UFI code",
            printUfiCode:
                "If a colorant in a formula exceeds the given limit, its UFI code will be printed on the print label.",
            printUfiCodePercentage:
                "If a colorant in a formula exceeds the given limit, its UFI code will be printed on the print label along with its percentage representation.",
            ufiCodesByPercentage:
                "The UFI code which prevails is used for printing considering its actual amount in the canister. Navigate to Canister settings to define the threshold for each canister.",
            ufiCodesFromDatabase:
                "The UFI code from the main database given by the database administrator is used for printing.",
            ufiCodesFromLastFilling:
                "The UFI code from the last refill given by the operator is used for printing regardless the refilled amount."
        },
        userManagement: {
            add: "The setting adds a new user who can log in into the software. The user can have a barcode assigned and can be set to log in automatically after the software is started.",
            assignedGroups:
                "This defines what user groups the user belongs to. Various user groups distribute various privileges.",
            availableGroups:
                "This defines what user groups there are available for the user. Various user groups distribute various privileges.",
            loggedUserDelete: "Currently logged in user cannot be deleted."
        },
        visit: "Lub odwiedÅº",
        visitNoLicense: "Aby uzyskaÄ wiÄcej informacji prosimy odwiedziÄ"
    },
    helpSettings: {
        customHelpLink: "Niestandardowy link do Centrum pomocy",
        helpSettings: "Ustawienia pomocy",
        message: "WiadomoÅÄ"
    },
    helper: {
        automaticallyCheckForUpdates: "Sprawdzaj aktualizacje automatycznie",
        automaticallyDownloadUpdates: "Pobierz aktualizacje automatycznie",
        automaticallyInstallNewDatabases: "Automatycznie instaluj nowe bazy danych",
        automaticallyInstallUpdates: "Automatycznie instaluj aktualizacje",
        bugReport: "ZgÅoszenie bÅÄdu",
        canBrowseChangeLog: "Show online %{name} changelog.",
        collect: "PrevziaÅ¥",
        collectLogFiles: "Zbierz pliki dziennika",
        component: "SkÅadnik",
        content: "ZawartoÅÄ",
        contentSize: "Rozmiar treÅci",
        download: "StiahnÃºÅ¥",
        downloadLogFiles: "StiahnÃºÅ¥ log sÃºbory",
        downloadingData: "Pobieranie danych",
        everyHours: "Co %{interval} godzin",
        forceInstall: "Force to update",
        installDuringNight: "During night (%{start} - %{end}) every %{interval} hour",
        newVersion: "Nowa wersja",
        notConnected: "Pomocnik nie jest podÅÄczony",
        openBugReport: "OtvoriÅ¥ okno s hlÃ¡senÃ­m o chybe",
        packageSize: "WielkoÅÄ paczki",
        pleaseWait: "ProszÄ czekaÄ, moÅ¼e to zajÄÄ trochÄ czasu.",
        send: "WysÅaÄ",
        sendBugReportToCustomerService: "WyÅlij raport o bÅÄdzie do obsÅugi klienta",
        sendingReport: "Posielam",
        subject: "Przedmiot"
    },
    helperDialog: {
        1: "MoÅ¼esz sprawdziÄ dostÄpnoÅÄ aktualizacji oprogramowania lub bazy danych.",
        2: "Czy kontynuowaÄ pobieranie pakietÃ³w aktualizacji?",
        3: "Czy kontynuowaÄ instalacjÄ pobranych pakietÃ³w aktualizacji?",
        10: "Sprawdzanie aktualizacji oprogramowania i bazy danych, proszÄ czekaÄ ...",
        11: "DostÄpna jest aktualizacja dla twojego komputera. Czy chcesz go pobraÄ?",
        12: "Brak dostÄpnych aktualizacji dla twojego komputera.",
        14: "WystÄpiÅ bÅÄd podczas sprawdzania dostÄpnoÅci aktualizacji. %{0}",
        15: "SynchronizujÄ bazy danych stref, proszÄ czekaÄ ...",
        20: "Pobieram pakiet aktualizacji, proszÄ czekaÄ ...",
        21: "Pakiet aktualizacji, ktÃ³ry zostaÅ pobrany, jest obecnie weryfikowany, proszÄ czekaÄ ...",
        22: "Pobieranie pakietu aktualizacji nie powiodÅo siÄ. Czy chcesz sprÃ³bowaÄ ponownie?",
        23: "Pobieranie pakietu aktualizacji nie powiodÅo siÄ (plik jest znieksztaÅcony), czy chcesz sprÃ³bowaÄ ponownie?",
        24: "Czy kontynuowaÄ instalacjÄ aktualizacji?",
        25: "Instalacja automatycznej aktualizacji rozpocznie siÄ za %{0}",
        26: "Jest dostÄpna aktualizacja do twojego komputera. Czy chcesz jÄ zainstalowaÄ?",
        27: "KontynuowaÄ z instalacjÄ aktualizacji?",
        40: "Zatrzymywanie aplikacji i usÅug, proszÄ czekaÄ ...",
        41: "Kopiowanie nowych plikÃ³w, proszÄ czekaÄ ...",
        42: "Uruchamianie aplikacji i usÅug, proszÄ czekaÄ ...",
        43: "KoÅczÄ aktualizacjÄ oprogramowania, proszÄ czekaÄ ...",
        44: "Twoje oprogramowanie zostaÅo pomyÅlnie zaktualizowane.",
        45: "Czy chcesz ponowiÄ instalacjÄ? JeÅli zdecydujesz siÄ sprÃ³bowaÄ ponownie, upewnij siÄ, Å¼e skÅadniki oprogramowania nie sÄ aktualnie uÅ¼ywane.",
        46: "Ponowne uruchomienie komputera jest wymagane, aby wpÅynÄÄ na zmiany, ponowne uruchomienie nastÄpi w %{0}",
        999: "WystÄpiÅ bÅÄd wewnÄtrzny: %{0}",
        automaticInstallation: "Automatyczna instalacja aktualizacji",
        btnAbort: "AnulowaÄ",
        btnCancel: "Anuluj",
        btnCheckUpdate: "SprawdÅº aktualizacje",
        btnContinue: "Kontyntynuj",
        btnDownloadUpdate: "Pobierz aktualizacjÄ",
        btnInstallUpdate: "Zainstaluj aktualizacjÄ",
        btnOk: "OK",
        btnRetry: "SprÃ³bowaÄ ponownie",
        btnSkip: "PominÄÄ",
        checkingForUpdates: "Sprawdzanie aktualizacji",
        downloadingFailed: "Pobieranie nie powiodÅo siÄ",
        downloadingPackage: "Pobieranie pakietu aktualizacji, proszÄ czekaÄ",
        finishingUpdate: "KoÅczÄ aktualizacjÄ",
        installingUpdate: "Instalacja aktualizacji",
        internalError: "BÅÄd wewnÄtrzny",
        rebootRequired: "Wymagane jest ponowne uruchomienie komputera",
        startingComponents: "Uruchamianie komponentÃ³w oprogramowania",
        stoppingComponents: "Zatrzymywanie komponentÃ³w oprogramowania",
        synchronizingDatabases: "Synchronizacja baz danych stref",
        updateAvailable: "Aktualizacja dostÄpna, wybierz komponenty do aktualizacji",
        updateDownloaded: "Aktualizacja zostaÅa pobrana",
        updateFailed: "Proces aktualizacji nie powiÃ³dÅ siÄ",
        updateInstalled: "Aktualizacja zostaÅa zainstalowana",
        verificationFailed: "Weryfikacja pakietu aktualizacji nie powiodÅa siÄ",
        verifyingPackage: "Weryfikacja pobranego pakietu",
        yourSoftwareIsUpToDate: "Twoje oprogramowanie jest aktualne",
        yourSoftwareVersion: "Twoja wersja oprogramowania: %{0}"
    },
    importData: {
        abortImportingData: "Przerwij import",
        aborted: "Import was aborted.",
        backupLocalDB: "Backup local database",
        confirmRestore: "Do you really want to restore all local settings?",
        dataMissing: "Import failed because the source file didn't contain any data.",
        deleteImportedData: "UsuÅ zaimportowane dane",
        encodingFile: "File encoding",
        exportLocalSettings: "Export Local Settings",
        exportStaticSql: "Export Static SQL",
        fileDamaged: "Import failed because the source file seems to be damaged.",
        fileMissing: "Import failed because the source file doesn't exist.",
        format: "Format",
        formatPath: "Formatuj ÅcieÅ¼kÄ",
        headerMissing: "Import failed because the files header is missing.",
        import: "Import",
        importAborted: "Importowanie przerwane",
        importAborting: "Importowanie przerwane",
        importFailed: "Import failed because of an unexpected error.",
        importLocalSettings: "Import Local Settings",
        importPrices: "Ceny importowe",
        imported: "PomyÅlnie zaimportowano",
        importedWithErrors: "Importing has finished with errors. Error lines have been skipped.",
        importing: "Importowanie",
        noFormatAvailable: "Brak dostÄpnego formatu",
        processing: "Przetwarzanie",
        processingCustomFormulas: "Przetwarzanie formuÅ niestandardowych",
        processingCustomers: "Przetwarzanie klientÃ³w",
        productsFile: "Plik produktÃ³w",
        restoreLocalSettings: "Restore Local Settings",
        underProgress: "Import is under progress.",
        unknownFormat: "Import failed because the source file is of unknown format.",
        userFormulasFile: "Plik formuÅ uÅ¼ytkownika"
    },
    infoType: {
        baseDensity: "Base density",
        baseMass: "Masa podstawowa",
        baseUfiCode: "Base UFI code",
        baseVolume: "Podstawowa objÄtoÅÄ",
        batchNumbersTable: "Batch numbers table",
        bfsGrade: "Klasa BFS",
        colorLab: "Color Lab",
        colorRgb: "Kolor RGB",
        colorRgbHex: "Kolor RGB Hex",
        colorXyz: "Kolor xyz",
        colorantBatchNumbers: "Colorant batch numbers",
        colorantMass: "Masa barwnika",
        colorantUfiCodes: "Colorant UFI codes",
        colorantVolume: "ObjÄtoÅÄ barwnika",
        formulaDate: "Formula date",
        formulaDatetime: "Formula datetime",
        formulaMoreInfo: "Formula more info",
        formulaMoreInfoInternal: "Formula more info internal",
        formulaMoreInfoPrint: "Formula more info print",
        hbw: "HBW",
        isPackageGravimetric: "Is package gravimetric",
        maxColorantMass: "Maximum allowed colorant mass",
        maxColorantVolume: "Maximum allowed colorant volume",
        nominalMass: "Package nominal mass",
        nominalVolume: "Package nominal volume",
        overfillDetected: "Overfill detected",
        totalPaintDensity: "Total paint density",
        totalPaintMass: "CaÅkowita masa farby",
        totalPaintVolume: "CaÅkowita objÄtoÅÄ farby",
        ufiCodesTable: "UFI codes table",
        verifiedFormula: "Verified formula",
        yValue: "WartoÅÄ Y."
    },
    initialTab: {
        favoriteFormulas: "Ulubione formuÅy",
        lastDispensedFormulas: "Ostatnio wydane formuÅy",
        searchNewFormula: "Wyszukaj nowÄ formuÅÄ"
    },
    invalidBatchNumbersModal: {
        header: "Check colorants Batch number",
        info: "At least one canister is filled with (possibly) defective batch of colorant. Please do not use this batch. Empty the canister using Quick tint.",
        unknownStatus: "Unknown Batch status"
    },
    keyWords: {
        action: "action",
        add: "add",
        addition: "addition",
        additional: "additional",
        address: "address",
        admin: "admin",
        advanced: "Advanced",
        after: "after",
        afterDispensing: "after dispensing",
        alfa: "Alfa",
        all: "all",
        allow: "allow",
        alphabetically: "alphabetically",
        amount: "amount",
        api: "api",
        ask: "ask",
        autocap: "autocap",
        autotask: "autotask",
        availablePrice: "available price",
        backup: "backup",
        banner: "banner",
        barcode: "barcode",
        barcodes: "barcodes",
        base: "base",
        before: "before",
        begin: "begin",
        bfs: "bfs",
        bottom: "bottom",
        brand: "brand",
        brush: "brush",
        bug: "bug",
        button: "button",
        buy: "buy",
        cC3: "CC3",
        cM: "CM",
        calibration: "calibration",
        can: "can",
        canHandling: "can handling",
        canister: "canister",
        canisterFilling: "canister filling",
        canisterLevels: "canister levels",
        canisters: "canisters",
        cap: "cap",
        center: "Center",
        centre: "Centre",
        change: "change",
        changelog: "changelog",
        channels: "channels",
        check: "check",
        chunk: "chunk",
        chunks: "chunks",
        city: "city",
        clean: "clean",
        cleaning: "cleaning",
        clientIdentifier: "client identifier",
        close: "close",
        closest: "closest",
        code: "code",
        collect: "collect",
        color: "color",
        colorLink3: "ColorLink3",
        colorPanel: "color palette",
        colorReader: "ColorReader",
        colorant: "colorant",
        colorantConsumption: "colorant consumption",
        colorantPrice: "colorant price",
        colorants: "colorants",
        colorix: "Colorix",
        colour: "colour",
        communication: "communication",
        compare: "compare",
        competitive: "competitive",
        computer: "computer",
        config: "config",
        configuration: "configuration",
        confirm: "confirm",
        confirmation: "confirmation",
        connection: "connection",
        contactPerson: "contact person",
        control: "Control",
        copies: "copies",
        corob: "Corob",
        cost: "cost",
        country: "country",
        create: "create",
        currency: "currency",
        current: "current",
        custom: "custom",
        customers: "customers",
        daily: "daily",
        dark: "Dark",
        data: "data",
        database: "database",
        datacolor: "Datacolor",
        date: "date",
        decimals: "decimals",
        default: "default",
        delay: "delay",
        delete: "delete",
        deletion: "deletion",
        deltaE: "delta e",
        device: "device",
        devices: "devices",
        diagnosticTile: "diagnostic tile",
        dialog: "dialog",
        direct: "direct",
        disconnect: "disconnect",
        discount: "discount",
        dispense: "dispense",
        dispenser: "dispenser",
        dispensing: "dispensing",
        down: "down",
        download: "download",
        driver: "driver",
        dromont: "Dromont",
        dspProxy: "DspProxy",
        edit: "edit",
        editor: "editor",
        email: "email",
        error: "error",
        evoDriver: "EvoDriver",
        evoService: "EvoService",
        excel: "excel",
        expiration: "expiration",
        export: "export",
        eyeOne: "Eye-One",
        fF: "F&F",
        fandeck: "fandeck",
        fastFluid: "Fast & Fluid",
        file: "file",
        fill: "fill",
        fillToMax: "fill to max",
        find: "find",
        first: "first",
        flex: "Flex",
        folder: "folder",
        formula: "formula",
        formulas: "formulas",
        from: "from",
        fts5: "fts5",
        fullScreen: "full screen",
        fullText: "full-text",
        fulltext: "fulltext",
        g: "g",
        genericPricing: "generic pricing",
        hLD: "HLD",
        hard: "hard",
        hbw: "hbw",
        help: "help",
        helpCenter: "help center",
        hero: "Hero",
        history: "history",
        home: "home",
        host: "host",
        humidifier: "humidifier",
        iDD: "IDD",
        identification: "identification",
        image: "image",
        impGallon: "imp. gallon",
        impQuart: "imp. quart",
        import: "import",
        individually: "individually",
        info: "info",
        information: "information",
        initial: "initial",
        initialization: "initialization",
        initialize: "initialize",
        insert: "insert",
        install: "install",
        intellyPurge: "intelly purge",
        invalid: "invalid",
        ipAddress: "ip address",
        italtinto: "Italtinto",
        items: "items",
        keyboard: "keyboard",
        kg: "kg",
        kiosk: "kiosk",
        kioskMode: "kiosk mode",
        l: "l",
        lLD: "LLD",
        lab: "lab",
        label: "label",
        labels: "labels",
        language: "language",
        largo: "largo",
        last: "last",
        lenteq: "Lenteq",
        levels: "levels",
        license: "license",
        light: "Light",
        limit: "limit",
        link: "link",
        linux: "Linux",
        load: "load",
        lock: "lock",
        logFiles: "log files",
        logic: "logic",
        logo: "logo",
        lower: "lower",
        machine: "machine",
        machineConfiguration: "machine configuration",
        machineManagement: "machine management",
        machineName: "machine name",
        main: "main",
        maintenance: "maintenance",
        manual: "manual",
        manualAddition: "manual addition",
        manualDispensing: "manual dispensing",
        manualScan: "manual scan",
        margins: "margins",
        markups: "markups",
        mass: "mass",
        match: "match",
        measure: "measure",
        measurement: "measurement",
        measurementUnits: "measurement units",
        melody: "melody",
        message: "message",
        minimal: "minimal",
        minolta: "Minolta",
        minus: "minus",
        minutes: "minutes",
        misura: "Misura",
        ml: "ml",
        mode: "mode",
        model: "model",
        modification: "modification",
        modify: "modify",
        monthly: "monthly",
        moreInfo: "more info",
        movableTable: "movable table",
        move: "move",
        music: "music",
        myOrders: "my orders",
        name: "name",
        naming: "naming",
        nano: "Nano",
        navigation: "navigation",
        new: "new",
        nextDriver: "NextDriver",
        night: "night",
        nixPro: "Nix Pro",
        notes: "notes",
        notification: "notification",
        number: "number",
        off: "off",
        open: "open",
        order: "order",
        ordering: "ordering",
        overfill: "overfill",
        overview: "overview",
        overwrite: "overwrite",
        own: "own",
        pCPDriver: "PCPDriver",
        package: "package",
        packagePrice: "package price",
        packages: "packages",
        panels: "panels",
        parameter: "parameter",
        path: "path",
        pc: "pc",
        phone: "phone",
        phoneNumber: "phone number",
        picture: "picture",
        place: "place",
        placement: "placement",
        plug: "plug",
        plugger: "plugger",
        plugging: "plugging",
        plugin: "plugin",
        plus: "plus",
        pointOfSale: "point of sale",
        popUp: "pop-up",
        pos: "pos",
        present: "present",
        preview: "preview",
        price: "price",
        priceExport: "price export",
        priceGroup: "price group",
        priceImport: "price import",
        prices: "prices",
        pricing: "pricing",
        primaryCurrency: "primary currency",
        print: "print",
        printer: "printer",
        printing: "printing",
        problem: "problem",
        product: "product",
        productPrice: "product price",
        profiledValues: "profiled values",
        punch: "punch",
        puncher: "puncher",
        punching: "punching",
        purge: "purge",
        purgeType: "purge type",
        purgeVolume: "purge volume",
        quality: "quality",
        quick: "quick",
        quickTint: "quick tint",
        rM: "RM",
        raise: "raise",
        rcc: "rcc",
        reader: "reader",
        reboot: "reboot",
        receive: "receive",
        recirculate: "recirculate",
        recirculation: "recirculation",
        redlike: "Redlike",
        refill: "refill",
        registration: "registration",
        regular: "regular",
        removal: "removal",
        remove: "remove",
        report: "report",
        reset: "reset",
        resolution: "resolution",
        restart: "restart",
        rgb: "rgb",
        rights: "rights",
        rounding: "rounding",
        rules: "rules",
        sanTint: "SanTint",
        save: "save",
        scale: "scale",
        scan: "scan",
        scope: "scope",
        screen: "screen",
        screensaver: "screensaver",
        search: "search",
        secondaryCurrency: "secondary currency",
        select: "select",
        selectedFormula: "Selected formula",
        sell: "sell",
        sensor: "sensor",
        serialNumber: "serial number",
        server: "server",
        servers: "servers",
        service: "service",
        serviceAction: "service action",
        serviceActions: "service actions",
        serviceSoftware: "service software",
        serviceWindow: "service window",
        settings: "settings",
        shelf: "shelf",
        shortcuts: "shortcuts",
        shot: "shot",
        show: "show",
        shutDown: "shut down",
        shutdown: "shutdown",
        silent: "Silent",
        simple: "simple",
        simulation: "simulation",
        size: "size",
        skip: "skip",
        smartPurge: "smart purge",
        software: "software",
        softwareSupplier: "software supplier",
        sort: "sort",
        sound: "sound",
        spectro: "spectro",
        spectrophotometer: "spectrophotometer",
        speed: "speed",
        split: "split",
        start: "start",
        startup: "startup",
        statistics: "statistics",
        status: "status",
        stir: "stir",
        stirring: "stirring",
        street: "street",
        support: "support",
        surcharge: "surcharge",
        tab: "tab",
        tabs: "tabs",
        task: "task",
        template: "template",
        testing: "testing",
        time: "time",
        tintingManagementCenter: "tinting management center",
        to: "to",
        toDispense: "to dispense",
        tolerance: "tolerance",
        top: "top",
        total: "total",
        translation: "translation",
        turnOff: "turn off",
        turntable: "turntable",
        type: "type",
        uIDD: "UIDD",
        uSGallon: "U.S gallon",
        uSQuart: "U.S quart",
        unit: "unit",
        up: "up",
        update: "update",
        url: "url",
        user: "user",
        userGroups: "user groups",
        v1: "v1",
        v2: "v2",
        v3: "v3",
        vAT: "VAT",
        validate: "validate",
        validation: "validation",
        version: "version",
        virtual: "virtual",
        volume: "volume",
        weekly: "weekly",
        window: "window",
        windows: "Windows",
        with: "with",
        without: "without",
        xRite: "X-Rite",
        xrite: "Xrite",
        yValue: "y value",
        zipCode: "zip code",
        zoom: "zoom"
    },
    languages: {
        bg: "BuÅgarski",
        cs: "Czeski",
        da: "Danish",
        de: "Niemiecki",
        el: "Grecki",
        en: "Angielski",
        es: "HiszpaÅski",
        fr: "Francuski",
        hr: "Chorwacki",
        hu: "WÄgierski",
        id: "Indonezyjski",
        is: "Ãsland",
        it: "WÅoski",
        lt: "Lithuanian",
        lv: "Latvian",
        ms: "Malajski",
        nl: "Holenderski",
        no: "Norway",
        pl: "Polski",
        pt: "Portugalski",
        ro: "RumuÅski",
        ru: "Rosyjski",
        sk: "SÅowacki",
        sr: "Srpski",
        sv: "Sverige",
        zh: "Chinese"
    },
    license: {
        activateLicense: "Aktywuj licencjÄ",
        activateNewLicense: "Aktywuj nowÄ licencjÄ",
        checkLicenseKey: "SprawdÅº klucz licencyjny",
        companyId: "identyfikator firmy",
        contactPerson: "Osoba kontaktowa",
        copy: "Kopiuj",
        country: "Kraj",
        emptyCity: "City is a required information",
        emptyCountry: "Country is a required information",
        emptyName: "Shop name is a required information",
        enterIdentificationKeys: "WprowadÅº swoje klucze identyfikacyjne",
        expirationDate: "Data waÅ¼noÅci %{dateTime}",
        fillRegistration: "Podaj dane rejestracyjne (przewiÅ w dÃ³Å, aby zobaczyÄ wiÄcej)",
        insertLicense: "Wstaw wygenerowany klucz do aktywacji offline",
        invalidEmail: "Email input is invalid",
        invalidPhone: "Phone input is invalid",
        itemsMarkedasterisk: "(elementy oznaczone gwiazdkÄ muszÄ byÄ wypeÅnione)",
        lastUpdate: "Last change %{dateTime}",
        leasedLicense: "Licencja dzierÅ¼awiona",
        licenseActivated: "License already activated",
        licenseStatus: "Status licencji",
        licenseWillExpire: "Twoja licencja wygasa za %{dayCount} dni",
        licenseWillExpireOneDay: "Your license expires in %{dayCount} day",
        machineInformation: "Informacje o maszynie",
        noLicenseAvailable: "brak dostÄpnej licencji",
        noProductsForKey: "There are no products available for the stated identification keys.",
        pointOfSale: "Punkt sprzedaÅ¼y",
        producer: "Producent",
        reactivate: "Reactivate",
        reactivateLicense: "Reactivate license",
        region: "Region",
        registerLicense: "WeÅº kopiÄ wniosku o aktywacjÄ i przejdÅº do:",
        registrationForm: "Rejestracja",
        selectProduct: "Wybierz produkt",
        serialNumber: "Numer seryjny",
        skipNewLicense: "If you want to activate new license later you can click on Skip",
        unlimitedLicense: "Licencja nieograniczona",
        userId: "Identyfikator uÅ¼ytkownika",
        uuid: "UUID licencji",
        versionDetails: "SzczegÃ³Åy wersji",
        versionScope: "Version scope",
        versionType: "Version type",
        zip: "kod pocztowy"
    },
    login: {
        authenticate: "UwierzytelniaÄ",
        logIn: "Zaloguj siÄ",
        loginAs: "Zaloguj siÄ jako inny uÅ¼ytkownik",
        messages: {
            incorrectUsername: "Nazwa uÅ¼ytkownika lub hasÅo jest niepoprawne"
        },
        password: "HasÅo",
        username: "Nazwa UÅ¼ytkownika"
    },
    machineActionHistory: {
        actionHistory: "Historia akcji"
    },
    machineErrors: {
        channel: "KanaÅ",
        code: "Kod",
        machineErrors: "BÅÄdy maszyny",
        noMachineErrors: "There are currently no machine errors",
        resetErrors: "Zresetuj bÅÄdy"
    },
    machineSettings: {
        action: "Akcja",
        addAutotask: "Dodaj zadanie automatyczne",
        autoCanisterIn: "Auto kanister IN",
        autoCanisterOut: "Auto kanister OUT",
        automaticRefill: "Automatyczne uzupeÅnianie",
        autotaskSettings: "Ustawienia automatycznego zadania",
        backupConfiguration: "Konfiguracja zapasowego dozownika",
        brushMaintenance: "Konserwacja szczotek",
        capMaintenance: "Konserwacja kubka",
        checkCanisterBeforeDispense: "SprawdÅº pojemnik przed wydaniem",
        checkColorantBaseRules: "Check colorant base rules",
        checkMinDosableAmount: "Check the minimal tintable amount of colorants",
        checkOverfill: "Check can overfill",
        checkTotalCntAmounts: "Check total colorants amount for base paint",
        cleanAll: "WyczyÅÄ wszystko",
        computerReboot: "Ponowne uruchomienie komputera",
        computerShutdown: "WyÅÄczenie komputera",
        connectMachine: "PodÅÄcz maszynÄ",
        days: "Dni",
        daysOfMonth: "Dni miesiÄca",
        devices: "UrzÄdzenia",
        disabled: "WyÅÄczony",
        dispenseAndPurge: "Dozuj i oczyÅÄ",
        dispenseOnly: "Tylko dozuj",
        dispenserCleaning: "Czyszczenie dozownika",
        dispensingWithErrorsEnabled: "Allow dispensing despite the validation errors",
        editAutotask: "Edytuj zadanie automatyczne",
        firstRun: "Pierwsze uruchomienie",
        hours: "godziny",
        humidifier: "NawilÅ¼acz",
        humidifierWaterLevelMaintenance: "Utrzymanie poziomu nawilÅ¼acza",
        machineConfigurationNoCanisters: "The machine configuration contains no canisters.",
        machineName: "Nazwa maszyny",
        machineSettings: "Ustawienia maszyny",
        manualPuncher: "Dziurkacz rÄczny",
        minDispensedAmount: "Min. Wydana iloÅÄ",
        minutes: "Minuty",
        nextRun: "NastÄpny przebieg",
        noAutotasksSet: "No autotasks set",
        noDataAvailable: "No data available",
        noMachine: "Å»adne urzÄdzenie nie jest podÅÄczone",
        onStart: "Na poczÄtek",
        plugger: "Wtyczka",
        postpone: "MoÅ¼na odÅoÅ¼yÄ",
        puncher: "Dziurkacz",
        purgeAll: "OczyÅÄ wszystko",
        purgeOnly: "Purge only",
        recirculateAll: "Recyrkuluj wszystko",
        recirculateChannels: "Recyrkuluj kanaÅy",
        recirculationSpeed: "PrÄdkoÅÄ recyrkulacji",
        recirculationTime: "Czas recyrkulacji",
        refillAll: "UzupeÅnij wszystko",
        refillCanisters: "UzupeÅnij kanistry",
        runAt: "Codziennie o godz",
        runDefinedDaysAt: "Zdefiniowane dni o",
        runEvery: "Uruchom co",
        runInDays: "Uruchom za kilka dni",
        serialNum: "Numer seryjny",
        settingsMachine: "Ustawienia maszyny",
        smartPurgeAll: "Inteligentne czyszczenie wszystkich",
        smartPurgeChannels: "Inteligentne kanaÅy oczyszczania",
        smartPurgeRules: "Zasady inteligentnego czyszczenia",
        startType: "Rozpocznij wpisywanie",
        stirAll: "Wymieszaj wszystko",
        stirCanisters: "MieszaÄ kanistry",
        stirringSpeed: "MieszajÄca prÄdkoÅÄ",
        stirringTime: "Czas mieszania",
        switchPlateMaintenance: "Konserwacja przeÅÄcznikÃ³w",
        theCurrentlySelectedMachine: "Aktualnie wybrana maszyna",
        threshold: "PrÃ³g",
        turntable: "Ruchomy stolik",
        unifyColorantBatchForMultipleCans: "Unify colorant batch for multiple cans dispensings",
        volume: "ObjÄtoÅÄ",
        weekdays: "Dni tygodnia"
    },
    mainTab: {
        acceptedFormula: "Accepted formula",
        addBuildingSite: "Add building site",
        addToFavorites: "Dodaj do ulubionych",
        alternativeFormulas: "Alternative formulas",
        alternativeValidFormulas: "Alternative valid formulas",
        buildingSiteSpecification: "Building site specification",
        colorantsAreInvalid: "One or more colorants are invalid",
        dispensedPackages: "Dozowane opakowania",
        dispensingInProgress: "Dozowanie w toku",
        dispensingIsAborted: "Dozowanie zostaÅo przerwane",
        dispensingIsNotAvailable: "Dozowanie nie jest dostÄpne",
        dispensingProgress: "%{done} z %{all}",
        editColorant: "Edytuj barwnik",
        editNote: "Edytuj notatkÄ",
        findCompetitiveColor: "Try to find the competitive color",
        forceDispensing: "Wymuszanie dozowania",
        formulaInvalidColorants: "FormuÅa zawiera nieprawidÅowe barwniki: %{colorants}",
        formulaOutOfDate: "Formula may be out of date",
        formulaProperties: "Formula properties",
        hiddenFandecks: "Ukryte wzorniki",
        hiddenProducts: "Ukryte produkty",
        historicalFormulas: "Wzory historyczne",
        lowerDeltaNumber: "NiÅ¼sza liczba delta dokÅadniejsze dopasowanie",
        machineError: "BÅÄd maszyny",
        machineIsBusy: "Maszyna jest zajÄta",
        machineNotConnected: "Maszyna nie jest podÅÄczona",
        manualColorantAddition: "RÄczne dodawanie barwnika",
        modifiedFormula: "FormuÅa zostaÅa zmodyfikowana",
        modifiedFormulaInLab: "Formula modified in laboratory",
        newColorAfterScaling: "New color after scaling",
        newRgbNotAccuratelyMeasured: "New RGB is not accurately measured, it is only indicative",
        noBaseAvailable: "No base is available",
        noBuildingSiteAvailable: "No building site info is available",
        noColorantForCorrection: "No additional colorants for correction selected",
        noColorants: "Bez barwnikÃ³w",
        noCustomer: "Brak klienta",
        noCustomers: "Brak dostÄpnych klientÃ³w",
        noDispenseNotesAvailable: "Brak notatek dotyczÄcych wydawania",
        noFormulaAvailable: "You have selected a combination with no formula!",
        noFormulaSelected: "Nie wybrano Å¼adnej formuÅy",
        noInternalNotesAvailable: "No internal notes are available",
        noNotesAvailable: "Brak dostÄpnych notatek",
        noPackageAvailable: "No package is available",
        noPackageSelected: "No package is selected",
        noProductAvailable: "No product is available",
        noResultsFound: "No results found",
        openLocalFile: "OtwÃ³rz z lokalnej bazy danych",
        openOnlineFile: "OtwÃ³rz z Internetu",
        order: "ZamÃ³wienie",
        orderingIsNotAvailable: "Zamawianie jest niedostÄpne",
        originalColor: "Original color",
        overAvailableLevel: "Ponad dostÄpny poziom",
        package: "Paczka",
        packageIsRequired: "Package is required",
        packaging: "Packaging",
        partialUpdateReload: "Partial updates may have affected this formula. Reload this tab to see an updated data.",
        printIsNotAvailable: "Wydruk jest niedostÄpny",
        productFiles: "Pliki produktÃ³w",
        productFilesViewer: "PrzeglÄdarka plikÃ³w produktÃ³w",
        productNotAvailable: "Product '%{productName}' is not available.",
        properties: "Properties",
        regularPrice: "Normalna cena",
        resetFormulaData: "Nowa formuÅa",
        rgbOnlyIndicative: "RGB only indicative!",
        saveAsCustom: "Zapisz jako",
        saveToStatsIsNotAvailable: "Zapisywanie historii jest niedostÄpne",
        searchForCheaper: "Szukaj taÅszej opcji",
        selectFromCompetitive: "You can select color from the competitive colors.",
        specialPrice: "Cena specjalna",
        specialPriceVip: "Specjalna cena VIP",
        splitFormula: "Podzielona formuÅa",
        withVAT: "z VAT",
        withoutVAT: "bez VAT"
    },
    marginSettings: {
        allBases: "Wszystkie zasady",
        allProducts: "Wszystkie produkty",
        editMargin: "Edytuj margines",
        marginAndDiscountWarning: "Musisz ustawiÄ opcjÄ kalkulacji ceny za korzystanie z marÅ¼ i rabatÃ³w.",
        marginSettings: "Ustawienia marginesÃ³w",
        marginsFor: "Marginesy dla",
        markupColorants: "Barwnik do znacznikÃ³w",
        sizeOfPackage: "Rozmiar paczki",
        valueBase: "Value base",
        valueColorant: "Value colorant"
    },
    matching: {
        actualColor: "Actual color",
        allCorrections: "All corrections",
        allTillItems: "All till the items",
        auto: "Auto",
        autoSelectAll: "Auto all",
        canStartCorrection: "Then you can start correction.",
        canStartMatching: "Then you can start matching.",
        cannotBeUsed: "Matching cannot be used.",
        changeProductAndColorants: "Try change product or colorants",
        checkConfig: "Please check the matching configuration.",
        colorCorrection: "Color correction",
        colorIsIndicative: "Color preview is only indicative.",
        colorNotAccurate: "Color may not be accurately displayed, it always depends on your monitor settings.",
        colorantInDispensedFormula: "Colorants in dispensed formula",
        confirmDispensing: "Confirm dispensing",
        connectionProblem: "Connection problem",
        correctionHistory: "Correction history",
        correctionRunning: "Correction is running",
        draftFormula: "Draft formula",
        exclude: "Exclude",
        excludeAll: "Exclude all",
        include: "Include",
        includeAll: "Include all",
        invalidProduct: "It is not possible to do the matching for product %{productName}",
        itemOnly: "Item only",
        manualColorCorrection: "Manual color correction",
        matchFormula: "Match formula",
        matchingInformation: "Matching information",
        matchingResult: "Matching result",
        matchingRunning: "Matching is running",
        matchingSearchOptions: "Matching search options",
        measurement: "Measurement",
        noCorrection: "No correction found",
        noSpectralCurveProvided:
            "The connected device cannot be used for matching because it doesn't provide spectral curve",
        notAvailableForMatching: "Not available for matching",
        originalFormula: "Original formula",
        reformulate: "Reformulate",
        reformulationRunning: "Reformulation is running",
        resultColor: "Result color",
        saveAsCustomFormula: "Save as custom formula",
        searchInProgress: "Search in progress, please wait",
        selectColorfile: "Please select colorfile.",
        selectRequiredItems: "Please select product, base, colorants and package.",
        selectedResult: "Selected result",
        spectralDataNotAvailable: "Spectral data is not available",
        startCorrection: "Start correction",
        startMatching: "Start matching",
        targetColor: "Target color",
        unsavedDraft: "Unsaved draft",
        unsavedDraftWarning: "Once you are satisfied with formula â do not forget to save your result.",
        usedForMatching: "Used for matching"
    },
    modal: {
        changeColorantUnit: "ZmieÅ jednostkÄ barwnika",
        payAttention: "Pay attention!"
    },
    module: {
        productGroups: "Product groups"
    },
    navigation: {
        globalSearch: {
            fandeckFilter: "Filtr Palet",
            formulasOverLimit: "OkoÅo %{count} wynikÃ³w. ProszÄ podaj wiÄcej znakÃ³w.",
            foundFormulas: "%{count} znalezionych formuÅ",
            help: "Pomoc:",
            helpText:
                "Wpisz np. '%{filter}' aby wyszukaÄ formuÅ zaczynajÄce siÄ od '%{formula}', produkt zaczynajÄcy siÄ z '%{product}' i paleta '%{fandeck}'.",
            productFilter: "Filtr produktu",
            searchInFormulas: "Szukaj w formuÅach",
            typeMore: "Wpisz wiÄcej znakÃ³w"
        },
        menu: {
            actionHistory: "Historia akcji",
            additionalFormulaTab: "Additional Formula Tab",
            advancedSettings: "Advanced Settings",
            autotaskSettings: "Ustawienia autozadania",
            availableDatabases: "Available Databases",
            availablePrices: "Available Prices",
            bugReport: "ZgÅoszenie bÅÄdu",
            canisterBarcodes: "Kody kreskowe kanistra",
            canisterDispensingLogic: "Dispensing Logic",
            canisterFilling: "NapeÅnianie kanistra",
            canisterSettings: "Ustawienia kanistra",
            clientServerSettings: "PoÅÄczenie klient / serwer",
            closing: "Closing",
            color: "Color",
            colorModification: "Color Modification",
            colorPanel: "Color Palette Settings",
            colorRepresentation: "Color Representation & Data",
            colorSearch: "Color Search",
            colorant: "Colorant",
            colorantConsumption: "Colorant Consumption",
            colorantPricing: "Ceny barwnikÃ³w",
            colorantRefillHistory: "Colorant Refill History",
            competitiveSearch: "Competitive Color Search",
            connections: "ZnajomoÅci",
            currency: "Ustawienia walut",
            customData: "Custom Data",
            database: "Database",
            databaseCheck: "Database Check",
            databaseConnection: "PoÅÄczenie z bazÄ danych",
            defaultValues: "Default Values",
            devices: "Devices",
            dispensingHistory: "Historia dozowania",
            dispensingSettings: "Dispensing Settings",
            driverSettings: "Ustawienia sterownika",
            environment: "Årodowisko",
            environmentConfiguration: "Ustawienia Årodowiska",
            environmentalSettings: "Environmental Settings",
            favorites: "Ulubione",
            fileTransfer: "DESO File Transfer",
            formatting: "Formatting",
            formula: "Formula",
            formulaData: "Dane",
            formulaModification: "Formula modification",
            formulaPanels: "Formula Panels",
            formulaSettings: "Ustawienia formuÅ",
            formulaUnit: "Formula unit",
            generalSearch: "General Search",
            globalSettingsSearch: "Global Settings Search",
            helpItems: "Ustawienia pomocy",
            importAndExport: "Import and export",
            importAndExportData: "Importuj dane niestandardowe",
            importCustomData: "ZaimportowaÄ dane",
            initialFormulaTab: "Initial Formula Tab",
            interfaceSettings: "Interface Settings",
            keyboardShortcuts: "SkrÃ³ty klawiszowe",
            language: "JÄzyk",
            languageSettings: "Language Settings",
            layout: "Layout",
            license: "Licencja",
            licenseData: "License Data",
            licenseIdentification: "License Identification",
            licenseStatus: "Status licencji",
            licenseSupplier: "License Supplier",
            licenseVersion: "License Version",
            localData: "Local Data",
            machine: "Informacje o maszynie",
            machineActions: "Akcje maszynowe",
            machineAndDevices: "Machine & Devices",
            machineManagement: "Machine Management",
            machineSettings: "Ustawienia maszyny",
            mainSettings: "Main Settings",
            maintenance: "Konserwacja",
            marginAndDiscount: "Margin and discount",
            matchingSearchResult: "Matching search result",
            matchingSettings: "Matching Settings",
            navigationItems: "Elementy nawigacyjne",
            newFormulaWindow: "FormuÅa",
            orderSearch: "ZamÃ³w wyszukiwanie",
            orderSettings: "Ordering Settings",
            packageSurcharge: "Package Surcharge",
            popUps: "Pop-Ups",
            posInfo: "Informacje o POS",
            price: "Ustawienia cen",
            priceManagement: "ZarzÄdzanie cenami",
            priceSettings: "Ustawienia cen",
            pricingOptions: "Pricing Options",
            printSettings: "Ustawienia drukowania",
            productPricing: "Cena produktu",
            qualityControlSettings: "Quality Control Settings",
            quickTint: "Szybki odcieÅ",
            rccConfig: "Ustawienia RCC",
            rccConnection: "PoÅÄczenie RCC",
            rccSettings: "Ustawienia RCC",
            refillSettings: "Refill Settings",
            refillingLogic: "Refilling Logic",
            registration: "Rejestracja",
            searchSettings: "Search Settings",
            serverPlugins: "Server Plugins",
            serviceActions: "Akcje serwisowe",
            settings: "Settings",
            simplifiers: "Simplifiers",
            singleActions: "Single Actions",
            smartPurgeRules: "Zasady inteligentnego oczyszczania",
            softwareOptions: "Software Options",
            spectroSettings: "Ustawienia Spectro",
            statistics: "Statystyka",
            switchToFrontdesk: "PrzejdÅº do Palety",
            switchToFullRedlike: "ZmieÅ do %{name}",
            switchToLight: "ZmieÅ do %{name}",
            switchToMachine: "PrzeÅÄcz na maszynÄ",
            tabs: "Tabs & Pop-Ups",
            testBarcodes: "Testowanie kodÃ³w kreskowych",
            updateOptions: "Opcje aktualizacji",
            userManagemenet: "User Management",
            visibleUnits: "Visible units"
        },
        navBar: {
            barcode: "kod kreskowy",
            help: "Wsparcie",
            hideItems: "Ukryj produkty / wzorniki"
        },
        notificationPanel: {
            noNotifications: "brak nowych powiadomieÅ"
        },
        tabBar: {
            closeActive: "Zamknij aktywne",
            closeAll: "Zamknij wszystko",
            closeAllExceptActive: "Zamknij wszystko oprÃ³cz aktywnych",
            customFormula: "Custom Formula",
            dispensingHistory: "Historia wydawania",
            favorites: "Ulubione",
            formulaSearch: "Formula search",
            rewriteSettings: "Re-write local settings"
        }
    },
    ordering: {
        assign: "PrzydzielaÄ",
        assignment: "Zadanie",
        createdDate: "Data utworzenia",
        finishDispensing: "ZakoÅcz wydawanie",
        foundInOrders: "Znaleziono w zamÃ³wieniach",
        inactiveDatabase: "Formula is from inactive or unknown database %{0}",
        inactiveUnknownDatabase: "Formula is from inactive or unknown database",
        newOrderReceived: "OtrzymaÅeÅ nowe zamÃ³wienie!",
        noOrderSelected: "Nie wybrano zamÃ³wienia",
        release: "Wydanie",
        status: {
            accepted: "przyjÄty",
            canceled: "anulowany",
            created: "Utworzony",
            done: "gotowy",
            partlyDone: "czÄÅciowo zrobione",
            preparing: "przygotowanie",
            unknown: "nieznany"
        }
    },
    partialUpdates: {
        applying: "Applying partial updates",
        cantBeUsedForYourDbVersion: "Updates can't be used for this database. Please update via Helper.",
        newVersionWillBeInstalled: "It will install the new version including all available partial updates.",
        noPartialUpdatesAvailable: "No partial updates available",
        outOfDate: "out of date!",
        partialUpdates: "Partial updates",
        partialUpdatesArePreparing: "Partial updates are preparing",
        partialUpdatesAvailable: "Partial updates available!",
        preparedUpdatesMessage: "The following partial updates are prepared to be applied",
        remindMeLater: "Remind me later (after %{time} minutes)",
        swOutOfDate: "The current version of the software is",
        updateAutomatically: "If you do not response, update will start automatically in: %{time} s",
        updateToNewVersion: "Update to the newest version",
        updateWillTakeMoreTime: "The update will take more time.",
        updatesApplied: "Partial updates were successfully applied.",
        updating: "Updating"
    },
    posInfo: {
        address: "Adres",
        contactName: "Nazwa Kontaktu",
        contactPerson: "Osoba kontaktowa",
        identification: "Identyfikacja",
        machineInformation: "Informacje o Maszyne",
        pos: "Punkt sprzedaÅ¼y",
        secondAddress: "Drugi adres",
        shopIdentification: "Identyfikacja sklepu",
        shopName: "Nazwa sklepu",
        url: "Url",
        zipCode: "Kod pocztowy"
    },
    priceTypeList: {
        priceBasePurchase: "Koszt wÅasny dla bazy",
        priceBaseSell: "Cena sprzedaÅ¼y za bazÄ",
        priceBaseSellFull: "Sell full price for base",
        priceCntPurchase: "Cena kosztowa barwnikÃ³w",
        priceCntPurchaseByColorantName: "Koszt wÅasny barwnika %{0}",
        priceCntPurchaseByName: "Koszt wÅasny barwnikÃ³w wedÅug nazwy",
        priceCntSell: "Cena sprzedaÅ¼y barwnikÃ³w",
        priceCntSellByColorantName: "Cena sprzedaÅ¼y za barwnik %{0}",
        priceCntSellByName: "Cena sprzedaÅ¼y barwnikÃ³w wedÅug nazwy",
        priceCntSellFull: "Sell full price for colorants",
        priceCntSellFullByColorantName: "Sell full price for %{0} colorant",
        priceCntSellFullByName: "Sell full price for colorants by name",
        priceGroupBarcode: "Grupa cenowa kod kreskowy",
        priceMarginAll: "MarÅ¼a na wszystkie paczki",
        priceMarginPerPkg: "Margines na jednÄ paczkÄ",
        priceSellPriceAll: "Cena sprzedaÅ¼y za wszystkie paczki",
        priceSellPricePerKg: "Cena sprzedaÅ¼y za kilogram",
        priceSellPricePerL: "Cena sprzedaÅ¼y za litr",
        priceSellPricePerPkg: "Cena sprzedaÅ¼y za jednÄ paczkÄ",
        priceSurchargeAll: "DopÅata za wszystkie paczki",
        priceSurchargePerPkg: "DopÅata za jednÄ paczkÄ",
        priceTintPurchaseAll: "Cena odcieÅ dla wszystkich paczek",
        priceTintPurchasePerPkg: "Cena kosztu za jeden pakiet",
        priceTintSellFullAll: "Tint sell full price for all packages",
        priceTintSellFullAllPerPackage: "Tint sell full price per package",
        priceTotalPurchaseAll: "Koszt caÅkowity wszystkich pakietÃ³w",
        priceTotalPurchasePerKg: "Koszt caÅkowity za kilogram",
        priceTotalPurchasePerL: "Koszt caÅkowity za litr",
        priceTotalPurchasePerPkg: "ÅÄczna cena za jeden pakiet",
        priceTotalSellFullAll: "Total sell full price for all packages",
        priceTotalSellFullPerKg: "Total sell full price per kilogram",
        priceTotalSellFullPerLiter: "Total sell full price per liter",
        priceTotalSellFullPerPackage: "Total sell full price per package"
    },
    pricing: {
        allBases: "Wszystkie zasady",
        allPackages: "Wszystkie paczki",
        backup: "Backup",
        basesOfProduct: "Bases of %{productName}",
        colorantPricing: "Ceny barwnikÃ³w",
        export: "Eksport",
        import: "Import",
        packagePricing: "Ceny pakietÃ³w",
        packageSurcharge: "DopÅata za pakiet",
        packages: "Pakiety",
        packagesOfProduct: "Packages of %{productName}",
        posCoeficient: "POS coeficient",
        priceGroupPricePerLiter: "Grupa cenowa cena za litr",
        priceGroups: "Grupy cenowe",
        pricePerLiter: "Cena za litr",
        productPricing: "Cena produktu",
        purchasePrice: "Cena zakupu",
        purchasePricePerLiter: "Cena zakupu za litr",
        sellPrice: "Sell price",
        surcharge: "DopÅata"
    },
    print: {
        adminRightsRequired: "Admin rights are required to edit or create a new template.",
        allowAutomaticPrint: "Zezwalaj na automatyczne drukowanie",
        allowPrintAfterDispensing: "ZezwÃ³l na druk po wydaniu",
        allowPrintBeforeDispensing: "PozwÃ³l na wydruk przed wydaniem",
        automaticPrint: "Drukuj automatycznie",
        choosePrinter: "Drukarka",
        chooseSettings: "Edytuj ustawienia",
        chooseTemplate: "Szablon",
        copies: "Copies",
        createTemplate: "Create template",
        createTemplateHint: "Create a new template from scratch. Save it to the templates folder and restart RCC.",
        defaultPrinter: "Drukarka",
        defaultSettings: "Default settings",
        defaultTemplate: "DomyÅlny szablon",
        editTemplate: "Edit template",
        editTemplateHint: "Edit %{name}. Changes will be visible after RCC restart.",
        noEditTemplate: "No template to edit",
        noPrinterSelected: "No printer is selected",
        noPrintersAvailable: "Brak dostÄpnych drukarek",
        noTemplateSelected: "No template is selected",
        noTemplatesAvailable: "Brak dostÄpnych szablonÃ³w",
        numberOfCopies: "Liczba kopii",
        openTemplateEditor: "OtwÃ³rz edytor szablonÃ³w",
        printAfterDispensing: "Wydrukuj po wydaniu",
        printAsImage: "VytlaÄiÅ¥ ako obrÃ¡zok",
        printBeforeDispensing: "Wydrukuj przed wydaniem",
        printOnRequest: "Wydruk na Å¼Ädanie",
        printOptions: "Print Options",
        printPagesAfterDispensing: "Liczba kopii po wydaniu puszki",
        printPagesBeforeDispensing: "Liczba kopii, ktÃ³re moÅ¼na wydaÄ",
        printPreview: "Print Preview",
        printSettings: "Ustawienia drukowania",
        printTaskLinkVariable: "Link to a variable",
        printVariable: "Print variable",
        printerName: "Nazwa drukarki",
        printerOptions: "Opcje drukarki",
        printerSettings: "Ustawienia drukarki",
        quickTintTemplate: "Å ablÃ³na rÃ½chleho tÃ³novania",
        setDefaultPrinter: "Ustaw domyÅlnÄ drukarkÄ",
        setDefaultTemplate: "Ustaw domyÅlny szablon",
        setQuickTintTemplate: "NastaviÅ¥ Å¡ablÃ³nu rÃ½chleho tÃ³novania",
        showPreviewDialogBeforePrint: "Show preview dialog before print",
        template: "Szablon",
        templateName: "Nazwa szablonu",
        templateSettings: "Template Settings"
    },
    printTemplate: {
        baseCode: "Kod podstawowy",
        baseName: "Nazwa podstawowa",
        bfs: "BFS",
        colorantType: "Colorant type",
        customerCity: "Miasto klienta",
        customerEmail: "Email klienta",
        customerName: "Nazwa klienta",
        customerPhone: "Telefon klienta",
        customerStreet: "Ulica klienta",
        customerZipCode: "Kod pocztowy klienta",
        destinationOfUse: "Destination of use",
        infoBfsGrade: "Klasa BFS",
        orderQrCode: "Kod QR",
        packageOrderCount: "Package order count",
        posAddress: "Adres POS",
        posAddressSecond: "Adres POS 2",
        posCity: "Miasto POS",
        posContact: "Kontakt do punktu sprzedaÅ¼y",
        posEmail: "E-mail POS",
        posPhone: "Telefon POS",
        posUrl: "Adres URL POS",
        posZipCode: "Kod pocztowy POS",
        priceBasePurchaseWithTax: "Cena podstawowa z VAT",
        priceBaseSellWithTax: "Cena sprzedaÅ¼y podstawy z VAT",
        priceCntPurchaseWithTax: "Cena kosztowa barwnikÃ³w z VAT",
        priceCntTotalSellWithTax: "Cena sprzedaÅ¼y barwnikÃ³w z VAT",
        priceMarginAllWithTax: "MarÅ¼a na wszystkie paczki z VAT",
        priceMarginPerPkgWithTax: "Margines na jednÄ paczkÄ z VAT",
        priceSellPriceAllWithTax: "Cena sprzedaÅ¼y wszystkich paczek z VAT",
        priceSellPricePerKgWithTax: "Cena sprzedaÅ¼y za kilogram z VAT",
        priceSellPricePerLWithTax: "Cena sprzedaÅ¼y za litr z VAT",
        priceSellPricePerPkgWithTax: "Cena sprzedaÅ¼y jednej paczki z VAT",
        priceSurchargeAllWithTax: "DopÅata za wszystkie paczki z VAT",
        priceSurchargePerPkgWithTax: "DopÅata za jednÄ paczkÄ z VAT",
        priceTintPurchaseAllWithTax: "Cena odcieÅ dla wszystkich paczek z VAT",
        priceTintPurchasePerPkgWithTax: "Cena odcieÅ za jednÄ paczkÄ z VAT",
        priceTotalPurchaseAllWithTax: "ÅÄczna cena za wszystkie paczki z VAT",
        priceTotalPurchasePerKgWithTax: "Koszt caÅkowity za kilogram z VAT",
        priceTotalPurchasePerLWithTax: "Koszt caÅkowity za litr z VAT",
        priceTotalPurchasePerPkgWithTax: "CaÅkowity koszt wÅasny jednej paczki z VAT",
        productAltName: "Produkt",
        recipeInline: "Przepis"
    },
    products: {
        bases: "Zasady",
        numberOfProducts: "Liczba produktÃ³w",
        packagesFor: "Pakiety dla",
        sizeOfPackage: "Rozmiar paczki"
    },
    purgeModal: {
        purgeAll: "OczyÅÄ wszystko",
        purgeAllChannels: "Purge all channels",
        purgeVolume: "OczyÅÄ objÄtoÅÄ",
        startPurge: "Rozpocznij czyszczenie"
    },
    qualityControl: {
        darker: "Darker",
        dispensedMeasuredFormula: "Dispensed (measured) formula",
        lighter: "Lighter",
        measureDispensedFormula: "Measure dispensed formula to calculate delta E",
        moreBlue: "More blue",
        moreGreen: "More green",
        moreRed: "More red",
        moreYellow: "More yellow",
        pleaseContinueToFormulaCorrection: "Please continue to formula correction",
        qualityControlFailed: "Quality control failed!",
        qualityControlPassed: "Quality control passed"
    },
    quickTint: {
        dispensingInProgress: "Dozowanie w toku",
        dispensingIsNotAvailable: "Dozowanie nie jest dostÄpne",
        machineNotConnected: "Maszyna nie jest podÅÄczona",
        noColorantsSelected: "Nie wybrano Å¼adnych barwnikÃ³w",
        noPrinterAvailable: "Print cannot be carried out as there is no printer available.",
        noTemplateAvailable: "Print cannot be carried out as there is no template available.",
        overMaxCanisterSize: "Co najmniej jedna iloÅÄ barwnika jest nieprawidÅowa"
    },
    quickTintSettings: {
        alphabetically: "Alfabetycznie",
        byCanister: "Kanister",
        closeAfterDispensing: "Zamknij po dozowaniu",
        closeBeforeDispensing: "Zamknij przed dozowaniem",
        quickTintSettings: "Szybkie ustawienia odcienia",
        sorting: "Sortowanie",
        windowClosingRules: "Zasady zamykania okien"
    },
    rccButtons: {
        abort: "anulowaÄ",
        all: "wszystko",
        cancel: "Anuluj",
        continue: "kontynuuj",
        help: "Wsparcie",
        ignore: "ignorowaÄ",
        no: "Nie",
        noToAll: "nie dla wszystkich",
        ok: "ok",
        postpone: "odraczaÄ",
        resume: "wznawianie",
        retry: "sprÃ³bowaÄ ponownie",
        skip: "pominÄÄ",
        yes: "tak",
        yesToAll: "tak do wszystkich"
    },
    rccDialog: {
        98: "Please Verify the %{0} base with the barcode.",
        99: "Please Insert base %{0} and confirm (click OK)",
        100: "Dozownik jest w stanie bÅÄdu, zresetowaÄ bÅÄdy?",
        101: "Dozownik jest w stanie bÅÄdu, nie moÅ¼na kontynuowaÄ",
        102: "Reset nieudany, nie moÅ¼na kontynuowaÄ",
        103: "FormuÅa zawiera nieprawidÅowy barwnik: %{0}",
        104: "FormuÅa zawiera nieprawidÅowe barwniki: %{0}",
        105: "Barwnik: %{0} jest poniÅ¼ej poziomu ostrzegawczego",
        106: "Barwniki: %{0} sÄ poniÅ¼ej poziomu ostrzegawczego",
        107: "Barwnik: %{0} jest poniÅ¼ej poziomu krytycznego",
        108: "Barwniki: %{0} sÄ poniÅ¼ej poziomu krytycznego",
        109: "UmieÅÄ puszkÄ",
        110: "UmieÅÄ puszkÄ z bazÄ: %{0} dla formuÅy: %{1}",
        111: "UsuÅ puszkÄ",
        112: "Przedziuraw puszkÄ",
        113: "Resetowanie bÅÄdÃ³w, proszÄ czekaÄ",
        114: "Poruszanie puszkÄ, proszÄ czekaÄ",
        115: "Dziurawienie puszki, proszÄ czekaÄ",
        116: "Dozowanie formuÅy %{0}, proszÄ czekaÄ | Opakowanie: %{1} z %{2} | Produkt: %{3}| Baza: %{4} | Rozmiar puszki: %{5}",
        117: "Dozowanie formuÅy %{0}, proszÄ czekaÄ | Opakowanie: %{1} z %{2} | Produkt: %{3}| Baza: %{4} | Rozmiar puszki: %{5}",
        118: "Dozowanie, proszÄ czekaÄ | Opakowanie: %{0} z %{1}",
        119: "Dozowanie, proszÄ czekaÄ | Opakowanie: %{0} z %{1}",
        120: "Anulowanie dozowania, proszÄ czekaÄ",
        121: "SprawdÅº poprawnoÅÄ kodu kreskowego",
        122: "SprawdÅº poprawnoÅÄ kodu kreskowego bazy | Produkt: %{0} | Baza: %{1} | Rozmar puszki: %{2}",
        123: "Proces dozowania zostaÅ anulowany, czy chcesz wznowiÄ dozowanie?",
        124: "WystÄpiÅ bÅÄd dozownika %{0} : %{1}. Czy chcesz wznowiÄ dozowanie?",
        125: "Upewnij siÄ, Å¼e poprzednio uÅ¼yta puszka jest umieszczona",
        126: "Upewnij siÄ, Å¼e uÅ¼ywasz ÅwieÅ¼ej puszki poniewaÅ¼ proces dozowania rozpocznie siÄ na nowo",
        127: "Colorant: %{0} is under minimal dispense amount. Do you want to continue despite this warning?",
        128: "Colorants: %{0} are under minimal dispense amount. Do you want to continue despite this warning?",
        129: "Selected formula breaks the overfill rule, total amount of colorants: %{0} %{1}, maximum allowed amounts of colorants: %{2} %{3}. Do you want to continue despite this warning?",
        130: "Dispenser is in error state, reset errors?",
        131: "Dispenser is in error state, cannot continue",
        132: "Reset failed, cannot continue",
        133: "Purge formula is empty, cannot continue",
        134: "Purge formula contains items that cannot be purged, do you want to continue?",
        135: "Place can for purge",
        136: "Remove can for purge",
        137: "Resetting errors, please wait",
        138: "Moving shelf, please wait",
        139: "Purging, please wait",
        140: "Purging, please wait",
        141: "Canceling purge, please wait",
        142: "Can for purge is missing, check that the can is properly placed",
        143: "Purge formula contains items that cannot be purged, do you want to continue?",
        144: "Place can for purge",
        145: "Preparing, please wait",
        146: "Finishing, please wait",
        150: "Cleaning, please wait",
        151: "Cleaning, please wait",
        152: "Canceling clean, please wait",
        160: "Recirculating, please wait",
        161: "Recirculating, please wait",
        162: "Canceling recirculation, please wait",
        170: "Stirring, please wait",
        171: "Stirring, please wait",
        172: "Canceling stir, please wait",
        180: "Initializing connection to the dispenser, please wait",
        181: "Connection to the dispenser cannot be established %{0}: %{1}",
        182: "Connection to the dispenser cannot be established. See log files for more info",
        183: "Dispenser is missing colorant: %{0} that is defined in your database",
        184: "Dispenser is missing colorants: %{0} that are defined in your database",
        185: "Closing connection to the dispenser, please wait",
        190: "Close the service window to continue",
        200: "Resetting, please wait",
        201: "Hard resetting, please wait",
        202: "Initializing, please wait",
        203: "Resetting errors, please wait",
        205: "Autocap opening, please wait",
        206: "Autocap closing, please wait",
        207: "Moving autocap, please wait",
        210: "Punching, please wait",
        211: "Plugging, please wait",
        215: "Moving shelf up, please wait",
        216: "Moving shelf down, please wait",
        217: "Moving shelf, please wait",
        220: "Moving table to refill position: %{0}, please wait",
        221: "Moving table to home, please wait",
        222: "Moving table, please wait",
        230: "Dispenser busy, please wait",
        240: "Please refill canister %{0}",
        241: "Please refill canister %{0}",
        242: "Positioning canister: %{0} (%{1}) to refill position",
        243: "Please refill canister %{0} using barcode",
        244: "Please refill canister %{0} using barcode",
        250: "Remove brush container, clean it and fill it with water according to the instructions",
        251: "Put back brush container",
        254: "Opening autocap",
        255: "Clean autocap according to the instructions",
        256: "Confirm when cleaning has finished and autocap is back in place",
        257: "Closing autocap",
        260: "Remove switch plate and clean it",
        261: "Put back switch plate",
        265: "Clean the machine with a cloth and remove all spilled colorant or other liquid",
        266: "Confirm when done",
        270: "Refill the humidifier water container and confirm when done",
        271: "Refill the humidifier water container and confirm when done",
        272: "Water level is still low, check it again",
        273: "Water level is still low, check it again",
        274: "Check the water level in humidifier container and refill if needed",
        275: "Please wait",
        280: "Rebooting computer",
        281: "Shutting down computer",
        300: "Base can missing, check that the can is placed properly",
        301: "Preparing, please wait",
        302: "Finishing, please wait",
        303: "Formula cannot be tinted as it contains colorant: %{0} which is over max dispense amount defined for canister",
        304: "Formula cannot be tinted as it contains colorants: %{0} which are over max dispense amounts defined for canisters",
        305: "Colorant: %{0} cannot be dispensed at once, do you want to split the formula?",
        306: "Colorants: %{0} cannot be dispensed at once, do you want to split the formula?",
        307: "Colorant: %{0} won't be dispensed by dispenser, do you want to continue and add it manually?",
        308: "Colorants: %{0} won't be dispensed by dispenser, do you want to continue and add them manually?",
        309: "Selected formula is empty, use base can as it is",
        310: "No colorant will be dispensed, prepare base can for manual colorant addition",
        311: "Remove base can and prepare it for manual colorant addition",
        312: "Add manually %{0} %{1} of colorant: %{2}, confirm when done",
        313: "Dispense manually formula",
        314: "Selected formula breaks the overfill rule, total amount of colorants: %{0} %{1}, maximum allowed amounts of colorants: %{2} %{3}. Do you want to continue despite this warning?",
        315: "Scan or type UFI code of base can",
        316: "Scan or type UFI code of base can|Product: %{0}|Base: %{1}|Can size: %{2}",
        317: "Prepare colorant: %{0} for manual addition, confirm when done",
        318: "Prepare colorants: %{0} for manual addition, confirm when done",
        319: "Add manually colorant: %{0}, confirm when done",
        320: "Add manually colorants: %{0}, confirm when done",
        400: "Automatic purge task will be started",
        401: "Automatic purge task will be started",
        405: "Brush container needs be maintained",
        406: "Brush container needs be maintained",
        410: "Automatic cap maintenance will be started",
        411: "Automatic cap maintenance will be started",
        415: "Switch plate has to be cleaned",
        416: "Switch plate has to be cleaned",
        420: "Dispenser has to be cleaned",
        421: "Dispenser has to be cleaned",
        425: "Refill of canisters will be started",
        426: "Refill of canisters will be started",
        430: "Computer reboot has been scheduled",
        431: "Computer reboot has been scheduled",
        435: "Computer shutdown has been scheduled",
        436: "Computer shutdown has been scheduled",
        440: "Dispenser cleaning has been scheduled",
        441: "Dispenser cleaning has been scheduled",
        445: "Dispenser recirculation has been scheduled",
        446: "Dispenser recirculation has been scheduled",
        450: "Dispenser stirring has been scheduled",
        451: "Dispenser stirring has been scheduled",
        990: "Dispenser error occurred %{0} : %{1}. Do you want to retry the task?",
        991: "Internal error occurred: %{0}",
        200000001: "Place can",
        200000002: "Remove can",
        200000003: "Amount for '%{0}' below minimum dispense amount, continue at own risk?",
        200000004: "Refill '%{0}'"
    },
    rccDriverSettings: {
        databasePath: "Database path",
        dispenser: "Dispenser",
        dispenserConfigurationFile: "Dispenser config file",
        driverPath: "Driver path",
        extensionPath: "Extension path",
        folder: "Folder",
        formulaPath: "Formula path",
        host: "Host",
        iddPath: "IDD configuration file",
        italtintoPath: "Italtinto configuration path",
        lldPath: "LLD path",
        machineType: "Machine type",
        noMachineAvailable: "No machine is available",
        protocolVersion: "Protocol version",
        rccDriverSettings: "Driver settings",
        resultPath: "Result path",
        save: "Save settings",
        saveSettingsWarning: "Warning! Changes in this section could cause malfunction of the dispenser.",
        serviceSwPath: "Service Software path",
        simulationPath: "Simulation path"
    },
    rccMachineSettings: {
        allowManualColorantAddition: "Allow manual colorant addition",
        ask: "Ask",
        canHandlingOptions: "Can handling options",
        checkCanBeforeDispense: "Check can before dispensing",
        checkOverfill: "Check overfill",
        colorantBatchNumbers: "Colorant batch numbers",
        colorantPackageValidation: "Colorant package validation only",
        disable: "Disable",
        dispenseInvalidColorants: "Dispense invalid colorants",
        dispensingOptions: "Dispensing options",
        enable: "Enable",
        enableUserIdentification: "User identification",
        fullValidation: "Full validation",
        machineAccuracyWarning: "Machine accuracy warning",
        machineOptions: "Machine options",
        machineUnit: "Machine unit",
        minimalDispenseAmount: "Minimal dispense amount",
        placeCanSensor: "Place can sensor",
        placeCanSensorDelay: "Place can sensor delay",
        rccMachineSettings: "Machine settings",
        refillBarcodeValidation: "Refill barcode validation",
        refillBarcodeValidationCanisterAndColorant: "Validate Canister and Colorant package",
        refillBarcodeValidationColorant: "Validate only colorant package",
        refillSettings: "Refill settings",
        removeCanSensor: "Remove can sensor",
        removeCanSensorDelay: "Remove can sensor delay",
        save: "Save settings",
        sec: "sec.",
        skipPlaceCanDialog: "Skip place can dialog",
        skipRemoveCanDialog: "Skip remove can dialog",
        splitFormula: "Split formula",
        tmcEnabled: "Enable TMC",
        ufiCode: "UFI code",
        validateBarcodeBaseCan: "Base can barcode validation",
        validateBarcodeRefill: "Refill barcode validation",
        validateColorantsDuringInit: "Validate colorants during init"
    },
    rccPanel: {
        actionsRunningOnDispenser: "There are some actions running on the machine",
        addLevel: "ADD LEVEL",
        addManually: "Add manually",
        barcodeNotSet: "Canister %{colorantName} (%{canisterName}) has no barcode assigned.",
        cancel: "CANCEL",
        dispenseFormula: "Dispense formula",
        dispenserIdle: "The machine is idle",
        dispenserIsBusy: "Machine is busy",
        dispenserIsIdle: "Machine is idle",
        dispenserIsReady: "The machine is ready for further tasks",
        dispensingFormula: "Dozowanie formuÅy",
        errorCode: "Error code",
        explanation: "Explanation",
        fillToMax: "Fill to max",
        finished: "Finished",
        inProgress: "In progress",
        machineIsReady: "Machine is ready",
        moveToFill: "Move to fill",
        noMachineDialog: "No machine is connected",
        of: "of",
        packageSize: "Package size",
        placeBaseCan: "Place base can",
        pleaseCheckYourMachineConnection: "Please check your machine connection.",
        pleaseRefill: "Please refill",
        solution: "RozwiÄzanie",
        subErrors: "Sub errors",
        timeToEnd: "Time to end",
        tintingFormula: "Tinting formula",
        tintingPleaseWait: "Tinting, please wait",
        validateBaseCan: "Validate base can",
        waiting: "Waiting"
    },
    rccSettigns: {
        rccSettigns: "RCC connection",
        rccUrl: "RCC url"
    },
    rccSpectroDialog: {
        100: "Connecting to your device over Bluetooth. Make sure you have Bluetooth enabled and your instrument is powered on.",
        101: "Instrument has not been detected. Do you want to retry?",
        110: "Make sure Nano is connected and press instrument button to start initialization",
        111: "Nano has not been detected. Do you want to retry?",
        112: "Disconnect Nano, wait 10 seconds, connect it again and continue",
        120: "Connecting to your device, please wait",
        121: "Instrument hasn't been detected. Do you want to retry?",
        200: "Place the instrument on black tile and continue or press instrument button",
        201: "Place the instrument on black tile and continue",
        202: "Place the instrument on black tile and press instrument button",
        205: "Place the instrument on white tile and continue or press instrument button",
        206: "Place the instrument on white tile and continue",
        207: "Place the instrument on white tile and press instrument button",
        210: "Place the instrument on diagnostic tile and continue or press instrument button",
        211: "Place the instrument on diagnostic tile and continue",
        212: "Place the instrument on diagnostic tile and press instrument button",
        215: "Close the instrument cover and continue or press instrument button",
        216: "Close the instrument cover and continue",
        217: "Close the instrument cover and press instrument button",
        220: "Place the instrument on zero tile and continue or press instrument button",
        221: "Place the instrument on zero tile and continue",
        222: "Place the instrument on zero tile and press instrument button",
        224: "Place the instrument on calibration pad and continue or press instrument button",
        225: "Place the instrument on calibration pad and continue",
        226: "Place the instrument on calibration pad and press instrument button",
        227: "Place the instrument on calibration pad and press instrument button",
        295: "Finish calibration in driver window",
        296: "UrzÄdzenie nie jest podÅÄczone, czy chcesz otworzyÄ z nim poÅÄczenie?",
        297: "Preparing for calibration step, please wait",
        298: "Calibrating, please wait",
        299: "Finishing calibration step, please wait",
        300: "Place the instrument on sample and continue or press instrument button",
        301: "Place the instrument on sample and continue",
        302: "Place the instrument on sample and press instrument button",
        303: "UrzÄdzenie nie jest skalibrowane, czy chcesz kontynuowaÄ kalibracjÄ?",
        304: "UrzÄdzenie nie jest podÅÄczone, czy chcesz otworzyÄ z nim poÅÄczenie?",
        390: "Select measure mode",
        395: "Finish measuring in driver window",
        397: "Preparing for measuring, please wait",
        398: "Measuring, please wait",
        399: "Finishing measuring, please wait",
        498: "Downloading measurement, please wait",
        499: "Downloading all measurements, please wait",
        900: "Instrument error occurred %{0} : %{1}. Do you want to retry the task?",
        901: "Internal error occurred: %{0}"
    },
    rccSpectroSettings: {
        DatacolorColorReader:
            "The computer has to have Bluetooth connection. The spectro has to be paired with the computer. Windows 10 with 2018 automn update required.",
        DatacolorSilent:
            "When using Silent mode, Datacolor windows are shown directly in %{name}. In these windows, spectro parameters cannot be changed.",
        DatacolorUseDiagnosticTile: "Using diagnostic tile improves the measurement quality.",
        comPort: "Com Port",
        diagnosticTile: "Datacolor use diagnostic tile",
        measureModes: "Measure modes",
        measureModesOrder: "Measure modes order",
        model: "Model",
        noSpectroAvailable: "No spectro is available",
        rccSpectroSettings: "Spectro settings",
        save: "Save settings",
        silent: "Datacolor Silent",
        simulationPath: "Simulation path",
        spectroType: "Spectro type",
        useProfiledValues: "Use profiled values"
    },
    recirculateChannels: {
        recirculateAllChannels: "Recirculate All Channels",
        recirculateChannels: "Recirculate Channels",
        recirculatingSpeed: "Recirculating speed",
        recirculatingTime: "Recirculating time",
        startRecirculating: "Start recirculating"
    },
    redlikeLight: {
        finishPreviousSteps: "Please finish previous steps",
        searchBySpectro: "Search by spectro",
        searchFormula: "Search formula",
        selectBase: "Select base",
        selectColor: "Select color",
        selectCustomer: "Select customer",
        selectFandeck: "Select fandeck",
        selectPackage: "Select package",
        selectProduct: "Select product",
        startSelectFandeck: "Start by selecting fandeck",
        startSelectProduct: "Start by selecting product",
        stepByStepProgress: "You can progress step by step",
        typeHereToSearch: "Type here to search",
        typeToFilter: "Type to filter"
    },
    restartModal: {
        computerNeedsRestart: "Computer needs restart!",
        notCompletelyTranslated:
            "Language change requires software restart. Some parts of the software may not be translated completely at this time.",
        restartIsRequired: "Po wprowadzeniu zmian wymagane jest ponowne uruchomienie oprogramowania.",
        softwareNeedsRestart: "%{name} Needs Restart!"
    },
    searchPanel: {
        basePlaceholder: "lub wpisz nazwÄ podstawowÄ",
        baseStartPlaceholder: "Zacznij od wpisania nazwy podstawowej",
        colorCodeNamePlaceholder: "lub wpisz kod/nazwÄ formuÅy",
        colorCodeNameStartPlaceholder: "Zacznij od wpisania kodu/nazwy formuÅy",
        colorCodePlaceholder: "lub wpisz kod formuÅy",
        colorCodeStartPlaceholder: "Zacznij od wpisania kodu formuÅy",
        colorNameCodePlaceholder: "lub wpisz nazwÄ/kod formuÅy",
        colorNameCodeStartPlaceholder: "Zacznij od wpisania nazwy/kodu formuÅy",
        colorNamePlaceholder: "lub wpisz nazwÄ formuÅy",
        colorNameStartPlaceholder: "Zacznij od wpisania nazwy formuÅy",
        colorPreviewIsNotAvailable: "Color preview is not available. Select a fandeck to see relevant color preview.",
        fandeckPlaceholder: "lub wpisz nazwÄ wzornika kolorÃ³w",
        fandeckStartPlaceholder: "Zacznij od wpisania nazwy wzornika kolorÃ³w",
        formulaByColor: "FormuÅa wedÅug koloru",
        noResultsFound: "Nie znaleziono wynikÃ³w",
        packagePlaceholder: "lub wpisz nazwÄ paczki",
        packageStartPlaceholder: "Zacznij od wpisania nazwy paczki",
        productPlaceholder: "lub wpisz nazwÄ produktu",
        productStartPlaceholder: "Zacznij od wpisania nazwy produktu",
        standard: "Standard",
        typeFandeckToFilter: "Wpisz tutaj, aby filtrowaÄ wedÅug nazwy wzornika kolorÃ³w",
        typeProductToFilter: "Wpisz tutaj, aby filtrowaÄ wedÅug nazwy produktu"
    },
    sendOrderModal: {
        customNote: "Custom note",
        noCompatibleServers: "No compatible servers are available in your network",
        orderOverview: "Order overview",
        selectTargetMachine: "Select the target machine",
        sendOrder: "Send order",
        sendOrderTo: "Your order will be sent to %{serverName}",
        targetMachine: "Target machine"
    },
    server: {
        computerId: "Computer ID",
        ip: "IP",
        selectServer: "Please select one of the available servers",
        server: "Server"
    },
    serverDialog: {
        1: "There is an error in the brand definition for your license. Please check with your provider.",
        2: "Could not process data for %{0}: %{1}",
        3: "Invalid network path.",
        4: "Invalid path type (only %{0} and %{1} types are supported)",
        5: "Error writing tinting file.",
        6: "Tinting file was created successfully.",
        7: "Could not find colorant with name: '%{0}' on row '%{1}'",
        8: "Could not find package with name: '%{0}' on row '%{1}'",
        9: "Could not find base in product with product name: '%{0}' and base name: '%{1}' on row '%{2}'",
        10: "Could not find base in product package with product name: '%{0}', base name: '%{1}' and package name: '%{2}' on row '%{3}'",
        11: "Could not parse price value: '%{0}' on row '%{1}' in sheet '%{2}'",
        12: "Preparing bases data, please wait",
        13: "Preparing bases in products data, please wait",
        14: "Preparing base packages data, please wait",
        15: "Preparing colors data, please wait",
        16: "Preparing colors in fandecks data, please wait",
        17: "Preparing fandecks data, please wait",
        18: "Preparing data for global search, please wait",
        19: "Preparing products data, please wait",
        30: "Partial updates can't be applied on database '%{0}'. Update your software to the latest version. Minimal required version is '%{1}'.",
        31: "Partial updates can't be applied on database '%{0}'. Database versions doesn't match. Contact your technical support.",
        32: "Partial updates can't be applied on database '%{0}'. Database structure version doesn't match. Contact your technical support.",
        33: "Partial updates can't be applied on database '%{0}'. The update is corrupted. Contact your technical support.",
        34: "Unknown error occurred during partial update. If this error repeats contact your technical support.",
        35: "No partial updates available. Please check your internet connection or contact your technical support.",
        36: "Prepared partial updates for database '%{0}' are for newer version of Redlike. Update your Redlike to the latest version. Minimal required version is '%{1}'.",
        37: "Partial updates can't be prepared. There is not enough space on the drive. Minimal required space is 20 GB.",
        38: "Partial updates can't be applied on database '%{0}'. The update is invalid. Contact your technical support.",
        39: "Partial updates can't be applied on database '%{0}'. The update can't be downloaded. Contact your technical support.",
        40: "Partial updates can't be applied on database '%{0}'. Downloaded file is corrupted. Contact your technical support."
    },
    serverPlugins: {
        activeServerPlugins: "Active server plugins",
        currentlyActive: "The currently active plugins",
        plugin: "Plugin",
        pluginName: "Plugin name",
        statusActive: "Active",
        statusInactive: "Unactive"
    },
    serviceActionsSettings: {
        canisterLevel: "Canister levels",
        capClose: "Close",
        capMiddle: "Middle",
        capOpen: "Open",
        cleanAllChannels: "Clean all",
        cleanChannels: "Clean channels",
        computer: "Computer",
        computerReboot: "Computer reboot",
        computerShutdown: "Computer shutdown",
        connectMachine: "Connect machine",
        general: "General",
        initialize: "Initialize",
        noMachineIsConnected: "No machine is connected",
        plug: "Plug",
        plugger: "Plugger",
        punch: "Punch",
        puncher: "Puncher",
        purgeChannels: "Purge channels",
        recirculate: "Recirculate",
        recirculateAllChannels: "Recirculate all",
        recirculateChannels: "Recirculate channels",
        serviceActions: "Service actions",
        setCanisterLevel: "Set canister level",
        shelfDown: "Shelf down",
        shelfUp: "Shelf up",
        showServiceWindow: "Show service window",
        smartPurgeAllChannels: "Smart purge all channels",
        smartPurgeChannels: "Smart purge channels",
        startErrorReset: "Start error reset",
        startHardReset: "Start hard reset",
        startReset: "Start reset",
        stirAllCanisters: "Stir all canisters",
        stirCanisters: "Stir canisters",
        stirCanistersMore: "Stir canisters"
    },
    spectroMode: {
        eggshell: "Skorupka jajka (Eggshell)",
        flat: "Flat",
        gloss: "Gloss",
        matt: "Mat",
        matte: "Matte",
        pearl: "Pearl",
        satin: "Satin",
        selectGlossLevel: "Compare the color sample to the gloss scale and select gloss level",
        semiGloss: "Semi-Gloss"
    },
    spectroTab: {
        bestMatch: "The best match",
        calibrate: "Calibrate",
        calibrateInstrument: "Calibrate instrument",
        connectDevice: "Connect device",
        connectedTo: "Connected to",
        connectingDevice: "Connecting your device",
        deselectAll: "Deselect all",
        deviceCalibrated: "Your device has been calibrated and you can start measuring",
        deviceIsNotCalibrated: "Your device is not calibrated",
        eraseResult: "Erase result",
        filter: "Filter",
        foundInFormulas: "Found in formulas",
        inactiveSpectro: "The Spectro function is inactive for selected brand.",
        instrumentCalibration: "Your instrument needs to be calibrated.",
        manualInput: "Manual input",
        measure: "Measure",
        measurementResult: "Measurement result",
        noFilters: "No filters available",
        noFormulas: "No formulas found",
        noSelectedSpectro: "No spectro is selected",
        notSelected: "Nie zaznaczone",
        pressConnectButton: "Upewnij siÄ, Å¼e urzÄdzenie jest podÅÄczone i naciÅnij przycisk ÅÄczenia",
        searchFormulas: "Wyszukaj formuÅy",
        selectSpectro: "Wybierz spectro",
        showDetails: "PokaÅ¼ szczegÃ³Åy",
        skipCalibration: "Skip calibration",
        spectroIsConnected: "Spektrofotometr jest poÅaczony",
        spectroIsReady: "Spektrofotometr jest gotowy",
        spectroReady: "UrzÄdzenie jest gotowe do dalszych zadaÅ",
        startCalibrateNow: "Start calibrate now",
        startMeasureText: "Twoje urzÄdzenie zostaÅo skalibrowane i moÅ¼esz rozpoczÄÄ pomiar",
        tolerance: "Delta E (CIE 2000)",
        toleranceOfDevitation: "tolerancja Delta E (CIE 2000)"
    },
    statisticsTab: {
        allRecords: "All records",
        customPackageName: "Niestandardowy %{1} %{2} ",
        deleteSelectedRecords: "UsuÅ wybrane wpisy",
        exportHistory: "Eksportuj historiÄ",
        finishFormula: "ZakoÅcz formuÅÄ ",
        foundInFormulas: "Znalezione w formuÅach ",
        hideHiddenRecords: "Nie pokazuj ukrytych wpisÃ³w",
        hideSelectedRecord: "Ukryj wybrany wpis",
        historicalFormula: "Historical formula",
        onlyFiltered: "Only filtered",
        restoreSelectedRecord: "PrzywrÃ³Ä wybrany wpis",
        showAllRecords: "PokaÅ¼ wszystkie wpisy",
        standardFormula: "Standard formula",
        unknownFormula: "Unknown formula"
    },
    stirCanisters: {
        selectCanisters: "Zaznacz kanistry",
        startStirring: "Zacznij mieszanie",
        stirAllCanisters: "Wymieszaj wszystkie kanistry",
        stirCanisters: "Wymieszaj kanistry",
        stirringSpeed: "SzybkoÅÄ mieszania",
        stirringTime: "Czas mieszania"
    },
    stock: {
        addColorant: "Add colorant...",
        addColorantPackagesToStock: "Add colorant packages to stock",
        addPackagesToStock: "Add packages to stock",
        addedToStock: "Added to stock",
        allDatabases: "All databases",
        checkStockPackageInventory: "If you used package from stock, please check if your stock inventory is valid.",
        clearAllItems: "Clear all items",
        colorantInventory: "Colorant inventory",
        colorantsStockInventory: "Colorants stock inventory",
        confirmSendingOrder: "Confirm sending order",
        consumptionPrediction: "Consumption prediction for the next %{weeks} weeks",
        createOrder: "Create order (%{sum})",
        expirationDate: "Expiration date",
        inDelivery: "In delivery",
        manualOrder: "Manual order",
        manualOrderProgress: "Step %{step}/%{total}",
        noPackagesFoundInStockForColorant: "There are no packages in stock for this colorant.",
        onStock: "In stock",
        orderSummary: "Order summary",
        prediction: "Prediction",
        removePackageFromStock: "Remove %{colorantName} package from stock",
        removePackageNameFromStock: "Would you like to remove one %{packageName} package from stock?",
        scanBarcodeOrSelectColorant: "Scan barcode from package or select colorant",
        selectPackageToRemove: "Select package to remove",
        sendConfirmed: "Send confirmed",
        setAmountsByPrediction: "Set amounts by prediction",
        sortByColorantName: "Sort by colorant name",
        sortByOrderNeed: "Sort by need to order",
        sortByStockLevel: "Sort by stock level",
        toOrder: "To order"
    },
    testBarcode: {
        noItemAssigned: "Å»aden element nie jest przypisany do kodu kreskowego %{code} ",
        pleaseScanBarcode: "ProszÄ zeskanowaÄ kod kreskowy bazy, produktu, opakowania lub innych przedmiotÃ³w",
        testBarcodes: "Testuj kody kreskowe "
    },
    ticketing: {
        answer: "Answer",
        answered: "Answered",
        chooseType: "Choose type",
        closeRequest: "Close request",
        comment: "Comment",
        create: "Create",
        createNewTicket: "Create new ticket",
        formulaAttached: "The requested formula is attached to the answer. Click the %{loadFormula} button to open it.",
        formulaClaim: "Formula claim",
        formulaRequest: "Formula request",
        formulaUnrealizable: "The requested formula is unrealizable.",
        newTicket: "New ticket",
        noPosInfoFound: "POS information (name, city) not found",
        noTicketSelected: "No ticket selected",
        openTicket: "Open ticket",
        posName: "POS name",
        posted: "Posted",
        request: "Request",
        requestDate: "Request date",
        requestId: "Request ID",
        resolvedBy: "Resolved by",
        responseDate: "Response date",
        saveToCustomFormula: "Save to custom formula",
        sending: "Sending",
        service: "Service",
        successfulCreation: "Ticket successfully created. Sending...",
        ticketAnswered: "A ticket has been answered.",
        ticketDelivered: "A ticket has been delivered.",
        ticketId: "Ticket ID",
        ticketType: "Ticket type",
        waitingForAnswer: "Waiting for answer"
    },
    tutorial: {
        last: "Ostani",
        next: "Dalej"
    },
    ufiCodeModal: {
        currentStatus: "Aktualny stan",
        detailedInfoForColorant: "SzczegÃ³Åowe informacje o barwniku %{colorantName}",
        userSetUfiCode: "Ustawiony przez uÅ¼ytkownika kod UFI, aktualna wartoÅÄ"
    },
    ufiCodeSettings: {
        baseUfiCodeValidation: "Walidacja podstawowego kodu UFI",
        confirmColorantRefilling: "PotwierdÅº uzupeÅnienie kolorantu",
        enableUfiCodes: "WÅÄcz kody UFI",
        printUfiCode: "Wydrukuj, jeÅli iloÅÄ kolorantu przekracza ",
        printUfiCodePercentage: "Drukuj procent, jeÅli iloÅÄ barwnika przekracza ",
        scanOrTypeUfiCode: "Zeskanuj lub wpisz kod UFI",
        scanOrTypeUfiCodeOfBase: "Zeskanuj lub wpisz kod UFI puszki z bazÄ",
        ufiCodesByPercentage: "UÅ¼yj kodÃ³w UFI w procentach",
        ufiCodesFromDatabase: "UÅ¼yj kodÃ³w UFI z bazy danych",
        ufiCodesFromLastFilling: "UÅ¼yj kodÃ³w UFI z ostatniego wypeÅnienia"
    },
    userSettings: {
        addUser: "Dodaj uÅ¼ytkownika",
        assignedUserGroups: "Przypisane grupy uÅ¼ytkownikÃ³w",
        availableUserGroups: "DostÄpne grupy uÅ¼ytkownikÃ³w",
        barcode: "Kod kreskowy",
        confirmNewPassword: "PotwierdÅº hasÅo",
        editPassword: "Edytuj hasÅo",
        editUser: "Edytuj uÅ¼ytkownika",
        enableAutoLogin: "WÅÄcz auto logowanie",
        newPassword: "Nowe hasÅo",
        noChange: "Nie ma zmian do zapisania",
        oldPassword: "Stare hasÅo",
        password: "HasÅo",
        passwordsDoNotMatch: "HasÅa nie pasujÄ do siebie",
        restoreUser: "Ten uÅ¼ytkownik zostaÅ usuniÄty. Chcesz go przywrÃ³ciÄ?",
        userGroup: "User Group",
        userGroups: "Grupy uÅ¼ytkownikÃ³w",
        userManagement: "ZarzÄdzanie uÅ¼ytkownikami ",
        userSettings: "Ustawienia uÅ¼ytkownika",
        username: "UÅ¼ytkownik",
        usernameIsMissing: "Brak nazwy uÅ¼ytkownika."
    },
    warningMissingDataModal: {
        continue: "Same data is missing, do you want continue?",
        notFoundBase:
            "This product base is not available. Confirm and be careful to get compatible product base from shelf or cancel this order.",
        notFoundProduct:
            "This product is not available. Confirm and be careful to get compatible product from shelf or cancel this order."
    },
    weekdays: {
        friday: "PiÄtek",
        monday: "PoniedziaÅek",
        saturday: "Sobota",
        sunday: "Niedziela",
        thursday: "Czwartek",
        tuesday: "Wtorek",
        wednesday: "Åroda"
    },
    welcome: {
        availableDatabase: "Serwer nie moÅ¼e poÅÄczyÄ siÄ z bazÄ danych. SprawdÅº konfiguracjÄ bazy danych.",
        availableDatabaseLocalError:
            "BÅÄd podczas ÅÄczenia siÄ z lokalnej bazy danych (niewÅaÅciwy plik, nieprawidÅowe hasÅo)",
        availableDatabaseLocalMissing: "Brak pliku lokalnej bazy danych ",
        availableDatabaseLocalUpdate: "Lokalna baza danych musi zostaÄ zaktualizowana do nowszej wersji ",
        availableDatabaseMainAndLocalError:
            "BÅÄd podczas ÅÄczenia z gÅÃ³wnÄ i lokalnÄ bazÄ danych  (niewÅaÅciwy plik, nieprawidÅowe hasÅo)",
        availableDatabaseMainAndLocalMissing: "Brakuje plikÃ³w gÅÃ³wnej oraz lokalnej bazy danych ",
        availableDatabaseMainAndLocalUpdate:
            "GÅÃ³wna oraz lokalna baza danych muszÄ zostaÄ zaktualizowane do nowszej wersji",
        availableDatabaseMainError:
            "BÅÄd podczas ÅÄczenia z gÅÃ³wnÄ bazÄ danych  (niewÅaÅciwy plik, nieprawidÅowe hasÅo)",
        availableDatabaseMainMissing: "Brak pliku gÅÃ³wnej bazy danych",
        availableDatabaseMainPartialUpdate: "Main database needs to be updated to the newer version via partial update",
        availableDatabaseMainPartialUpdateAndLocalUpdate:
            "Main database needs to be updated to the newer version via partial update and local database needs to be updated to the newer version",
        availableDatabaseMainUpdate: "GÅÃ³wna baza danych musi zostaÄ zaktualizowana do nowszej wersji",
        closing: "Program siÄ zamyka",
        compatibility: "SprawdÅº wersjÄ swojego serwera. TwÃ³j klient jest zgodny tylko z serwerem %{0} lub nowszym. ",
        compatibilityCheck: "Trwa sprawdzanie zgodnoÅci ",
        compatibilityDatabase: "Twoja baza danych nie jest kompatybilna z serwerem. SprawdÅº konfiguracjÄ bazy danych.",
        connectingServer: "ÅÄczenie z serwerem na %{ip} ",
        databaseCompatibility: "Twoja baza danych nie jest kompatybilna z aktualnÄ wersjÄ programu",
        databasesCompatibility: "Twoje bazy danych nie sÄ kompatybilne z bieÅ¼ÄcÄ wersjÄ oprogramowania ",
        licenseVerification: "Trwa weryfikacja licencji ",
        loading: "Åadowanie",
        lostConnection: "PoÅÄczenie z serwerem zostaÅo utracone",
        moduleMessage:
            "ZwrÃ³Ä uwagÄ na wybÃ³r moduÅu, poniewaÅ¼ przyszÅa zmiana moduÅu bÄdzie dostÄpna tylko dla uprzywilejowanych uÅ¼ytkownikÃ³w. ",
        refresh: "OdÅwieÅ¼",
        restoring: "Przywracam poÅÄczenie",
        selectModule: "ProszÄ zaznaczyÄ jeden z dostÄpnych moduÅÃ³w",
        stopUpdate: "Zatrzymaj aktualizacjÄ",
        updateDatabase: "Uaktualnij bazÄ danych",
        updatingDatabase: "Baza danych jest aktualizowana",
        updatingDatabases: "Bazy danych sÄ aktualizowane",
        updatingWarning: "Trwa aktualizacja struktury bazy danych do najnowszej wersji, proszÄ czekaÄ.",
        updatingWarningInfo: "Nie zamykaj tego okna, gdyÅ¼ spowodowaÅoby to koniecznoÅÄ wykonania aktualizacji od nowa."
    }
};
